/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 10);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/** Make a node */
exports.mk = function mk(e) {
  return document.createElement(e);
};

/** Find one by query */
exports.qs = function qs(s) {
  return document.querySelector(s);
};

/** Find all by query */
exports.qsa = function qsa(s) {
  return document.querySelectorAll(s);
};

/**
 * Filter 'spacebar' and 'return' from keypress handler,
 * and when they're pressed, fire the callback.
 * use $(...).on('keypress', cr(handler))
 */
exports.cr = function cr(hdl) {
  return function (e) {
    if (e.which === 10 || e.which === 13 || e.which === 32) {
      hdl.call(this, e);
    }
  };
};

/** Decode number from 2B encoding */
exports.parse2B = function parse2B(s) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  return s.charCodeAt(i++) - 1 + (s.charCodeAt(i) - 1) * 127;
};

/** Decode number from 3B encoding */
exports.parse3B = function parse3B(s) {
  var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  return s.charCodeAt(i) - 1 + (s.charCodeAt(i + 1) - 1) * 127 + (s.charCodeAt(i + 2) - 1) * 127 * 127;
};

/** Encode using 2B encoding, returns string. */
exports.encode2B = function encode2B(n) {
  var lsb = void 0,
      msb = void 0;
  lsb = n % 127;
  n = (n - lsb) / 127;
  lsb += 1;
  msb = n + 1;
  return String.fromCharCode(lsb) + String.fromCharCode(msb);
};

/** Encode using 3B encoding, returns string. */
exports.encode3B = function encode3B(n) {
  var lsb = void 0,
      msb = void 0,
      xsb = void 0;
  lsb = n % 127;
  n = (n - lsb) / 127;
  lsb += 1;
  msb = n % 127;
  n = (n - msb) / 127;
  msb += 1;
  xsb = n + 1;
  return String.fromCharCode(lsb) + String.fromCharCode(msb) + String.fromCharCode(xsb);
};

/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*!chibi 3.0.7, Copyright 2012-2016 Kyle Barrow, released under MIT license */

// MODIFIED VERSION.
(function () {
	'use strict';

	var readyfn = [],
	    loadedfn = [],
	    domready = false,
	    pageloaded = false,
	    d = document,
	    w = window;

	// Fire any function calls on ready event
	function fireReady() {
		var i;
		domready = true;
		for (i = 0; i < readyfn.length; i += 1) {
			readyfn[i]();
		}
		readyfn = [];
	}

	// Fire any function calls on loaded event
	function fireLoaded() {
		var i;
		pageloaded = true;
		// For browsers with no DOM loaded support
		if (!domready) {
			fireReady();
		}
		for (i = 0; i < loadedfn.length; i += 1) {
			loadedfn[i]();
		}
		loadedfn = [];
	}

	// Check DOM ready, page loaded
	if (d.addEventListener) {
		// Standards
		d.addEventListener('DOMContentLoaded', fireReady, false);
		w.addEventListener('load', fireLoaded, false);
	} else if (d.attachEvent) {
		// IE
		d.attachEvent('onreadystatechange', fireReady);
		// IE < 9
		w.attachEvent('onload', fireLoaded);
	} else {
		// Anything else
		w.onload = fireLoaded;
	}

	// Utility functions

	// Loop through node array
	function nodeLoop(fn, nodes) {
		var i;
		// Good idea to walk up the DOM
		for (i = nodes.length - 1; i >= 0; i -= 1) {
			fn(nodes[i]);
		}
	}

	// Convert to camel case
	function cssCamel(property) {
		return property.replace(/-\w/g, function (result) {
			return result.charAt(1).toUpperCase();
		});
	}

	// Get computed style
	function computeStyle(elm, property) {
		// IE, everything else or null
		return elm.currentStyle ? elm.currentStyle[cssCamel(property)] : w.getComputedStyle ? w.getComputedStyle(elm, null).getPropertyValue(property) : null;
	}

	// Returns URI encoded query string pair
	function queryPair(name, value) {
		return encodeURIComponent(name).replace(/%20/g, '+') + '=' + encodeURIComponent(value).replace(/%20/g, '+');
	}

	// Set CSS, important to wrap in try to prevent error thown on unsupported property
	function setCss(elm, property, value) {
		try {
			elm.style[cssCamel(property)] = value;
		} catch (e) {}
	}

	// Show CSS
	function showCss(elm) {
		elm.style.display = '';
		// For elements still hidden by style block
		if (computeStyle(elm, 'display') === 'none') {
			elm.style.display = 'block';
		}
	}

	// Serialize form & JSON values
	function serializeData(nodes) {
		var querystring = '',
		    subelm,
		    i,
		    j;
		if (nodes.constructor === Object) {
			// Serialize JSON data
			for (subelm in nodes) {
				if (nodes.hasOwnProperty(subelm)) {
					if (nodes[subelm].constructor === Array) {
						for (i = 0; i < nodes[subelm].length; i += 1) {
							querystring += '&' + queryPair(subelm, nodes[subelm][i]);
						}
					} else {
						querystring += '&' + queryPair(subelm, nodes[subelm]);
					}
				}
			}
		} else {
			// Serialize node data
			nodeLoop(function (elm) {
				if (elm.nodeName === 'FORM') {
					for (i = 0; i < elm.elements.length; i += 1) {
						subelm = elm.elements[i];

						if (!subelm.disabled) {
							switch (subelm.type) {
								// Ignore buttons, unsupported XHR 1 form fields
								case 'button':
								case 'image':
								case 'file':
								case 'submit':
								case 'reset':
									break;

								case 'select-one':
									if (subelm.length > 0) {
										querystring += '&' + queryPair(subelm.name, subelm.value);
									}
									break;

								case 'select-multiple':
									for (j = 0; j < subelm.length; j += 1) {
										if (subelm[j].selected) {
											querystring += '&' + queryPair(subelm.name, subelm[j].value);
										}
									}
									break;

								case 'checkbox':
								case 'radio':
									if (subelm.checked) {
										querystring += '&' + queryPair(subelm.name, subelm.value);
									}
									break;

								// Everything else including shinny new HTML5 input types
								default:
									querystring += '&' + queryPair(subelm.name, subelm.value);
							}
						}
					}
				}
			}, nodes);
		}
		// Tidy up first &
		return querystring.length > 0 ? querystring.substring(1) : '';
	}

	// Class helper
	function classHelper(classes, action, nodes) {
		var classarray,
		    search,
		    i,
		    replace,
		    has = false;
		if (classes) {
			// Trim any whitespace
			classarray = classes.split(/\s+/);
			nodeLoop(function (elm) {
				for (i = 0; i < classarray.length; i += 1) {
					var clz = classarray[i];
					if (action === 'remove') {
						elm.classList.remove(clz);
					} else if (action === 'add') {
						elm.classList.add(clz);
					} else if (action === 'toggle') {
						elm.classList.toggle(clz);
					} else if (action === 'has') {
						if (elm.classList.contains(clz)) {
							has = true;
							break;
						}
					}

					// search = new RegExp('\\b' + classarray[i] + '\\b', 'g');
					// replace = new RegExp(' *' + classarray[i] + '\\b', 'g');
					// if (action === 'remove') {
					// 	elm.className = elm.className.replace(search, '');
					// } else if (action === 'toggle') {
					// 	elm.className = (elm.className.match(search)) ? elm.className.replace(replace, '') : elm.className + ' ' + classarray[i];
					// } else if (action === 'has') {
					// 	if (elm.className.match(search)) {
					// 		has = true;
					// 		break;
					// 	}
					// }
				}
			}, nodes);
		}
		return has;
	}

	// HTML insertion helper
	function insertHtml(value, position, nodes) {
		var tmpnodes, tmpnode;
		if (value) {
			nodeLoop(function (elm) {
				// No insertAdjacentHTML support for FF < 8 and IE doesn't allow insertAdjacentHTML table manipulation, so use this instead
				// Convert string to node. We can't innerHTML on a document fragment
				tmpnodes = d.createElement('div');
				tmpnodes.innerHTML = value;
				while ((tmpnode = tmpnodes.lastChild) !== null) {
					// Catch error in unlikely case elm has been removed
					try {
						if (position === 'before') {
							elm.parentNode.insertBefore(tmpnode, elm);
						} else if (position === 'after') {
							elm.parentNode.insertBefore(tmpnode, elm.nextSibling);
						} else if (position === 'append') {
							elm.appendChild(tmpnode);
						} else if (position === 'prepend') {
							elm.insertBefore(tmpnode, elm.firstChild);
						}
					} catch (e) {
						break;
					}
				}
			}, nodes);
		}
	}

	// Get nodes and return chibi
	function chibi(selector) {
		var cb,
		    nodes = [],
		    json = false,
		    nodelist,
		    i;

		if (selector) {

			// Element node, would prefer to use (selector instanceof HTMLElement) but no IE support
			if (selector.nodeType && selector.nodeType === 1) {
				nodes = [selector]; // return element as node list
			} else if ((typeof selector === 'undefined' ? 'undefined' : _typeof(selector)) === 'object') {
				// JSON, document object or node list, would prefer to use (selector instanceof NodeList) but no IE support
				json = typeof selector.length !== 'number';
				nodes = selector;
			} else if (typeof selector === 'string') {
				nodelist = d.querySelectorAll(selector);

				// Convert node list to array so results have full access to array methods
				// Array.prototype.slice.call not supported in IE < 9 and often slower than loop anyway
				for (i = 0; i < nodelist.length; i += 1) {
					nodes[i] = nodelist[i];
				}
			}
		}

		// Only attach nodes if not JSON
		cb = json ? {} : nodes;

		// Public functions

		// Executes a function on nodes
		cb.each = function (fn) {
			if (typeof fn === 'function') {
				nodeLoop(function (elm) {
					// <= IE 8 loses scope so need to apply
					return fn.apply(elm, arguments);
				}, nodes);
			}
			return cb;
		};
		// Find first
		cb.first = function () {
			return chibi(nodes.shift());
		};
		// Find last
		cb.last = function () {
			return chibi(nodes.pop());
		};
		// Find odd
		cb.odd = function () {
			var odds = [],
			    i;
			for (i = 0; i < nodes.length; i += 2) {
				odds.push(nodes[i]);
			}
			return chibi(odds);
		};
		// Find even
		cb.even = function () {
			var evens = [],
			    i;
			for (i = 1; i < nodes.length; i += 2) {
				evens.push(nodes[i]);
			}
			return chibi(evens);
		};
		// Hide node
		cb.hide = function () {
			nodeLoop(function (elm) {
				elm.style.display = 'none';
			}, nodes);
			return cb;
		};
		// Show node
		cb.show = function () {
			nodeLoop(function (elm) {
				showCss(elm);
			}, nodes);
			return cb;
		};
		// Toggle node display
		cb.toggle = function (state) {
			if (typeof state != 'undefined') {
				// ADDED
				if (state) cb.show();else cb.hide();
			} else {
				nodeLoop(function (elm) {
					// computeStyle instead of style.display == 'none' catches elements that are hidden via style block
					if (computeStyle(elm, 'display') === 'none') {
						showCss(elm);
					} else {
						elm.style.display = 'none';
					}
				}, nodes);
			}
			return cb;
		};
		// Remove node
		cb.remove = function () {
			nodeLoop(function (elm) {
				// Catch error in unlikely case elm has been removed
				try {
					elm.parentNode.removeChild(elm);
				} catch (e) {}
			}, nodes);
			return chibi();
		};
		// Get/Set CSS
		cb.css = function (property, value) {
			if (property) {
				if (value || value === '') {
					nodeLoop(function (elm) {
						setCss(elm, property, value);
					}, nodes);
					return cb;
				}
				if (nodes[0]) {
					if (nodes[0].style[cssCamel(property)]) {
						return nodes[0].style[cssCamel(property)];
					}
					if (computeStyle(nodes[0], property)) {
						return computeStyle(nodes[0], property);
					}
				}
			}
		};
		// Get class(es)
		cb.getClass = function () {
			if (nodes[0] && nodes[0].className.length > 0) {
				// Weak IE trim support
				return nodes[0].className.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, '').replace(/\s+/, ' ');
			}
		};
		// Set (replaces) classes
		cb.setClass = function (classes) {
			if (classes || classes === '') {
				nodeLoop(function (elm) {
					elm.className = classes;
				}, nodes);
			}
			return cb;
		};
		// Add class
		cb.addClass = function (classes) {
			classHelper(classes, 'add', nodes);
			// if (classes) {
			// 	nodeLoop(function (elm) {
			// 		elm.className += ' ' + classes;
			// 	}, nodes);
			// }
			return cb;
		};
		// Remove class
		cb.removeClass = function (classes) {
			classHelper(classes, 'remove', nodes);
			return cb;
		};
		// Toggle class
		cb.toggleClass = function (classes, set) {
			var method = typeof set === 'undefined' ? 'toggle' : +set ? 'add' : 'remove';
			classHelper(classes, method, nodes);
			return cb;
		};
		// Has class
		cb.hasClass = function (classes) {
			return classHelper(classes, 'has', nodes);
		};
		// Get/set HTML
		cb.html = function (value) {
			if (value || value === '') {
				nodeLoop(function (elm) {
					elm.innerHTML = value;
				}, nodes);
				return cb;
			}
			if (nodes[0]) {
				return nodes[0].innerHTML;
			}
		};
		// Insert HTML before selector
		cb.htmlBefore = function (value) {
			insertHtml(value, 'before', nodes);
			return cb;
		};
		// Insert HTML after selector
		cb.htmlAfter = function (value) {
			insertHtml(value, 'after', nodes);
			return cb;
		};
		// Insert HTML after selector innerHTML
		cb.htmlAppend = function (value) {
			insertHtml(value, 'append', nodes);
			return cb;
		};
		// Insert HTML before selector innerHTML
		cb.htmlPrepend = function (value) {
			insertHtml(value, 'prepend', nodes);
			return cb;
		};
		// Get/Set HTML attributes
		cb.attr = function (property, value) {
			if (property) {
				property = property.toLowerCase();
				// IE < 9 doesn't allow style or class via get/setAttribute so switch. cssText returns prettier CSS anyway
				if (typeof value !== 'undefined') {
					//FIXED BUG HERE
					nodeLoop(function (elm) {
						if (property === 'style') {
							elm.style.cssText = value;
						} else if (property === 'class') {
							elm.className = value;
						} else {
							elm.setAttribute(property, value);
						}
					}, nodes);
					return cb;
				}
				if (nodes[0]) {
					if (property === 'style') {
						if (nodes[0].style.cssText) {
							return nodes[0].style.cssText;
						}
					} else if (property === 'class') {
						if (nodes[0].className) {
							return nodes[0].className;
						}
					} else {
						if (nodes[0].getAttribute(property)) {
							return nodes[0].getAttribute(property);
						}
					}
				}
			}
		};
		// Get/Set HTML data property
		cb.data = function (key, value) {
			if (key) {
				return cb.attr('data-' + key, value);
			}
		};
		// Get/Set form element values
		cb.val = function (value) {
			var values, i, j;
			if (typeof value != 'undefined') {
				// FIXED A BUG HERE
				nodeLoop(function (elm) {
					switch (elm.nodeName) {
						case 'SELECT':
							if (typeof value === 'string' || typeof value === 'number') {
								value = [value];
							}
							for (i = 0; i < elm.length; i += 1) {
								// Multiple select
								for (j = 0; j < value.length; j += 1) {
									elm[i].selected = '';
									if (elm[i].value === "" + value[j]) {
										elm[i].selected = 'selected';
										break;
									}
								}
							}
							break;
						case 'INPUT':
						case 'TEXTAREA':
						case 'BUTTON':
							elm.value = value;
							break;
					}
				}, nodes);

				return cb;
			}
			if (nodes[0]) {
				switch (nodes[0].nodeName) {
					case 'SELECT':
						values = [];
						for (i = 0; i < nodes[0].length; i += 1) {
							if (nodes[0][i].selected) {
								values.push(nodes[0][i].value);
							}
						}
						return values.length > 1 ? values : values[0];
					case 'INPUT':
					case 'TEXTAREA':
					case 'BUTTON':
						return nodes[0].value;
				}
			}
		};
		// Return matching checked checkbox or radios
		cb.checked = function (check) {
			if (typeof check === 'boolean') {
				nodeLoop(function (elm) {
					if (elm.nodeName === 'INPUT' && (elm.type === 'checkbox' || elm.type === 'radio')) {
						elm.checked = check;
					}
				}, nodes);
				return cb;
			}
			if (nodes[0] && nodes[0].nodeName === 'INPUT' && (nodes[0].type === 'checkbox' || nodes[0].type === 'radio')) {
				return !!nodes[0].checked;
			}
		};
		// Add event handler
		cb.on = function (event, fn) {
			if (selector === w || selector === d) {
				nodes = [selector];
			}
			nodeLoop(function (elm) {
				if (d.addEventListener) {
					elm.addEventListener(event, fn, false);
				} else if (d.attachEvent) {
					// <= IE 8 loses scope so need to apply, we add this to object so we can detach later (can't detach anonymous functions)
					elm[event + fn] = function () {
						return fn.apply(elm, arguments);
					};
					elm.attachEvent('on' + event, elm[event + fn]);
				}
			}, nodes);
			return cb;
		};
		// Remove event handler
		cb.off = function (event, fn) {
			if (selector === w || selector === d) {
				nodes = [selector];
			}
			nodeLoop(function (elm) {
				if (d.addEventListener) {
					elm.removeEventListener(event, fn, false);
				} else if (d.attachEvent) {
					elm.detachEvent('on' + event, elm[event + fn]);
					// Tidy up
					elm[event + fn] = null;
				}
			}, nodes);
			return cb;
		};
		return cb;
	}

	// Basic XHR
	chibi.ajax = function (options) {
		// if options is a number, it's timeout in ms
		var opts = Object.assign({
			method: 'GET',
			nocache: true,
			timeout: 5000,
			loader: true,
			callback: null
		}, options);
		opts.method = opts.method.toUpperCase();

		var loaderFn = opts.loader ? chibi._loader : function () {};
		var url = opts.url;
		var method = opts.method;
		var query = null;

		if (opts.data) {
			query = serializeData(opts.data);
		}

		if (query && method === 'GET') {
			url += url.indexOf('?') === -1 ? '?' + query : '&' + query;
			query = null;
		}

		var xhr = new XMLHttpRequest();

		// prevent caching
		if (opts.nocache) {
			var ts = (+new Date()).toString(36);
			url += (url.indexOf('?') === -1 ? '?' : '&') + '_=' + ts;
		}

		loaderFn(true);

		xhr.open(method, url, true);
		xhr.timeout = opts.timeout;

		// Abort after given timeout
		var abortTmeo = setTimeout(function () {
			console.error("XHR timed out.");
			xhr.abort();
			loaderFn(false);
		}, opts.timeout + 10);

		xhr.onreadystatechange = function () {
			if (xhr.readyState === 4) {
				loaderFn(false);

				opts.callback && opts.callback(xhr.responseText, xhr.status);

				clearTimeout(abortTmeo);
			}
		};

		xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
		if (method === 'POST') {
			xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
		}

		xhr.send(query);
		return xhr;
	};

	chibi._loader = function () {};

	// Alias to cb.ajax(url, 'get', callback)
	chibi.get = function (url, callback, opts) {
		opts = opts || {};
		opts.url = url;
		opts.callback = callback;
		opts.method = 'GET';
		return chibi.ajax(opts);
	};

	// Alias to cb.ajax(url, 'post', callback)
	chibi.post = function (url, callback, opts) {
		opts = opts || {};
		opts.url = url;
		opts.callback = callback;
		opts.method = 'POST';
		return chibi.ajax(opts);
	};

	// Fire on DOM ready
	chibi.ready = function (fn) {
		if (fn) {
			if (domready) {
				fn();
				return chibi;
			} else {
				readyfn.push(fn);
			}
		}
	};

	// Fire on page loaded
	chibi.loaded = function (fn) {
		if (fn) {
			if (pageloaded) {
				fn();
				return chibi;
			} else {
				loadedfn.push(fn);
			}
		}
	};

	var entityMap = {
		'&': '&amp;',
		'<': '&lt;',
		'>': '&gt;',
		'"': '&quot;',
		"'": '&#39;',
		'/': '&#x2F;',
		'`': '&#x60;',
		'=': '&#x3D;'
	};

	chibi.htmlEscape = function (string) {
		return String(string).replace(/[&<>"'`=\/]/g, function (s) {
			return entityMap[s];
		});
	};

	// Set Chibi's global namespace here ($)
	module.exports = chibi;
})();

/***/ }),
/* 2 */
/***/ (function(module, exports) {

// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

function EventEmitter() {
  this._events = this._events || {};
  this._maxListeners = this._maxListeners || undefined;
}
module.exports = EventEmitter;

// Backwards-compat with node 0.10.x
EventEmitter.EventEmitter = EventEmitter;

EventEmitter.prototype._events = undefined;
EventEmitter.prototype._maxListeners = undefined;

// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
EventEmitter.defaultMaxListeners = 10;

// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
EventEmitter.prototype.setMaxListeners = function(n) {
  if (!isNumber(n) || n < 0 || isNaN(n))
    throw TypeError('n must be a positive number');
  this._maxListeners = n;
  return this;
};

EventEmitter.prototype.emit = function(type) {
  var er, handler, len, args, i, listeners;

  if (!this._events)
    this._events = {};

  // If there is no 'error' event listener then throw.
  if (type === 'error') {
    if (!this._events.error ||
        (isObject(this._events.error) && !this._events.error.length)) {
      er = arguments[1];
      if (er instanceof Error) {
        throw er; // Unhandled 'error' event
      } else {
        // At least give some kind of context to the user
        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
        err.context = er;
        throw err;
      }
    }
  }

  handler = this._events[type];

  if (isUndefined(handler))
    return false;

  if (isFunction(handler)) {
    switch (arguments.length) {
      // fast cases
      case 1:
        handler.call(this);
        break;
      case 2:
        handler.call(this, arguments[1]);
        break;
      case 3:
        handler.call(this, arguments[1], arguments[2]);
        break;
      // slower
      default:
        args = Array.prototype.slice.call(arguments, 1);
        handler.apply(this, args);
    }
  } else if (isObject(handler)) {
    args = Array.prototype.slice.call(arguments, 1);
    listeners = handler.slice();
    len = listeners.length;
    for (i = 0; i < len; i++)
      listeners[i].apply(this, args);
  }

  return true;
};

EventEmitter.prototype.addListener = function(type, listener) {
  var m;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events)
    this._events = {};

  // To avoid recursion in the case that type === "newListener"! Before
  // adding it to the listeners, first emit "newListener".
  if (this._events.newListener)
    this.emit('newListener', type,
              isFunction(listener.listener) ?
              listener.listener : listener);

  if (!this._events[type])
    // Optimize the case of one listener. Don't need the extra array object.
    this._events[type] = listener;
  else if (isObject(this._events[type]))
    // If we've already got an array, just append.
    this._events[type].push(listener);
  else
    // Adding the second element, need to change to array.
    this._events[type] = [this._events[type], listener];

  // Check for listener leak
  if (isObject(this._events[type]) && !this._events[type].warned) {
    if (!isUndefined(this._maxListeners)) {
      m = this._maxListeners;
    } else {
      m = EventEmitter.defaultMaxListeners;
    }

    if (m && m > 0 && this._events[type].length > m) {
      this._events[type].warned = true;
      console.error('(node) warning: possible EventEmitter memory ' +
                    'leak detected. %d listeners added. ' +
                    'Use emitter.setMaxListeners() to increase limit.',
                    this._events[type].length);
      if (typeof console.trace === 'function') {
        // not supported in IE 10
        console.trace();
      }
    }
  }

  return this;
};

EventEmitter.prototype.on = EventEmitter.prototype.addListener;

EventEmitter.prototype.once = function(type, listener) {
  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  var fired = false;

  function g() {
    this.removeListener(type, g);

    if (!fired) {
      fired = true;
      listener.apply(this, arguments);
    }
  }

  g.listener = listener;
  this.on(type, g);

  return this;
};

// emits a 'removeListener' event iff the listener was removed
EventEmitter.prototype.removeListener = function(type, listener) {
  var list, position, length, i;

  if (!isFunction(listener))
    throw TypeError('listener must be a function');

  if (!this._events || !this._events[type])
    return this;

  list = this._events[type];
  length = list.length;
  position = -1;

  if (list === listener ||
      (isFunction(list.listener) && list.listener === listener)) {
    delete this._events[type];
    if (this._events.removeListener)
      this.emit('removeListener', type, listener);

  } else if (isObject(list)) {
    for (i = length; i-- > 0;) {
      if (list[i] === listener ||
          (list[i].listener && list[i].listener === listener)) {
        position = i;
        break;
      }
    }

    if (position < 0)
      return this;

    if (list.length === 1) {
      list.length = 0;
      delete this._events[type];
    } else {
      list.splice(position, 1);
    }

    if (this._events.removeListener)
      this.emit('removeListener', type, listener);
  }

  return this;
};

EventEmitter.prototype.removeAllListeners = function(type) {
  var key, listeners;

  if (!this._events)
    return this;

  // not listening for removeListener, no need to emit
  if (!this._events.removeListener) {
    if (arguments.length === 0)
      this._events = {};
    else if (this._events[type])
      delete this._events[type];
    return this;
  }

  // emit removeListener for all listeners on all events
  if (arguments.length === 0) {
    for (key in this._events) {
      if (key === 'removeListener') continue;
      this.removeAllListeners(key);
    }
    this.removeAllListeners('removeListener');
    this._events = {};
    return this;
  }

  listeners = this._events[type];

  if (isFunction(listeners)) {
    this.removeListener(type, listeners);
  } else if (listeners) {
    // LIFO order
    while (listeners.length)
      this.removeListener(type, listeners[listeners.length - 1]);
  }
  delete this._events[type];

  return this;
};

EventEmitter.prototype.listeners = function(type) {
  var ret;
  if (!this._events || !this._events[type])
    ret = [];
  else if (isFunction(this._events[type]))
    ret = [this._events[type]];
  else
    ret = this._events[type].slice();
  return ret;
};

EventEmitter.prototype.listenerCount = function(type) {
  if (this._events) {
    var evlistener = this._events[type];

    if (isFunction(evlistener))
      return 1;
    else if (evlistener)
      return evlistener.length;
  }
  return 0;
};

EventEmitter.listenerCount = function(emitter, type) {
  return emitter.listenerCount(type);
};

function isFunction(arg) {
  return typeof arg === 'function';
}

function isNumber(arg) {
  return typeof arg === 'number';
}

function isObject(arg) {
  return typeof arg === 'object' && arg !== null;
}

function isUndefined(arg) {
  return arg === void 0;
}


/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);

var _require = __webpack_require__(7),
    rgb255ToHex = _require.rgb255ToHex;

var themes = exports.themes = [[// 0 - Tango - terminator
'#111213', '#CC0000', '#4E9A06', '#C4A000', '#3465A4', '#75507B', '#06989A', '#D3D7CF', '#555753', '#EF2929', '#8AE234', '#FCE94F', '#729FCF', '#AD7FA8', '#34E2E2', '#EEEEEC'], [// 1 - Linux (CGA) - terminator
'#000000', '#aa0000', '#00aa00', '#aa5500', '#0000aa', '#aa00aa', '#00aaaa', '#aaaaaa', '#555555', '#ff5555', '#55ff55', '#ffff55', '#5555ff', '#ff55ff', '#55ffff', '#ffffff'], [// 2 - xterm - terminator
'#000000', '#cd0000', '#00cd00', '#cdcd00', '#0000ee', '#cd00cd', '#00cdcd', '#e5e5e5', '#7f7f7f', '#ff0000', '#00ff00', '#ffff00', '#5c5cff', '#ff00ff', '#00ffff', '#ffffff'], [// 3 - rxvt - terminator
'#000000', '#cd0000', '#00cd00', '#cdcd00', '#0000cd', '#cd00cd', '#00cdcd', '#faebd7', '#404040', '#ff0000', '#00ff00', '#ffff00', '#0000ff', '#ff00ff', '#00ffff', '#ffffff'], [// 4 - Ambience - terminator
'#2e3436', '#cc0000', '#4e9a06', '#c4a000', '#3465a4', '#75507b', '#06989a', '#d3d7cf', '#555753', '#ef2929', '#8ae234', '#fce94f', '#729fcf', '#ad7fa8', '#34e2e2', '#eeeeec'], [// 5 - Solarized Dark - terminator
'#073642', '#dc322f', '#859900', '#b58900', '#268bd2', '#d33682', '#2aa198', '#eee8d5', '#002b36', '#cb4b16', '#586e75', '#657b83', '#839496', '#6c71c4', '#93a1a1', '#fdf6e3'], [// 6 - CGA NTSC - wikipedia
'#000000', '#69001A', '#117800', '#769100', '#1A00A6', '#8019AB', '#289E76', '#A4A4A4', '#484848', '#C54E76', '#6DD441', '#D2ED46', '#765BFF', '#DC75FF', '#84FAD2', '#FFFFFF'], [// 7 - ZX Spectrum - wikipedia
'#000000', '#aa0000', '#00aa00', '#aaaa00', '#0000aa', '#aa00aa', '#00aaaa', '#aaaaaa', '#000000', '#ff0000', '#00FF00', '#ffff00', '#0000ff', '#ff00ff', '#00ffff', '#ffffff'], [// 8 - Apple II - wikipedia
'#000000', '#722640', '#0E5940', '#808080', '#40337F', '#E434FE', '#1B9AFE', '#BFB3FF', '#404C00', '#E46501', '#1BCB01', '#BFCC80', '#808080', '#F1A6BF', '#8DD9BF', '#ffffff'], [// 9 - Commodore - wikipedia
'#000000', '#8D3E37', '#55A049', '#AAB95D', '#40318D', '#80348B', '#72C1C8', '#D59F74', '#8B5429', '#B86962', '#94E089', '#FFFFB2', '#8071CC', '#AA5FB6', '#87D6DD', '#ffffff'], [// 10 - Solarized Light - https://github.com/sgerrand/xfce4-terminal-colors-solarized
'#eee8d5', '#dc322f', '#859900', '#b58900', '#268bd2', '#d33682', '#2aa198', '#073642', '#fdf6e3', '#cb4b16', '#93a1a1', '#839496', '#657b83', '#6c71c4', '#586e75', '#002b36'], [// 11 - Solarized Dark High contrast - https://github.com/sgerrand/xfce4-terminal-colors-solarized
'#073642', '#dc322f', '#859900', '#b58900', '#268bd2', '#d33682', '#2aa198', '#fdf6e3', '#002b36', '#cb4b16', '#657b83', '#839496', '#93a1a1', '#6c71c4', '#eee8d5', '#fdf6e3']];

exports.fgbgThemes = [['#AAAAAA', '#000000', 'Lnx', 'Linux'], ['#FFFFFF', '#000000', 'W+K', 'White on Black'], ['#00FF00', '#000000', 'Lim', 'Lime'], ['#E53C00', '#000000', 'Nix', 'Nixie'], ['#EFF0F1', '#31363B', 'Brz', 'Breeze'], ['#FFFFFF', '#300A24', 'Amb', 'Ambiance'], ['#839496', '#002B36', 'SoD', 'Solarized Dark'], ['#93a1a1', '#002b36', 'SoH', 'Solarized Dark (High Contrast)'], ['#657B83', '#FDF6E3', 'SoL', 'Solarized Light'], ['#000000', '#FFD75F', 'Wsp', 'Wasp'], ['#000000', '#FFFFDD', 'K+Y', 'Black on Yellow'], ['#000000', '#FFFFFF', 'K+W', 'Black on White']];

var colorTable256 = null;

exports.buildColorTable = function () {
  if (colorTable256 !== null) return colorTable256;

  // 256color lookup table
  // should not be used to look up 0-15
  colorTable256 = new Array(16).fill('#000000');

  // fill color table
  // colors 16-231 are a 6x6x6 color cube
  for (var red = 0; red < 6; red++) {
    for (var green = 0; green < 6; green++) {
      for (var blue = 0; blue < 6; blue++) {
        var redValue = red * 40 + (red ? 55 : 0);
        var greenValue = green * 40 + (green ? 55 : 0);
        var blueValue = blue * 40 + (blue ? 55 : 0);
        colorTable256.push(rgb255ToHex(redValue, greenValue, blueValue));
      }
    }
  }
  // colors 232-255 are a grayscale ramp, sans black and white
  for (var gray = 0; gray < 24; gray++) {
    var value = gray * 10 + 8;
    colorTable256.push(rgb255ToHex(value, value, value));
  }

  return colorTable256;
};

exports.SELECTION_FG = '#333';
exports.SELECTION_BG = '#b2d7fe';

exports.themePreview = function (themeN) {
  $('[data-fg]').forEach(function (elem) {
    var shade = elem.dataset.fg;
    if (/^\d+$/.test(shade)) shade = exports.toHex(shade, themeN);
    elem.style.color = shade;
  });
  $('[data-bg]').forEach(function (elem) {
    var shade = elem.dataset.bg;
    if (/^\d+$/.test(shade)) shade = exports.toHex(shade, themeN);
    elem.style.backgroundColor = shade;
  });
};

exports.colorTable256 = null;
exports.ensureColorTable256 = function () {
  if (!exports.colorTable256) exports.colorTable256 = exports.buildColorTable();
};

exports.getColor = function (i) {
  var palette = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  // return palette color if it exists
  if (i < 16 && i in palette) return palette[i];

  // -1 for selection foreground, -2 for selection background
  if (i === -1) return exports.SELECTION_FG;
  if (i === -2) return exports.SELECTION_BG;

  // 256 color
  if (i > 15 && i < 256) {
    exports.ensureColorTable256();
    return exports.colorTable256[i];
  }

  // 24-bit color, encoded as (hex) + 256 (such that #000000 == 256)
  if (i > 255) {
    i -= 256;
    return '#' + ('000000' + i.toString(16)).substr(-6);
  }

  // return error color
  return Math.floor(Date.now() / 1000) % 2 === 0 ? '#ff0ff' : '#00ff00';
};

exports.toHex = function (shade, themeN) {
  if (/^\d+$/.test(shade)) {
    shade = +shade;
    return exports.getColor(shade, themes[themeN]);
  }
  return shade;
};

/***/ }),
/* 4 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);

/** Module for toggling a modal overlay */
var modal = {};
var curCloseCb = null;

modal.show = function (sel, closeCb) {
  var $m = $(sel);
  $m.removeClass('hidden visible');
  setTimeout(function () {
    $m.addClass('visible');
  }, 1);
  curCloseCb = closeCb;
};

modal.hide = function (sel) {
  var $m = $(sel);
  $m.removeClass('visible');
  setTimeout(function () {
    $m.addClass('hidden');
    if (curCloseCb) curCloseCb();
  }, 500); // transition time
};

modal.init = function () {
  // close modal by click outside the dialog
  $('.Modal').on('click', function () {
    if ($(this).hasClass('no-close')) return; // this is a no-close modal
    modal.hide(this);
  });

  $('.Dialog').on('click', function (e) {
    e.stopImmediatePropagation();
  });

  // Hide all modals on esc
  $(window).on('keydown', function (e) {
    if (e.which === 27) {
      modal.hide('.Modal');
    }
  });
};

module.exports = modal;

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);
var modal = __webpack_require__(4);

var nt = {};
var sel = '#notif';
var $balloon = void 0;

var timerHideBegin = void 0; // timeout to start hiding (transition)
var timerHideEnd = void 0; // timeout to add the hidden class
var canCancel = false;

var stopTimeouts = function stopTimeouts() {
  clearTimeout(timerHideBegin);
  clearTimeout(timerHideEnd);
};

nt.show = function (message, timeout, isError) {
  $balloon.toggleClass('error', isError === true);
  $balloon.html(message);
  modal.show($balloon);
  stopTimeouts();

  if (!timeout || timeout <= 0) {
    timeout = 2500;
  }

  timerHideBegin = setTimeout(nt.hide, timeout);

  canCancel = false;
  setTimeout(function () {
    canCancel = true;
  }, 500);
};

nt.hide = function () {
  var $m = $(sel);
  $m.removeClass('visible');
  timerHideEnd = setTimeout(function () {
    $m.addClass('hidden');
  }, 250); // transition time
};

nt.init = function () {
  $balloon = $(sel);

  // close by click outside
  $(document).on('click', function () {
    if (!canCancel) return;
    nt.hide(this);
  });

  // click caused by selecting, prevent it from bubbling
  $balloon.on('click', function (e) {
    e.stopImmediatePropagation();
    return false;
  });

  // stop fading if moused
  $balloon.on('mouseenter', function () {
    stopTimeouts();
    $balloon.removeClass('hidden').addClass('visible');
  });
};

module.exports = nt;

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


// Bits in the cell attribs word

/* eslint-disable no-multi-spaces */
exports.ATTR_FG = 1 << 0; // 1 if not using default background color (ignore cell bg) - color extension bit
exports.ATTR_BG = 1 << 1; // 1 if not using default foreground color (ignore cell fg) - color extension bit
exports.ATTR_BOLD = 1 << 2; // Bold font
exports.ATTR_UNDERLINE = 1 << 3; // Underline decoration
exports.ATTR_INVERSE = 1 << 4; // Invert colors - this is useful so we can clear then with SGR manipulation commands
exports.ATTR_BLINK = 1 << 5; // Blinking
exports.ATTR_ITALIC = 1 << 6; // Italic font
exports.ATTR_STRIKE = 1 << 7; // Strike-through decoration
exports.ATTR_OVERLINE = 1 << 8; // Over-line decoration
exports.ATTR_FAINT = 1 << 9; // Faint foreground color (reduced alpha)
exports.ATTR_FRAKTUR = 1 << 10; // Fraktur font (unicode substitution)
/* eslint-enable no-multi-spaces */

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*
 * Copyright (c) 2010 Tim Baumann
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

// NOTE:
// Extracted from ColorTriangle and
// Converted to ES6 by MightyPork (2017)

/*******************
 * Color conversion *
 *******************/

var M = Math;
var TAU = 2 * M.PI;

exports.hue2rgb = function (v1, v2, h) {
  if (h < 0) h += 1;
  if (h > 1) h -= 1;

  if (6 * h < 1) return v1 + (v2 - v1) * 6 * h;
  if (2 * h < 1) return v2;
  if (3 * h < 2) return v1 + (v2 - v1) * (2 / 3 - h) * 6;
  return v1;
};

exports.hsl2rgb = function (h, s, l) {
  h /= TAU;
  var r = void 0,
      g = void 0,
      b = void 0;

  if (s === 0) {
    r = g = b = l;
  } else {
    var var_1 = void 0,
        var_2 = void 0;

    if (l < 0.5) var_2 = l * (1 + s);else var_2 = l + s - s * l;

    var_1 = 2 * l - var_2;

    r = exports.hue2rgb(var_1, var_2, h + 1 / 3);
    g = exports.hue2rgb(var_1, var_2, h);
    b = exports.hue2rgb(var_1, var_2, h - 1 / 3);
  }
  return [r, g, b];
};

exports.rgb2hsl = function (r, g, b) {
  var min = M.min(r, g, b);
  var max = M.max(r, g, b);
  var d = max - min; // delta

  var h = void 0,
      s = void 0,
      l = void 0;

  l = (max + min) / 2;

  if (d === 0) {
    // gray
    h = s = 0; // HSL results from 0 to 1
  } else {
    // chroma
    if (l < 0.5) s = d / (max + min);else s = d / (2 - max - min);

    var d_r = ((max - r) / 6 + d / 2) / d;
    var d_g = ((max - g) / 6 + d / 2) / d;
    var d_b = ((max - b) / 6 + d / 2) / d; // deltas

    if (r === max) h = d_b - d_g;else if (g === max) h = 1 / 3 + d_r - d_b;else if (b === max) h = 2 / 3 + d_g - d_r;

    if (h < 0) h += 1;else if (h > 1) h -= 1;
  }
  h *= TAU;
  return [h, s, l];
};

exports.hex2rgb = function (hex) {
  var groups = hex.match(/^#([\da-f]{3,6})$/i);
  if (groups) {
    hex = groups[1];
    var bytes = hex.length / 3;
    var max = Math.pow(16, bytes) - 1;
    return [0, 1, 2].map(function (x) {
      return parseInt(hex.slice(x * bytes, (x + 1) * bytes), 16) / max;
    });
  }
  return [0, 0, 0];
};

function pad(n) {
  return ('00' + n).substr(-2);
}

exports.rgb255ToHex = function (r, g, b) {
  return '#' + [r, g, b].map(function (x) {
    return pad(x.toString(16));
  }).join('');
};

exports.rgb2hex = function (r, g, b) {
  return '#' + [r, g, b].map(function (x) {
    return pad(Math.round(x * 255).toString(16));
  }).join('');
};

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var EventEmitter = __webpack_require__(2);

var _require = __webpack_require__(0),
    parse2B = _require.parse2B;

var _require2 = __webpack_require__(3),
    themes = _require2.themes;

var encodeAsCodePoint = function encodeAsCodePoint(i) {
  return String.fromCodePoint(i + (i >= 0xD800 ? 0x801 : 1));
};

var ANSIParser = function () {
  function ANSIParser(handler) {
    _classCallCheck(this, ANSIParser);

    this.reset();
    this.handler = handler;
    this.joinChunks = true;
  }

  _createClass(ANSIParser, [{
    key: 'reset',
    value: function reset() {
      this.currentSequence = 0;
      this.sequence = '';
    }
  }, {
    key: 'parseSequence',
    value: function parseSequence(sequence) {
      if (sequence[0] === '[') {
        var type = sequence[sequence.length - 1];
        var content = sequence.substring(1, sequence.length - 1);

        var numbers = content ? content.split(';').map(function (i) {
          return +i.replace(/\D/g, '');
        }) : [];
        var numOr1 = numbers.length ? numbers[0] : 1;
        if (type === 'H') {
          this.handler('set-cursor', (numbers[0] | 0) - 1, (numbers[1] | 0) - 1);
        } else if (type >= 'A' && type <= 'D') {
          this.handler('move-cursor-' + (type <= 'B' ? 'y' : 'x'), (type === 'B' || type === 'C' ? 1 : -1) * numOr1);
        } else if (type === 'E' || type === 'F') {
          this.handler('move-cursor-line', (type === 'E' ? 1 : -1) * numOr1);
        } else if (type === 'G') {
          this.handler('set-cursor-x', numOr1 - 1);
        } else if (type === 'J') {
          var number = numbers.length ? numbers[0] : 2;
          if (number === 2) this.handler('clear');
        } else if (type === 'P') {
          this.handler('delete', numOr1);
        } else if (type === '@') {
          this.handler('insert-blanks', numOr1);
        } else if (type === 'q') this.handler('set-cursor-style', numOr1);else if (type === 'm') {
          if (!numbers.length) {
            this.handler('reset-style');
            return;
          }
          var _type = void 0;
          while (_type = numbers.shift()) {
            if (_type === 0) this.handler('reset-style');else if (_type === 1) this.handler('add-attrs', 1 << 2); // bold
            else if (_type === 2) this.handler('add-attrs', 1 << 9); // faint
              else if (_type === 3) this.handler('add-attrs', 1 << 6); // italic
                else if (_type === 4) this.handler('add-attrs', 1 << 3); // underline
                  else if (_type === 5 || _type === 6) this.handler('add-attrs', 1 << 5); // blink
                    else if (_type === 7) this.handler('add-attrs', 1 << 4); // invert
                      else if (_type === 9) this.handler('add-attrs', 1 << 7); // strike
                        else if (_type === 20) this.handler('add-attrs', 1 << 10); // fraktur
                          else if (_type >= 30 && _type <= 37) this.handler('set-color-fg', _type % 10);else if (_type >= 40 && _type <= 47) this.handler('set-color-bg', _type % 10);else if (_type === 39) this.handler('reset-color-fg');else if (_type === 49) this.handler('reset-color-bg');else if (_type >= 90 && _type <= 98) this.handler('set-color-fg', _type % 10 + 8);else if (_type >= 100 && _type <= 108) this.handler('set-color-bg', _type % 10 + 8);else if (_type === 38 || _type === 48) {
                              var mode = numbers.shift();
                              if (mode === 2) {
                                var r = numbers.shift();
                                var g = numbers.shift();
                                var b = numbers.shift();
                                var color = (r << 16 | g << 8 | b) + 256;
                                if (_type === 38) this.handler('set-color-fg', color);
                                if (_type === 48) this.handler('set-color-bg', color);
                              } else if (mode === 5) {
                                var _color = (numbers.shift() | 0) & 0xFF;
                                if (_type === 38) this.handler('set-color-fg', _color);
                                if (_type === 48) this.handler('set-color-bg', _color);
                              }
                            }
          }
        } else if (type === 'h' || type === 'l') {
          if (content === '?25') {
            if (type === 'h') this.handler('show-cursor');else if (type === 'l') this.handler('hide-cursor');
          }
        }
      }
    }
  }, {
    key: 'write',
    value: function write(text) {
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = text.toString()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var character = _step.value;

          var code = character.codePointAt(0);
          if (code === 0x1b) this.currentSequence = 1;else if (this.currentSequence === 1 && character === '[') {
            this.currentSequence = 2;
            this.sequence += '[';
          } else if (this.currentSequence && character.match(/[\x40-\x7e]/)) {
            this.parseSequence(this.sequence + character);
            this.currentSequence = 0;
            this.sequence = '';
          } else if (this.currentSequence > 1) this.sequence += character;else if (this.currentSequence === 1) {
            // something something nothing
            this.currentSequence = 0;
            this.handler('write', character);
          } else if (code < 0x03) this.handler('_null');else if (code === 0x03) this.handler('sigint');else if (code <= 0x06) this.handler('_null');else if (code === 0x07) this.handler('bell');else if (code === 0x08) this.handler('back');else if (code === 0x09) this.handler('tab');else if (code === 0x0a) this.handler('new-line');else if (code === 0x0d) this.handler('return');else if (code === 0x15) this.handler('delete-line');else if (code === 0x17) this.handler('delete-word');else this.handler('write', character);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      if (!this.joinChunks) this.reset();
    }
  }]);

  return ANSIParser;
}();

var TERM_DEFAULT_STYLE = [0, 0, 0];

var getRainbowColor = function getRainbowColor(t) {
  var r = Math.floor(Math.sin(t) * 2.5 + 2.5);
  var g = Math.floor(Math.sin(t + 2 / 3 * Math.PI) * 2.5 + 2.5);
  var b = Math.floor(Math.sin(t + 4 / 3 * Math.PI) * 2.5 + 2.5);
  return 16 + 36 * r + 6 * g + b;
};

var ScrollingTerminal = function () {
  function ScrollingTerminal(screen) {
    var _this = this;

    _classCallCheck(this, ScrollingTerminal);

    this.width = 80;
    this.height = 25;
    this.termScreen = screen;
    this.parser = new ANSIParser(function () {
      return _this.handleParsed.apply(_this, arguments);
    });
    this.buttonLabels = [];

    this.reset();

    this._lastLoad = Date.now();
    this.loadTimer();

    window.showPage();
  }

  _createClass(ScrollingTerminal, [{
    key: 'reset',
    value: function reset() {
      this.style = TERM_DEFAULT_STYLE.slice();
      this.cursor = { x: 0, y: 0, style: 1, visible: true };
      this.trackMouse = false;
      this.theme = 0;
      this.defaultFG = 7;
      this.defaultBG = 0;
      this.rainbow = this.superRainbow = false;
      this.parser.reset();
      this.clear();
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.screen = [];
      for (var i = 0; i < this.width * this.height; i++) {
        this.screen.push([' ', this.style.slice()]);
      }
    }
  }, {
    key: 'scroll',
    value: function scroll() {
      this.screen.splice(0, this.width);
      for (var i = 0; i < this.width; i++) {
        this.screen.push([' ', TERM_DEFAULT_STYLE.slice()]);
      }
      this.cursor.y--;
    }
  }, {
    key: 'newLine',
    value: function newLine() {
      this.cursor.y++;
      if (this.cursor.y >= this.height) this.scroll();
    }
  }, {
    key: 'writeChar',
    value: function writeChar(character) {
      this.screen[this.cursor.y * this.width + this.cursor.x] = [character, this.style.slice()];
      this.cursor.x++;
      if (this.cursor.x >= this.width) {
        this.cursor.x = 0;
        this.newLine();
      }
    }
  }, {
    key: 'moveBack',
    value: function moveBack() {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      for (var i = 0; i < n; i++) {
        this.cursor.x--;
        if (this.cursor.x < 0) {
          if (this.cursor.y > 0) this.cursor.x = this.width - 1;else this.cursor.x = 0;
          this.cursor.y = Math.max(0, this.cursor.y - 1);
        }
      }
    }
  }, {
    key: 'moveForward',
    value: function moveForward() {
      var n = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;

      for (var i = 0; i < n; i++) {
        this.cursor.x++;
        if (this.cursor.x >= this.width) {
          this.cursor.x = 0;
          this.cursor.y++;
          if (this.cursor.y >= this.height) this.scroll();
        }
      }
    }
  }, {
    key: 'deleteChar',
    value: function deleteChar() {
      // FIXME unused?
      this.moveBack();
      this.screen.splice((this.cursor.y + 1) * this.width, 0, [' ', TERM_DEFAULT_STYLE.slice()]);
      this.screen.splice(this.cursor.y * this.width + this.cursor.x, 1);
    }
  }, {
    key: 'deleteForward',
    value: function deleteForward(n) {
      n = Math.min(this.width, n);
      for (var i = 0; i < n; i++) {
        this.screen.splice((this.cursor.y + 1) * this.width, 0, [' ', TERM_DEFAULT_STYLE.slice()]);
      }this.screen.splice(this.cursor.y * this.width + this.cursor.x, n);
    }
  }, {
    key: 'clampCursor',
    value: function clampCursor() {
      if (this.cursor.x < 0) this.cursor.x = 0;
      if (this.cursor.y < 0) this.cursor.y = 0;
      if (this.cursor.x > this.width - 1) this.cursor.x = this.width - 1;
      if (this.cursor.y > this.height - 1) this.cursor.y = this.height - 1;
    }
  }, {
    key: 'handleParsed',
    value: function handleParsed(action) {
      if (action === 'write') {
        this.writeChar(arguments.length <= 1 ? undefined : arguments[1]);
      } else if (action === 'delete') {
        this.deleteForward(arguments.length <= 1 ? undefined : arguments[1]);
      } else if (action === 'insert-blanks') {
        this.insertBlanks(arguments.length <= 1 ? undefined : arguments[1]); // FIXME undefined?
      } else if (action === 'clear') {
        this.clear();
      } else if (action === 'bell') {
        this.termScreen.load('U\x01B');
      } else if (action === 'back') {
        this.moveBack();
      } else if (action === 'new-line') {
        this.newLine();
        this.cursor.x = 0;
      } else if (action === 'return') {
        this.cursor.x = 0;
      } else if (action === 'set-cursor') {
        this.cursor.x = arguments.length <= 2 ? undefined : arguments[2];
        this.cursor.y = arguments.length <= 1 ? undefined : arguments[1];
        this.clampCursor();
      } else if (action === 'move-cursor-y') {
        this.cursor.y += arguments.length <= 1 ? undefined : arguments[1];
        this.clampCursor();
      } else if (action === 'move-cursor-x') {
        this.cursor.x += arguments.length <= 1 ? undefined : arguments[1];
        this.clampCursor();
      } else if (action === 'move-cursor-line') {
        this.cursor.x = 0;
        this.cursor.y += arguments.length <= 1 ? undefined : arguments[1];
        this.clampCursor();
      } else if (action === 'set-cursor-x') {
        this.cursor.x = arguments.length <= 1 ? undefined : arguments[1];
      } else if (action === 'set-cursor-style') {
        this.cursor.style = Math.max(0, Math.min(6, arguments.length <= 1 ? undefined : arguments[1]));
      } else if (action === 'reset-style') {
        this.style = TERM_DEFAULT_STYLE.slice();
      } else if (action === 'add-attrs') {
        this.style[2] |= arguments.length <= 1 ? undefined : arguments[1];
      } else if (action === 'set-color-fg') {
        this.style[0] = arguments.length <= 1 ? undefined : arguments[1];
        this.style[2] |= 1;
      } else if (action === 'set-color-bg') {
        this.style[1] = arguments.length <= 1 ? undefined : arguments[1];
        this.style[2] |= 1 << 1;
      } else if (action === 'reset-color-fg') {
        this.style[0] = 0;
        if (this.style[2] & 1) this.style[2] ^= 1;
      } else if (action === 'reset-color-bg') {
        this.style[1] = 0;
        if (this.style[2] & 1 << 1) this.style[2] ^= 1 << 1;
      } else if (action === 'hide-cursor') {
        this.cursor.visible = false;
      } else if (action === 'show-cursor') {
        this.cursor.visible = true;
      }
    }
  }, {
    key: 'write',
    value: function write(text) {
      this.parser.write(text);
    }
  }, {
    key: 'getScreenOpts',
    value: function getScreenOpts() {
      var data = 'O';
      data += encodeAsCodePoint(25);
      data += encodeAsCodePoint(80);
      data += encodeAsCodePoint(this.theme);
      data += this.encodeColor(this.defaultFG);
      data += this.encodeColor(this.defaultBG);
      var attributes = +this.cursor.visible;
      attributes |= (3 << 5) * +this.trackMouse; // track mouse controls both
      attributes |= 3 << 7; // buttons/links always visible
      attributes |= this.cursor.style << 9;
      data += encodeAsCodePoint(attributes);
      return data;
    }
  }, {
    key: 'getButtons',
    value: function getButtons() {
      var data = 'B';
      data += encodeAsCodePoint(this.buttonLabels.length);
      data += this.buttonLabels.map(function (x) {
        return '\x01' + x + '\x01';
      }).join('');
      return data;
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      return 'TESPTerm Web UI Demo\x01';
    }
  }, {
    key: 'getCursor',
    value: function getCursor() {
      var data = 'C';
      data += encodeAsCodePoint(this.cursor.y);
      data += encodeAsCodePoint(this.cursor.x);
      data += encodeAsCodePoint(0);
      return data;
    }
  }, {
    key: 'encodeColor',
    value: function encodeColor(color) {
      if (color < 256) {
        return encodeAsCodePoint(color);
      } else {
        color -= 256;
        return encodeAsCodePoint(color & 0xFFF | 0x10000) + encodeAsCodePoint(color >> 12);
      }
    }
  }, {
    key: 'serializeScreen',
    value: function serializeScreen() {
      var serialized = 'S';
      serialized += encodeAsCodePoint(0) + encodeAsCodePoint(0);
      serialized += encodeAsCodePoint(this.height) + encodeAsCodePoint(this.width);

      var lastStyle = [null, null, null];
      var index = 0;
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = this.screen[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var cell = _step2.value;

          var style = cell[1].slice();
          if (this.rainbow) {
            var x = index % this.width;
            var y = Math.floor(index / this.width);
            // C instead of F in mask and 1 << 8 in attrs to change attr bits 1 and 2
            var t = (x + y) / 10 + Date.now() / 1000;
            if (this.superRainbow) {
              t = (x * y + Date.now()) / 100 + Date.now() / 1000;
            }
            style[0] = getRainbowColor(t);
            style[1] = 0;
            if (this.superRainbow) style[1] = getRainbowColor(t / 10);
            style[2] = style[2] | 1;
            if (!this.superRainbow && style[2] & 1 << 1) style[2] ^= 1 << 1;
            index++;
          }

          var foreground = style[0];
          var background = style[1];
          var attributes = style[2];
          var setForeground = foreground !== lastStyle[0];
          var setBackground = background !== lastStyle[1];
          var setAttributes = attributes !== lastStyle[2];

          if (setForeground && setBackground) {
            if (foreground < 256 && background < 256) {
              serialized += '\x03' + encodeAsCodePoint(background << 8 | foreground);
            } else {
              serialized += '\x05' + this.encodeColor(foreground);
              serialized += '\x06' + this.encodeColor(background);
            }
          } else if (setForeground) serialized += '\x05' + this.encodeColor(foreground);else if (setBackground) serialized += '\x06' + this.encodeColor(background);
          if (setAttributes) serialized += '\x04' + encodeAsCodePoint(attributes);
          lastStyle = style;

          serialized += cell[0];
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return serialized;
    }
  }, {
    key: 'getUpdate',
    value: function getUpdate() {
      var topics = 0;
      var topicData = [];
      var screenOpts = this.getScreenOpts();
      var title = this.getTitle();
      var buttons = this.getButtons();
      var cursor = this.getCursor();
      var screen = this.serializeScreen();
      if (this._screenOpts !== screenOpts) {
        this._screenOpts = screenOpts;
        topicData.push(screenOpts);
      }
      if (this._title !== title) {
        this._title = title;
        topicData.push(title);
      }
      if (this._buttons !== buttons) {
        this._buttons = buttons;
        topicData.push(buttons);
      }
      if (this._cursor !== cursor) {
        this._cursor = cursor;
        topicData.push(cursor);
      }
      if (this._screen !== screen) {
        this._screen = screen;
        topicData.push(screen);
      }
      if (!topicData.length) return '';
      return 'U' + encodeAsCodePoint(topics) + topicData.join('');
    }
  }, {
    key: 'loadTimer',
    value: function loadTimer() {
      var _this2 = this;

      clearInterval(this._loadTimer);
      this._loadTimer = setInterval(function () {
        var update = _this2.getUpdate();
        if (update) _this2.termScreen.load(update);
      }, 30);
    }
  }]);

  return ScrollingTerminal;
}();

var Process = function (_EventEmitter) {
  _inherits(Process, _EventEmitter);

  function Process() {
    _classCallCheck(this, Process);

    return _possibleConstructorReturn(this, (Process.__proto__ || Object.getPrototypeOf(Process)).apply(this, arguments));
  }

  _createClass(Process, [{
    key: 'write',
    value: function write(data) {
      this.emit('in', data);
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      // death.
      this.emit('exit', 0);
    }
  }, {
    key: 'run',
    value: function run() {
      // noop
    }
  }]);

  return Process;
}(EventEmitter);

var demoData = {
  buttons: [],
  mouseReceiver: null
};

var demoshIndex = {
  clear: function (_Process) {
    _inherits(Clear, _Process);

    function Clear() {
      _classCallCheck(this, Clear);

      return _possibleConstructorReturn(this, (Clear.__proto__ || Object.getPrototypeOf(Clear)).apply(this, arguments));
    }

    _createClass(Clear, [{
      key: 'run',
      value: function run() {
        this.emit('write', '\x1b[2J\x1b[1;1H');
        this.destroy();
      }
    }]);

    return Clear;
  }(Process),
  screenfetch: function (_Process2) {
    _inherits(Screenfetch, _Process2);

    function Screenfetch() {
      _classCallCheck(this, Screenfetch);

      return _possibleConstructorReturn(this, (Screenfetch.__proto__ || Object.getPrototypeOf(Screenfetch)).apply(this, arguments));
    }

    _createClass(Screenfetch, [{
      key: 'run',
      value: function run() {
        var _this6 = this;

        var image = ('\n ###.                          ESPTerm Demo\n   \'###.                       Hostname: ' + window.location.hostname + '\n     \'###.                     Shell: ESPTerm Demo Shell\n       \'###.                   Resolution: 80x25@' + window.devicePixelRatio + 'x\n         :###-\n       .###\'\n     .###\'\n   .###\'      ###############\n ###\'         ###############\n      ').split('\n').filter(function (line) {
          return line.trim();
        });

        var chars = '';
        for (var y = 0; y < image.length; y++) {
          for (var x = 0; x < 80; x++) {
            if (image[y][x]) {
              chars += '\x1B[38;5;' + getRainbowColor((x + y) / 10) + 'm' + image[y][x];
            } else chars += ' ';
          }
        }

        this.emit('write', '\r\n\x1b[?25l');
        var loop = function loop() {
          _this6.emit('write', chars.substr(0, 80));
          chars = chars.substr(80);
          if (chars.length) setTimeout(loop, 50);else {
            _this6.emit('write', '\r\n\x1b[?25h');
            _this6.destroy();
          }
        };
        loop();
      }
    }]);

    return Screenfetch;
  }(Process),
  'local-echo': function (_Process3) {
    _inherits(LocalEcho, _Process3);

    function LocalEcho() {
      _classCallCheck(this, LocalEcho);

      return _possibleConstructorReturn(this, (LocalEcho.__proto__ || Object.getPrototypeOf(LocalEcho)).apply(this, arguments));
    }

    _createClass(LocalEcho, [{
      key: 'run',
      value: function run() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        if (!args.includes('--suppress-note')) {
          this.emit('write', '\x1b[38;5;239mNote: not all terminal features are supported and may not work as expected in this demo\x1b[m\n');
        }
        this.emit('buttons', [{
          label: 'Exit',
          action: function action(shell) {
            shell.write('\x03');
          }
        }]);
      }
    }, {
      key: 'write',
      value: function write(data) {
        this.emit('write', data);
      }
    }]);

    return LocalEcho;
  }(Process),
  info: function (_Process4) {
    _inherits(Info, _Process4);

    function Info() {
      _classCallCheck(this, Info);

      return _possibleConstructorReturn(this, (Info.__proto__ || Object.getPrototypeOf(Info)).apply(this, arguments));
    }

    _createClass(Info, [{
      key: 'run',
      value: function run() {
        var _this9 = this;

        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var fast = args.includes('--fast');
        this.showSplash().then(function () {
          _this9.printText(fast);
        });
      }
    }, {
      key: 'showSplash',
      value: function showSplash() {
        var _this10 = this;

        var splash = '\n              -#####- -###*..#####- ######-\n              -#*    -#-    .## .##.  *#-\n              -##### .-###*..#####-   *#-  -*##*- #*-#--#**#-*##-\n              -#*        -#-.##.      *#-  *##@#* ##.  -#* *# .#*\n              -#####--####- .##.      *#-  -*#@@- ##.  -#* *# .#*\n      '.split('\n').filter(function (line) {
          return line.trim();
        });
        var levels = {
          ' ': -231,
          '.': 4,
          '-': 8,
          '*': 17,
          '#': 24
        };
        var characters = {
          ' ': ' ',
          '.': '░',
          '-': '▒',
          '*': '▓',
          '#': '█'
        };
        for (var i in splash) {
          if (splash[i].length < 79) splash[i] += ' '.repeat(79 - splash[i].length);
        }
        this.emit('write', '\r\n'.repeat(splash.length + 1));
        this.emit('write', '\x1b[A'.repeat(splash.length));
        this.emit('write', '\x1b[?25l');

        var cursorX = 0;
        var cursorY = 0;
        var moveTo = function moveTo(x, y) {
          var moveX = x - cursorX;
          var moveY = y - cursorY;
          _this10.emit('write', '\x1B[' + Math.abs(moveX) + (moveX > 0 ? 'C' : 'D'));
          _this10.emit('write', '\x1B[' + Math.abs(moveY) + (moveY > 0 ? 'B' : 'A'));
          cursorX = x;
          cursorY = y;
        };
        var drawCell = function drawCell(x, y) {
          moveTo(x, y);
          if (splash[y][x] === '@') {
            _this10.emit('write', '\x1b[48;5;238m\x1b[38;5;255m▄\b');
          } else {
            var level = 231 + levels[splash[y][x]];
            var character = characters[splash[y][x]];
            _this10.emit('write', '\x1B[48;5;' + level + 'm\x1B[38;5;' + level + 'm' + character + '\b');
          }
        };
        return new Promise(function (resolve, reject) {
          var self = _this10;
          var x = 13;
          var cycles = 0;
          var loop = function loop() {
            for (var y = 0; y < splash.length; y++) {
              var dx = x - y;
              if (dx > 0) drawCell(dx, y);
            }

            if (++x < 70) {
              if (++cycles >= 3) {
                setTimeout(loop, 50);
                cycles = 0;
              } else loop();
            } else {
              moveTo(0, splash.length);
              self.emit('write', '\x1b[m\x1b[?25h');
              resolve();
            }
          };
          loop();
        });
      }
    }, {
      key: 'printText',
      value: function printText() {
        var fast = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

        // lots of printing
        var parts = ['', '  ESPTerm is a VT100-like terminal emulator running on the ESP8266 WiFi chip.', '', '  \x1b[93mThis is an online demo of the web user interface, simulating a simple ', '  terminal in your browser.\x1b[m', '', '  Type \x1b[92mls\x1b[m to list available commands.', '  Use the \x1b[94mlinks\x1b[m below this screen for a demo of the options and more info.', ''];

        if (fast) {
          this.emit('write', parts.join('\r\n') + '\r\n');
          this.destroy();
        } else {
          var self = this;
          var loop = function loop() {
            self.emit('write', parts.shift() + '\r\n');
            if (parts.length) setTimeout(loop, 17);else self.destroy();
          };
          loop();
        }
      }
    }]);

    return Info;
  }(Process),
  colors: function (_Process5) {
    _inherits(PrintColors, _Process5);

    function PrintColors() {
      _classCallCheck(this, PrintColors);

      return _possibleConstructorReturn(this, (PrintColors.__proto__ || Object.getPrototypeOf(PrintColors)).apply(this, arguments));
    }

    _createClass(PrintColors, [{
      key: 'run',
      value: function run() {
        this.emit('write', '\r\n');
        var fgtext = 'foreground-color';
        this.emit('write', '    ');
        for (var i = 0; i < 16; i++) {
          this.emit('write', '\x1b[' + (i < 8 ? '3' + i : '9' + (i - 8)) + 'm');
          this.emit('write', fgtext[i] + ' ');
        }
        this.emit('write', '\r\n    ');
        for (var _i = 0; _i < 16; _i++) {
          this.emit('write', '\x1b[' + (_i < 8 ? '4' + _i : '10' + (_i - 8)) + 'm  ');
        }
        this.emit('write', '\x1b[m\r\n');
        for (var r = 0; r < 6; r++) {
          this.emit('write', '    ');
          for (var g = 0; g < 6; g++) {
            for (var b = 0; b < 6; b++) {
              this.emit('write', '\x1B[48;5;' + (16 + r * 36 + g * 6 + b) + 'm  ');
            }
            this.emit('write', '\x1b[m');
          }
          this.emit('write', '\r\n');
        }
        this.emit('write', '    ');
        for (var _g = 0; _g < 24; _g++) {
          this.emit('write', '\x1B[48;5;' + (232 + _g) + 'm  ');
        }
        this.emit('write', '\x1b[m\r\n\n');
        this.destroy();
      }
    }]);

    return PrintColors;
  }(Process),
  ls: function (_Process6) {
    _inherits(ListCommands, _Process6);

    function ListCommands() {
      _classCallCheck(this, ListCommands);

      return _possibleConstructorReturn(this, (ListCommands.__proto__ || Object.getPrototypeOf(ListCommands)).apply(this, arguments));
    }

    _createClass(ListCommands, [{
      key: 'run',
      value: function run() {
        this.emit('write', '\x1b[92mList of demo commands\x1b[m\r\n');
        for (var i in demoshIndex) {
          if (typeof demoshIndex[i] === 'string') continue;
          this.emit('write', i + '\r\n');
        }
        this.destroy();
      }
    }]);

    return ListCommands;
  }(Process),
  theme: function (_Process7) {
    _inherits(SetTheme, _Process7);

    function SetTheme(shell) {
      _classCallCheck(this, SetTheme);

      var _this13 = _possibleConstructorReturn(this, (SetTheme.__proto__ || Object.getPrototypeOf(SetTheme)).call(this));

      _this13.shell = shell;
      return _this13;
    }

    _createClass(SetTheme, [{
      key: 'run',
      value: function run() {
        var theme = +(arguments.length <= 0 ? undefined : arguments[0]) | 0;
        var maxnum = themes.length;
        if (!arguments.length || !Number.isFinite(theme) || theme < 0 || theme >= maxnum) {
          this.emit('write', '\x1B[31mUsage: theme [0\u2013' + (maxnum - 1) + ']\n');
          this.destroy();
          return;
        }
        this.shell.terminal.theme = theme;
        // HACK: reset drawn screen to prevent only partly redrawn screen
        this.shell.terminal.termScreen.drawnScreenFG = [];
        this.emit('write', '');
        this.destroy();
      }
    }]);

    return SetTheme;
  }(Process),
  themes: function (_Process8) {
    _inherits(ShowThemes, _Process8);

    function ShowThemes(shell) {
      _classCallCheck(this, ShowThemes);

      var _this14 = _possibleConstructorReturn(this, (ShowThemes.__proto__ || Object.getPrototypeOf(ShowThemes)).call(this));

      _this14.shell = shell;
      _this14.parser = new ANSIParser(function () {
        return _this14.handler.apply(_this14, arguments);
      });
      return _this14;
    }

    _createClass(ShowThemes, [{
      key: 'destroy',
      value: function destroy() {
        this.shell.terminal.cursor.style = this.savedCursorStyle;
        this.emit('write', '\n\n');
        _get(ShowThemes.prototype.__proto__ || Object.getPrototypeOf(ShowThemes.prototype), 'destroy', this).call(this);
      }
    }, {
      key: 'run',
      value: function run() {
        var _this15 = this;

        this.savedCursorStyle = this.shell.terminal.cursor.style;
        this.shell.terminal.cursor.style = 3;

        this.fgType = 0;
        this.bgType = 0;

        var get24FG = function get24FG() {
          return _this15.shell.terminal.defaultFG - 256;
        };
        var set24FG = function set24FG(v) {
          _this15.shell.terminal.defaultFG = v + 256;
        };
        var get24BG = function get24BG() {
          return _this15.shell.terminal.defaultBG - 256;
        };
        var set24BG = function set24BG(v) {
          _this15.shell.terminal.defaultBG = v + 256;
        };

        var make24Control = function make24Control(label, index, _getValue, _setValue, type) {
          index *= 4;

          return {
            label: label,
            length: 1,
            getValue: function getValue() {
              return _getValue() >> index & 0xF;
            },
            getDisplay: function getDisplay() {
              return (_getValue() >> index & 0xF).toString(16);
            },
            setValue: function setValue(value) {
              _setValue(_getValue() & (0xFFFFFF ^ 0xF << index) | (value & 0xF) << index);
            },
            shouldShow: function shouldShow() {
              return _this15[type + 'Type'] === 1;
            },
            parseValue: function parseValue(input) {
              return parseInt(input, 16) & 0xF;
            },
            moveAfterInput: index !== 0
          };
        };

        this.controls = [{
          label: 'Theme: ',
          length: themes.length.toString().length,
          getValue: function getValue() {
            return _this15.shell.terminal.theme;
          },
          setValue: function setValue(value) {
            var count = themes.length;
            _this15.shell.terminal.theme = (value % count + count) % count;
          }
        }, {
          label: ' Default Foreground: ',
          length: 6,
          getValue: function getValue() {
            return _this15.fgType;
          },
          getDisplay: function getDisplay() {
            return _this15.fgType === 0 ? '256' : '24-bit';
          },
          setValue: function setValue(value) {
            _this15.fgType = (value % 2 + 2) % 2;
          }
        }, {
          label: ' ',
          length: 3,
          getValue: function getValue() {
            return _this15.shell.terminal.defaultFG & 0xFF;
          },
          setValue: function setValue(value) {
            _this15.shell.terminal.defaultFG = value & 0xFF;
          },
          shouldShow: function shouldShow() {
            return _this15.fgType === 0;
          },
          parseValue: function parseValue(input) {
            return parseInt(input, 16);
          }
        }, make24Control(' #', 5, get24FG, set24FG, 'fg'), make24Control('', 4, get24FG, set24FG, 'fg'), make24Control('', 3, get24FG, set24FG, 'fg'), make24Control('', 2, get24FG, set24FG, 'fg'), make24Control('', 1, get24FG, set24FG, 'fg'), make24Control('', 0, get24FG, set24FG, 'fg'), {
          label: ' Default Background: ',
          length: 6,
          getValue: function getValue() {
            return _this15.bgType;
          },
          getDisplay: function getDisplay() {
            return _this15.bgType === 0 ? '256' : '24-bit';
          },
          setValue: function setValue(value) {
            _this15.bgType = (value % 2 + 2) % 2;
          }
        }, {
          label: ' ',
          length: 3,
          getValue: function getValue() {
            return _this15.shell.terminal.defaultBG & 0xFF;
          },
          setValue: function setValue(value) {
            _this15.shell.terminal.defaultBG = value & 0xFF;
          },
          shouldShow: function shouldShow() {
            return _this15.bgType === 0;
          },
          parseValue: function parseValue(input) {
            return parseInt(input, 16);
          }
        }, make24Control(' #', 5, get24BG, set24BG, 'bg'), make24Control('', 4, get24BG, set24BG, 'bg'), make24Control('', 3, get24BG, set24BG, 'bg'), make24Control('', 2, get24BG, set24BG, 'bg'), make24Control('', 1, get24BG, set24BG, 'bg'), make24Control('', 0, get24BG, set24BG, 'bg')];
        this.selection = 0;

        this.emit('write', '\x1b[1mThemes\x1b[m\n\n\n\n\x1b[2A');

        this.render();
      }
    }, {
      key: 'render',
      value: function render() {
        this.emit('write', '\x1b[m\r');
        // no ^[2K implementation, here's a hack
        this.emit('write', ' '.repeat(this.shell.terminal.width - 1) + '\r');

        var index = 0;
        var selectedX = 0;
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = this.controls[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var control = _step3.value;

            if (control.shouldShow && !control.shouldShow()) continue;
            if (control.label) {
              this.emit('write', '\x1B[1m' + control.label + '\x1B[m');
            }
            // TODO: colors
            this.emit('write', '\x1b[38;5;255m\x1b[48;5;16m');
            var value = control.getDisplay ? control.getDisplay() : control.getValue().toString();
            this.emit('write', (control.fill || ' ').repeat(Math.max(0, control.length - value.length)));
            this.emit('write', value.substr(0, control.length));
            this.emit('write', '\x1b[m');

            if (index === this.selection) {
              selectedX = this.shell.terminal.cursor.x - 1;

              // draw arrows
              this.emit('write', '\x1b[m\x1b[D\x1b[A▲\x1b[D\x1b[2B▼\x1b[A');
            } else {
              // clear arrows if they were there
              this.emit('write', '\x1b[m\x1b[D\x1b[A \x1b[D\x1b[2B \x1b[A');
            }

            index++;
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        this.shell.terminal.cursor.x = selectedX;
      }
    }, {
      key: 'write',
      value: function write(data) {
        this.parser.write(data);
      }
    }, {
      key: 'getControlCount',
      value: function getControlCount() {
        var count = 0;
        var _iteratorNormalCompletion4 = true;
        var _didIteratorError4 = false;
        var _iteratorError4 = undefined;

        try {
          for (var _iterator4 = this.controls[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
            var control = _step4.value;

            if (control.shouldShow && !control.shouldShow()) continue;
            count++;
          }
        } catch (err) {
          _didIteratorError4 = true;
          _iteratorError4 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion4 && _iterator4.return) {
              _iterator4.return();
            }
          } finally {
            if (_didIteratorError4) {
              throw _iteratorError4;
            }
          }
        }

        return count;
      }
    }, {
      key: 'getSelectedControl',
      value: function getSelectedControl() {
        var selected = null;
        var index = 0;
        var _iteratorNormalCompletion5 = true;
        var _didIteratorError5 = false;
        var _iteratorError5 = undefined;

        try {
          for (var _iterator5 = this.controls[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
            var control = _step5.value;

            if (control.shouldShow && !control.shouldShow()) continue;
            if (index === this.selection) {
              selected = control;
              break;
            }
            index++;
          }
        } catch (err) {
          _didIteratorError5 = true;
          _iteratorError5 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion5 && _iterator5.return) {
              _iterator5.return();
            }
          } finally {
            if (_didIteratorError5) {
              throw _iteratorError5;
            }
          }
        }

        return selected;
      }
    }, {
      key: 'handler',
      value: function handler(action) {
        var _console;

        for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
          args[_key3 - 1] = arguments[_key3];
        }

        (_console = console).log.apply(_console, [action].concat(args));

        if (action === 'move-cursor-x') {
          this.selection += args[0];
          var count = this.getControlCount();
          this.selection = (this.selection % count + count) % count;
        } else if (action === 'move-cursor-y') {
          var control = this.getSelectedControl();
          if (control) control.setValue(control.getValue() - args[0]);
        } else if (action === 'write') {
          var _control = this.getSelectedControl();
          if (_control && _control.parseValue) {
            var parsed = _control.parseValue(args[0]);
            if (Number.isFinite(parsed)) {
              _control.setValue(parsed);
              if (_control.moveAfterInput) {
                if (this.selection < this.getControlCount() - 1) this.selection++;
              }
            }
          }
        }

        this.render();
      }
    }]);

    return ShowThemes;
  }(Process),
  cursor: function (_Process9) {
    _inherits(SetCursor, _Process9);

    function SetCursor() {
      _classCallCheck(this, SetCursor);

      return _possibleConstructorReturn(this, (SetCursor.__proto__ || Object.getPrototypeOf(SetCursor)).apply(this, arguments));
    }

    _createClass(SetCursor, [{
      key: 'run',
      value: function run() {
        for (var _len4 = arguments.length, args = Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
          args[_key4] = arguments[_key4];
        }

        var steady = args.includes('--steady');
        if (args.includes('block')) {
          this.emit('write', '\x1B[' + 2 * steady + ' q');
        } else if (args.includes('line')) {
          this.emit('write', '\x1B[' + (3 + steady) + ' q');
        } else if (args.includes('bar') || args.includes('beam')) {
          this.emit('write', '\x1B[' + (5 + steady) + ' q');
        } else {
          this.emit('write', '\x1b[31mUsage: cursor [block|line|bar] [--steady]\r\n');
        }
        this.destroy();
      }
    }]);

    return SetCursor;
  }(Process),
  rainbow: function (_Process10) {
    _inherits(ToggleRainbow, _Process10);

    function ToggleRainbow(shell) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, ToggleRainbow);

      var _this17 = _possibleConstructorReturn(this, (ToggleRainbow.__proto__ || Object.getPrototypeOf(ToggleRainbow)).call(this));

      _this17.shell = shell;
      _this17.su = options.su;
      _this17.abort = false;
      return _this17;
    }

    _createClass(ToggleRainbow, [{
      key: 'write',
      value: function write(data) {
        var newLine = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

        if (data === 'y') {
          this.shell.terminal.rainbow = !this.shell.terminal.rainbow;
          this.shell.terminal.superRainbow = true;
          demoData._didWarnRainbow = true;
        } else {
          this.emit('write', data);
        }
        if (newLine) this.emit('write', '\x1b[0;32m\x1b[G\x1b[79PRainbow!\n');
        this.destroy();
      }
    }, {
      key: 'run',
      value: function run() {
        if (this.su && !this.shell.terminal.rainbow) {
          if (!demoData._didWarnRainbow) {
            this.emit('write', '\x1b[31;1mWarning: flashy colors. Continue? [y/N] ');
          } else {
            this.write('y', false);
          }
        } else {
          this.shell.terminal.rainbow = !this.shell.terminal.rainbow;
          this.shell.terminal.superRainbow = false;
          this.destroy();
        }
      }
    }, {
      key: 'destroy',
      value: function destroy() {
        this.abort = true;
        _get(ToggleRainbow.prototype.__proto__ || Object.getPrototypeOf(ToggleRainbow.prototype), 'destroy', this).call(this);
      }
    }]);

    return ToggleRainbow;
  }(Process),
  mouse: function (_Process11) {
    _inherits(MouseDemo, _Process11);

    function MouseDemo(shell) {
      _classCallCheck(this, MouseDemo);

      var _this18 = _possibleConstructorReturn(this, (MouseDemo.__proto__ || Object.getPrototypeOf(MouseDemo)).call(this));

      _this18.shell = shell;
      return _this18;
    }

    _createClass(MouseDemo, [{
      key: 'run',
      value: function run() {
        var _this19 = this;

        var self = this;
        this.emit('buttons', [{
          label: 'Exit',
          action: function action(shell) {
            shell.write('\x03');
          }
        }, {
          label: 'Add Box',
          action: function action() {
            self.boxes.push(self.generateRandomBox());
            self.render();
          }
        }]);

        this.shell.terminal.trackMouse = true;
        demoData.mouseReceiver = this;

        this.boxes = Array(3).fill(0).map(function (x) {
          return _this19.generateRandomBox();
        });
        this.grabbedBox = null;
        this.grabOffset = [0, 0];

        this.render();
      }
    }, {
      key: 'render',
      value: function render() {
        this.emit('write', '\x1b[m\x1b[2J\x1b[1;1H');
        this.emit('write', '\x1b[97m\x1b[1mMouse Demo\r\n\x1b[mMove boxes around or scroll their contents!');

        // draw boxes
        var _iteratorNormalCompletion6 = true;
        var _didIteratorError6 = false;
        var _iteratorError6 = undefined;

        try {
          for (var _iterator6 = this.boxes[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
            var box = _step6.value;

            this.emit('write', '\x1B[' + (box.y + 1) + ';' + (box.x + 1) + 'H');
            this.emit('write', '\x1B[m\x1B[48;2;' + box.color.join(';') + 'm');
            for (var y = box.y; y < box.y + box.height; y++) {
              var drawnX = 0;
              for (var x = box.x; x < box.x + box.width; x++) {
                if (x < 0 || x >= this.shell.terminal.width - 1) continue;
                if (y < 0 || y >= this.shell.terminal.height) continue;
                drawnX++;
                this.emit('write', box.content[y - box.y][x - box.x]);
              }
              this.emit('write', '\x1b[D'.repeat(drawnX) + '\x1b[B');
            }
          }

          // move cursor to mouse
        } catch (err) {
          _didIteratorError6 = true;
          _iteratorError6 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion6 && _iterator6.return) {
              _iterator6.return();
            }
          } finally {
            if (_didIteratorError6) {
              throw _iteratorError6;
            }
          }
        }

        if (this.mouse) {
          this.emit('write', '\x1B[' + (this.mouse.y + 1) + ';' + (this.mouse.x + 1) + 'H');
        }
      }
    }, {
      key: 'generateRandomBox',
      value: function generateRandomBox() {
        var chars = 'abcdefghijklmnopqrstuvwxyz-*()!@#$%';
        var content = [];
        var width = [5, 10, 15][Math.floor(Math.random() * 3)];
        var height = [4, 5, 6][Math.floor(Math.random() * 3)];

        for (var y = 0; y < height; y++) {
          content.push('');
          for (var x = 0; x < width; x++) {
            if (Math.random() > 0.6) {
              content[y] += chars[Math.floor(Math.random() * chars.length)];
            } else content[y] += ' ';
          }
        }

        return {
          x: Math.floor(Math.random() * (this.shell.terminal.width - 1)) + 1,
          y: Math.floor(Math.random() * (this.shell.terminal.height - 1)) + 1,
          width: width,
          height: height,
          color: [Math.random(), Math.random(), Math.random()].map(function (x) {
            return Math.floor(x * 255);
          }),
          content: content
        };
      }
    }, {
      key: 'getBoxAt',
      value: function getBoxAt(x, y) {
        var boxes = this.boxes.slice().reverse(); // top to bottom, like drawing order
        var _iteratorNormalCompletion7 = true;
        var _didIteratorError7 = false;
        var _iteratorError7 = undefined;

        try {
          for (var _iterator7 = boxes[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
            var box = _step7.value;

            if (box.x <= x && box.x + box.width > x && box.y <= y && box.y + box.height > y) {
              return box;
            }
          }
        } catch (err) {
          _didIteratorError7 = true;
          _iteratorError7 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion7 && _iterator7.return) {
              _iterator7.return();
            }
          } finally {
            if (_didIteratorError7) {
              throw _iteratorError7;
            }
          }
        }
      }
    }, {
      key: 'mouseMove',
      value: function mouseMove(x, y) {
        this.mouse = { x: x, y: y };
        if (this.grabbedBox) {
          this.grabbedBox.x = x + this.grabOffset[0];
          this.grabbedBox.y = y + this.grabOffset[1];
        }
        this.render();
      }
    }, {
      key: 'mouseDown',
      value: function mouseDown(x, y, button) {
        if (button === 4) this.scrollInsideBox(this.getBoxAt(x, y), -1);else if (button === 5) this.scrollInsideBox(this.getBoxAt(x, y), 1);else {
          var box = this.getBoxAt(x, y);
          if (box) {
            var _boxes;

            this.grabbedBox = box;
            this.grabOffset = [box.x - x, box.y - y];
            // move grabbed box to top of stack
            (_boxes = this.boxes).push.apply(_boxes, _toConsumableArray(this.boxes.splice(this.boxes.indexOf(box), 1)));
          }
        }
        this.render();
      }
    }, {
      key: 'mouseUp',
      value: function mouseUp(x, y, button) {
        this.grabbedBox = null;
      }
    }, {
      key: 'scrollInsideBox',
      value: function scrollInsideBox(box, amount) {
        if (!box) return;
        var content = box.content.slice();
        box.content = [];
        for (var i = 0; i < content.length; i++) {
          box.content.push(content[(i + amount % content.length + content.length) % content.length]);
        }
      }
    }, {
      key: 'destroy',
      value: function destroy() {
        this.shell.terminal.write('\x1b[m\x1b[2J\x1b[1;1H');
        this.shell.terminal.trackMouse = false;
        if (demoData.mouseReceiver === this) demoData.mouseReceiver = null;
        _get(MouseDemo.prototype.__proto__ || Object.getPrototypeOf(MouseDemo.prototype), 'destroy', this).call(this);
      }
    }]);

    return MouseDemo;
  }(Process),
  sudo: function (_Process12) {
    _inherits(Sudo, _Process12);

    function Sudo(shell) {
      _classCallCheck(this, Sudo);

      var _this20 = _possibleConstructorReturn(this, (Sudo.__proto__ || Object.getPrototypeOf(Sudo)).call(this));

      _this20.shell = shell;
      _this20.didDestroy = false;
      return _this20;
    }

    _createClass(Sudo, [{
      key: 'run',
      value: function run() {
        var _this21 = this;

        for (var _len5 = arguments.length, args = Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
          args[_key5] = arguments[_key5];
        }

        if (args.length === 0) {
          this.emit('write', '\x1b[31mUsage: sudo [command]\x1b[m\r\n');
          this.destroy();
        } else {
          var name = args.shift();
          if (this.shell.index[name]) {
            var _Process13 = this.shell.index[name];
            if (_Process13 instanceof Function) {
              var child = this.child = new _Process13(this.shell, { su: true });
              this.on('in', function (data) {
                return child.write(data);
              });
              var write = function write(data) {
                return _this21.emit('write', data);
              };
              var setButtons = function setButtons(buttons) {
                return _this21.emit('buttons', buttons);
              };
              child.on('write', write);
              child.on('buttons', setButtons);
              child.on('exit', function (code) {
                child.removeListener('write', write);
                child.removeListener('buttons', setButtons);
                _this21.destroy();
              });
              child.run.apply(child, args);
            } else {
              this.emit('write', _Process13);
              this.destroy();
            }
          } else {
            this.emit('write', 'sudo: ' + name + ': command not found\r\n');
            this.destroy();
          }
        }
      }
    }, {
      key: 'destroy',
      value: function destroy() {
        if (this.didDestroy) return;
        this.didDestroy = true;
        if (this.child) this.child.destroy();
        _get(Sudo.prototype.__proto__ || Object.getPrototypeOf(Sudo.prototype), 'destroy', this).call(this);
      }
    }]);

    return Sudo;
  }(Process),
  make: function (_Process14) {
    _inherits(Make, _Process14);

    function Make(shell) {
      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _classCallCheck(this, Make);

      var _this22 = _possibleConstructorReturn(this, (Make.__proto__ || Object.getPrototypeOf(Make)).call(this));

      _this22.su = options.su;
      return _this22;
    }

    _createClass(Make, [{
      key: 'run',
      value: function run() {
        for (var _len6 = arguments.length, args = Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
          args[_key6] = arguments[_key6];
        }

        if (args.length === 0) this.emit('write', '\x1b[31mmake: *** No targets specified.  Stop.\x1b[0m\r\n');else if (args.length === 3 && args.join(' ').toLowerCase() === 'me a sandwich') {
          if (this.su) {
            var b = '\x1b[33m';
            var r = '\x1b[0m';
            var l = '\x1b[32m';
            var c = '\x1b[38;5;229m';
            var h = '\x1b[38;5;225m';
            this.emit('write', '                    ' + b + '_.---._\r\n' + '                _.-~       ~-._\r\n' + '            _.-~               ~-._\r\n' + '        _.-~                       ~---._\r\n' + '    _.-~                                 ~\\\r\n' + ' .-~                                    _.;\r\n' + ' :-._                               _.-~ ./\r\n' + ' `-._~-._                   _..__.-~ _.-~\r\n' + ('  ' + c + '/  ' + b + '~-._~-._              / .__..--' + c + '~-' + l + '---._\r\n') + (c + ' \\_____(_' + b + ';-._\\.        _.-~_/' + c + '       ~)' + l + '.. . \\\r\n') + (l + '    /(_____  ' + b + '\\`--...--~_.-~' + c + '______..-+' + l + '_______)\r\n') + (l + '  .(_________/' + b + '`--...--~/' + l + '    _/ ' + h + '          ' + b + '/\\\r\n') + (b + ' /-._' + h + '     \\_     ' + l + '(___./_..-~' + h + '__.....' + b + '__..-~./\r\n') + (b + ' `-._~-._' + h + '   ~\\--------~  .-~' + b + '_..__.-~ _.-~\r\n') + (b + '     ~-._~-._ ' + h + '~---------`  ' + b + '/ .__..--~\r\n') + (b + '         ~-._\\.        _.-~_/\r\n') + (b + '             \\`--...--~_.-~\r\n') + (b + '              `--...--~' + r + '\r\n'));
          } else {
            this.emit('write', '\x1b[31mmake: me a sandwich : Permission denied\x1b[0m\r\n');
          }
        } else {
          this.emit('write', '\x1B[31mmake: *** No rule to make target \'' + args.join(' ').toLowerCase() + '\'.  Stop.\x1B[0m\r\n');
        }
        this.destroy();
      }
    }]);

    return Make;
  }(Process),
  pwd: '/this/is/a/demo\r\n',
  cd: '\x1b[38;5;239mNo directories to change to\r\n',
  whoami: window.navigator.userAgent + '\r\n',
  hostname: '' + window.location.hostname,
  uname: 'ESPTerm Demo\r\n',
  mkdir: '\x1b[38;5;239mDid not create a directory because this is a demo.\r\n',
  rm: '\x1b[38;5;239mDid not delete anything because this is a demo.\r\n',
  cp: '\x1b[38;5;239mNothing to copy because this is a demo.\r\n',
  mv: '\x1b[38;5;239mNothing to move because this is a demo.\r\n',
  ln: '\x1b[38;5;239mNothing to link because this is a demo.\r\n',
  touch: '\x1b[38;5;239mNothing to touch\r\n',
  exit: '\x1b[38;5;239mNowhere to go\r\n',
  github: function (_Process15) {
    _inherits(GoToGithub, _Process15);

    function GoToGithub() {
      _classCallCheck(this, GoToGithub);

      return _possibleConstructorReturn(this, (GoToGithub.__proto__ || Object.getPrototypeOf(GoToGithub)).apply(this, arguments));
    }

    _createClass(GoToGithub, [{
      key: 'run',
      value: function run() {
        window.open('https://github.com/espterm/espterm-firmware');
        this.destroy();
      }
    }]);

    return GoToGithub;
  }(Process)
};
var autocompleteIndex = {
  'local-echo': 'local-echo [--suppress-note]',
  theme: 'theme [n]',
  cursor: 'cursor [block|line|bar] [--steady]',
  sudo: 'sudo [command]'
};

var DemoShell = function () {
  function DemoShell(terminal, printInfo) {
    var _this24 = this;

    _classCallCheck(this, DemoShell);

    this.terminal = terminal;
    this.terminal.reset();
    this.parser = new ANSIParser(function () {
      return _this24.handleParsed.apply(_this24, arguments);
    });
    this.history = [];
    this.historyIndex = 0;
    this.cursorPos = 0;
    this.lastInputLength = 0;
    this.child = null;
    this.index = demoshIndex;

    if (printInfo) this.run('info');else this.prompt();
  }

  _createClass(DemoShell, [{
    key: 'write',
    value: function write(text) {
      if (this.child) {
        if (text.codePointAt(0) === 3) this.child.destroy();else this.child.write(text);
      } else this.parser.write(text);
    }
  }, {
    key: 'prompt',
    value: function prompt() {
      var success = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (this.terminal.cursor.x !== 0) this.terminal.write('\x1b[m\x1b[38;5;238m⏎\r\n');
      this.terminal.write('\x1b[34;1mdemosh \x1b[m');
      if (!success) this.terminal.write('\x1b[31m');
      this.terminal.write('$ \x1b[m');
      this.history.unshift('');
      this.cursorPos = 0;

      this.setButtons();
    }
  }, {
    key: 'copyFromHistoryIndex',
    value: function copyFromHistoryIndex() {
      if (!this.historyIndex) return;
      var current = this.history[this.historyIndex];
      this.history[0] = current;
      this.historyIndex = 0;
    }
  }, {
    key: 'getCompleted',
    value: function getCompleted() {
      var visual = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.history[0]) {
        var input = this.history[0];
        var prefix = '';
        if (input.startsWith('sudo ')) {
          var newInput = input.replace(/^(sudo\s+)+/, '');
          prefix = input.substr(0, input.length - newInput.length);
          input = newInput;
        }
        if (!input) return null;
        for (var name in this.index) {
          if (name.startsWith(input) && name !== input) {
            if (visual && name in autocompleteIndex) return prefix + autocompleteIndex[name];
            return prefix + name;
          }
        }
        return null;
      }
      return null;
    }
  }, {
    key: 'handleParsed',
    value: function handleParsed(action) {
      this.terminal.write('\x1B[' + (this.lastInputLength - this.cursorPos) + 'P');
      this.terminal.write('\b\x1b[P'.repeat(this.cursorPos));

      if (action === 'write') {
        this.copyFromHistoryIndex();
        this.history[0] = this.history[0].substr(0, this.cursorPos) + (arguments.length <= 1 ? undefined : arguments[1]) + this.history[0].substr(this.cursorPos);
        this.cursorPos++;
      } else if (action === 'back') {
        this.copyFromHistoryIndex();
        this.history[0] = this.history[0].substr(0, this.cursorPos - 1) + this.history[0].substr(this.cursorPos);
        this.cursorPos--;
        if (this.cursorPos < 0) this.cursorPos = 0;
      } else if (action === 'tab') {
        var _completed = this.getCompleted();
        if (_completed) {
          this.history[0] = _completed;
          this.cursorPos = this.history[0].length;
        }
      } else if (action === 'move-cursor-x') {
        this.cursorPos = Math.max(0, Math.min(this.history[this.historyIndex].length, this.cursorPos + (arguments.length <= 1 ? undefined : arguments[1])));
      } else if (action === 'delete-line') {
        this.copyFromHistoryIndex();
        this.history[0] = '';
        this.cursorPos = 0;
      } else if (action === 'delete-word') {
        this.copyFromHistoryIndex();
        var words = this.history[0].substr(0, this.cursorPos).split(' ');
        words.pop();
        this.history[0] = words.join(' ') + this.history[0].substr(this.cursorPos);
        this.cursorPos = words.join(' ').length;
      } else if (action === 'move-cursor-y') {
        this.historyIndex -= arguments.length <= 1 ? undefined : arguments[1];
        if (this.historyIndex < 0) this.historyIndex = 0;
        if (this.historyIndex >= this.history.length) this.historyIndex = this.history.length - 1;
        this.cursorPos = this.history[this.historyIndex].length;
      }

      this.terminal.write(this.history[this.historyIndex]);
      this.terminal.write('\b'.repeat(this.history[this.historyIndex].length));
      this.terminal.moveForward(this.cursorPos);

      this.lastInputLength = this.cursorPos;

      var completed = this.getCompleted(true);
      if (this.historyIndex === 0 && completed && action !== 'return') {
        // show closest match faintly
        var rest = completed.substr(this.history[0].length);
        this.terminal.write('\x1B[2m' + rest + '\x1B[m' + '\b'.repeat(rest.length));
        this.lastInputLength += rest.length;
      }

      if (action === 'return') {
        this.terminal.write('\n');
        this.parse(this.history[this.historyIndex]);
      }
    }
  }, {
    key: 'parse',
    value: function parse(input) {
      if (input === 'help') input = 'info';
      // TODO: basic chaining (i.e. semicolon)
      if (input) this.run(input);else this.prompt();
    }
  }, {
    key: 'run',
    value: function run(command) {
      var parts = [''];

      var inQuote = false;
      var _iteratorNormalCompletion8 = true;
      var _didIteratorError8 = false;
      var _iteratorError8 = undefined;

      try {
        for (var _iterator8 = command.trim()[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
          var character = _step8.value;

          if (inQuote && character !== inQuote) {
            parts[parts.length - 1] += character;
          } else if (inQuote) {
            inQuote = false;
          } else if (character === '"' || character === "'") {
            inQuote = character;
          } else if (character.match(/\s/)) {
            if (parts[parts.length - 1]) parts.push('');
          } else parts[parts.length - 1] += character;
        }
      } catch (err) {
        _didIteratorError8 = true;
        _iteratorError8 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion8 && _iterator8.return) {
            _iterator8.return();
          }
        } finally {
          if (_didIteratorError8) {
            throw _iteratorError8;
          }
        }
      }

      var name = parts.shift();

      if (name in this.index) {
        this.spawn(name, parts);
      } else {
        this.terminal.write('demosh: Unknown command: ' + name + '\r\n');
        this.prompt(false);
      }
    }
  }, {
    key: 'spawn',
    value: function spawn(name) {
      var _this25 = this;

      var args = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

      var Process = this.index[name];
      if (Process instanceof Function) {
        var _child;

        this.setButtons([]);
        this.child = new Process(this);
        var write = function write(data) {
          return _this25.terminal.write(data);
        };
        var setButtons = function setButtons(buttons) {
          return _this25.setButtons(buttons);
        };
        this.child.on('write', write);
        this.child.on('buttons', setButtons);
        this.child.on('exit', function (code) {
          if (_this25.child) {
            _this25.child.removeListener('write', write);
            _this25.child.removeListener('buttons', setButtons);
          }
          _this25.child = null;
          _this25.prompt(!code);
        });
        (_child = this.child).run.apply(_child, _toConsumableArray(args));
      } else {
        this.terminal.write(Process);
        this.prompt();
      }
    }
  }, {
    key: 'setButtons',
    value: function setButtons(buttons) {
      if (!buttons) {
        var shell = this;
        var writeChars = function writeChars(chars) {
          var loop = function loop() {
            shell.write(chars[0]);
            chars = chars.substr(1);
            if (chars) setTimeout(loop, 100);
          };
          setTimeout(loop, 200);
        };

        buttons = [{
          label: 'Open GitHub',
          action: function action(shell) {
            if (shell.child) shell.child.destroy();
            writeChars('github\r');
          }
        }, {
          label: 'Help',
          action: function action(shell) {
            if (shell.child) shell.child.destroy();
            writeChars('info\r');
          }
        }];
      }
      if (!buttons.length) buttons.push({ label: '', action: function action() {}
      });
      this.buttons = buttons;
      this.terminal.buttonLabels = buttons.map(function (x) {
        return x.label;
      });
    }
  }, {
    key: 'onButtonPress',
    value: function onButtonPress(index) {
      var button = this.buttons[index];
      if (!button) return;
      button.action(this, this.terminal);
    }
  }]);

  return DemoShell;
}();

window.demoInterface = module.exports = {
  input: function input(data) {
    var type = data[0];
    var content = data.substr(1);

    if (type === 's') {
      this.shell.write(content);
    } else if (type === 'b') {
      var button = content.charCodeAt(0);
      this.shell.onButtonPress(button - 1);
    } else if (type === 'm' || type === 'p' || type === 'r') {
      var row = parse2B(content, 0);
      var column = parse2B(content, 2);
      var _button = parse2B(content, 4);
      var modifiers = parse2B(content, 6);

      if (demoData.mouseReceiver) {
        if (type === 'm') demoData.mouseReceiver.mouseMove(column, row, _button, modifiers);else if (type === 'p') demoData.mouseReceiver.mouseDown(column, row, _button, modifiers);else if (type === 'r') demoData.mouseReceiver.mouseUp(column, row, _button, modifiers);
      }
    }
  },

  didInit: false,
  init: function init(screen) {
    if (this.didInit) return;
    this.didInit = true;
    this.terminal = new ScrollingTerminal(screen);
    this.shell = new DemoShell(this.terminal, true);
  }
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var data = __webpack_require__(14);

module.exports = function localize(key) {
  return data[key] || '?' + key + '?';
};

/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(11);
__webpack_require__(4);
__webpack_require__(5);
__webpack_require__(12);
try {
  __webpack_require__(8);
} catch (err) {}
__webpack_require__(13);
__webpack_require__(15);

var $ = __webpack_require__(1);

var _require = __webpack_require__(0),
    qs = _require.qs;

/* Export stuff to the global scope for inline scripts */


window.termInit = __webpack_require__(16);
window.$ = $;
window.qs = qs;

window.themes = __webpack_require__(3);

window.TermConf = __webpack_require__(27);

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/*! http://mths.be/fromcodepoint v0.1.0 by @mathias */
if (!String.fromCodePoint) {
  (function () {
    var defineProperty = function () {
      // IE 8 only supports `Object.defineProperty` on DOM elements
      try {
        var object = {};
        var $defineProperty = Object.defineProperty;
        var result = $defineProperty(object, object, object) && $defineProperty;
      } catch (error) {}
      return result;
    }();
    var stringFromCharCode = String.fromCharCode;
    var floor = Math.floor;
    var fromCodePoint = function fromCodePoint() {
      var MAX_SIZE = 0x4000;
      var codeUnits = [];
      var highSurrogate;
      var lowSurrogate;
      var index = -1;
      var length = arguments.length;
      if (!length) {
        return '';
      }
      var result = '';
      while (++index < length) {
        var codePoint = Number(arguments[index]);
        if (!isFinite(codePoint) || // `NaN`, `+Infinity`, or `-Infinity`
        codePoint < 0 || // not a valid Unicode code point
        codePoint > 0x10FFFF || // not a valid Unicode code point
        floor(codePoint) != codePoint // not an integer
        ) {
            throw RangeError('Invalid code point: ' + codePoint);
          }
        if (codePoint <= 0xFFFF) {
          // BMP code point
          codeUnits.push(codePoint);
        } else {
          // Astral code point; split in surrogate halves
          // http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
          codePoint -= 0x10000;
          highSurrogate = (codePoint >> 10) + 0xD800;
          lowSurrogate = codePoint % 0x400 + 0xDC00;
          codeUnits.push(highSurrogate, lowSurrogate);
        }
        if (index + 1 == length || codeUnits.length > MAX_SIZE) {
          result += stringFromCharCode.apply(null, codeUnits);
          codeUnits.length = 0;
        }
      }
      return result;
    };
    if (defineProperty) {
      defineProperty(String, 'fromCodePoint', {
        'value': fromCodePoint,
        'configurable': true,
        'writable': true
      });
    } else {
      String.fromCodePoint = fromCodePoint;
    }
  })();
}

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);

var _require = __webpack_require__(0),
    mk = _require.mk,
    qs = _require.qs,
    qsa = _require.qsa,
    cr = _require.cr;

var modal = __webpack_require__(4);
var notify = __webpack_require__(5);

/** Global generic init */
$.ready(function () {
  // Opening menu on mobile / narrow screen
  function menuOpen() {
    $('#menu').toggleClass('expanded');
  }
  $('#brand').on('click', menuOpen).on('keypress', cr(menuOpen));

  // Checkbox UI (checkbox CSS and hidden input with int value)
  $('.Row.checkbox').forEach(function (x) {
    var inp = x.querySelector('input');
    var box = x.querySelector('.box');

    $(box).toggleClass('checked', inp.value);

    var hdl = function hdl() {
      inp.value = 1 - inp.value;
      $(box).toggleClass('checked', inp.value);
    };

    $(x).on('click', hdl).on('keypress', cr(hdl));
  });

  // Expanding boxes on mobile
  $('.Box.mobcol,.Box.fold').forEach(function (x) {
    var h = x.querySelector('h2');

    var hdl = function hdl() {
      if ($(x).hasClass('d-expanded')) {
        $(x).removeClass('d-expanded');
      } else {
        $(x).toggleClass('expanded');
      }
    };
    $(h).on('click', hdl).on('keypress', cr(hdl));
  });

  $('form').forEach(function (x) {
    $(x).on('keypress', function (e) {
      if ((e.keyCode === 10 || e.keyCode === 13) && e.ctrlKey) {
        x.submit();
      }
    });
  });

  // loader dots...
  setInterval(function () {
    $('.anim-dots').each(function (x) {
      var $x = $(x);
      var dots = $x.html() + '.';
      if (dots.length === 5) dots = '.';
      $x.html(dots);
    });
  }, 1000);

  // flipping number boxes with the mouse wheel
  $('input[type=number]').on('wheel', function (e) {
    var $this = $(this);
    var val = +$this.val();
    if (isNaN(val)) val = 1;

    var step = +($this.attr('step') || 1);
    var min = +$this.attr('min');
    var max = +$this.attr('max');
    if (e.deltaY > 0) {
      val += step;
    } else {
      val -= step;
    }

    if (Number.isFinite(min)) val = Math.max(val, +min);
    if (Number.isFinite(max)) val = Math.min(val, +max);
    $this.val(val);

    if ('createEvent' in document) {
      var evt = document.createEvent('HTMLEvents');
      evt.initEvent('change', false, true);
      $this[0].dispatchEvent(evt);
    } else {
      $this[0].fireEvent('onchange');
    }

    e.preventDefault();
  });

  try {
    do {
      var msgAt = void 0,
          box = void 0;
      // populate the form errors box from GET arg ?err=...
      // (a way to pass errors back from server via redirect)
      msgAt = window.location.search.indexOf('err=');
      if (msgAt !== -1 && qs('.Box.errors')) {
        var _ret = function () {
          var errs = decodeURIComponent(window.location.search.substr(msgAt + 4)).split(',');
          var humanReadableErrors = [];
          errs.forEach(function (er) {
            if (er.length === 0) return;
            var lbls = qsa('label[for="' + er + '"]');
            if (lbls && lbls.length > 0) {
              for (var i = 0; i < lbls.length; i++) {
                var lbl = lbls[i];
                lbl.classList.add('error');
                if (i === 0) humanReadableErrors.push(lbl.childNodes[0].textContent.trim().replace(/: ?$/, ''));
              }
            } else {
              console.log(JSON.stringify(er));
              humanReadableErrors.push(er);
            }
          });

          qs('.Box.errors .list').innerHTML = humanReadableErrors.join(', ');
          qs('.Box.errors').classList.remove('hidden');
          return 'break';
        }();

        if (_ret === 'break') break;
      }

      var fademsgbox = function fademsgbox(box, time) {
        box.classList.remove('hidden');
        setTimeout(function () {
          box.classList.add('hiding');
          setTimeout(function () {
            box.classList.add('hidden');
          }, 1000);
        }, time);
      };

      msgAt = window.location.search.indexOf('errmsg=');
      box = qs('.Box.errmessage');
      if (msgAt !== -1 && box) {
        var msg = decodeURIComponent(window.location.search.substr(msgAt + 7));
        box.innerHTML = msg;
        fademsgbox(box, 3000);
        break;
      }

      msgAt = window.location.search.indexOf('msg=');
      box = qs('.Box.message');
      if (msgAt !== -1 && box) {
        var _msg = decodeURIComponent(window.location.search.substr(msgAt + 4));
        box.innerHTML = _msg;
        fademsgbox(box, 2000);
        break;
      }
    } while (0);
  } catch (e) {
    console.error(e);
  }

  modal.init();
  notify.init();

  // remove tabindices from h2 if wide
  if (window.innerWidth > 550) {
    $('.Box h2').forEach(function (x) {
      x.removeAttribute('tabindex');
    });

    // brand works as a link back to term in widescreen mode
    var br = qs('#brand');
    br && br.addEventListener('click', function () {
      window.location.href = '/'; // go to terminal
    });
  }
});

// setup the ajax loader
$._loader = function (vis) {
  $('#loader').toggleClass('show', vis);
};

var pageShown = false;
// reveal content on load
function showPage() {
  pageShown = true;
  $('#content').addClass('load');
}
// HACKITY HACK: fix this later
window.showPage = showPage;

// Auto reveal pages other than the terminal (sets window.noAutoShow)
$.ready(function () {
  if (window.noAutoShow === true) {
    setTimeout(function () {
      if (!pageShown) {
        var bnr = mk('P');
        bnr.id = 'load-failed';
        bnr.innerHTML = 'Server connection failed! Trying again' + '<span class="anim-dots" style="width:1.5em;text-align:left;display:inline-block">.</span>';
        qs('#screen').appendChild(bnr);
        qs('#screen').classList.add('failed');
        showPage();
      }
    }, 2000);
  } else {
    setTimeout(function () {
      showPage();
    }, 1);
  }
});

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);

var _require = __webpack_require__(0),
    mk = _require.mk;

var tr = __webpack_require__(9);

var HTTPS = window.location.protocol.match(/s:/);

{

  // Get XX % for a slider input
  var calc_dBm = function calc_dBm(inp) {
    return '+' + (inp.value * 0.25).toFixed(2) + ' dBm';
  };

  // Display selected STA SSID etc


  var selectSta = function selectSta(name, password, ip) {
    $('#sta_ssid').val(name);
    $('#sta_password').val(password);

    $('#sta-nw').toggleClass('hidden', name.length === 0);
    $('#sta-nw-nil').toggleClass('hidden', name.length > 0);

    $('#sta-nw .essid').html($.htmlEscape(name));
    var hasPassword = !!password;

    // (the following is kind of confusing with the double-double negations,
    // but it works)
    $('#sta-nw .passwd').toggleClass('hidden', !hasPassword);
    $('#sta-nw .nopasswd').toggleClass('hidden', hasPassword);

    $('#sta-nw .ip').html(ip.length > 0 ? tr('wifi.connected_ip_is') + ip : tr('wifi.not_conn'));
  };

  /** Update display for received response */


  var onScan = function onScan(resp, status) {
    // var ap_json = {
    //  "result": {
    //    "inProgress": "0",
    //    "APs": [
    //      {"essid": "Chlivek", "bssid": "88:f7:c7:52:b3:99", "rssi": "204", "enc": "4", "channel": "1"},
    //      {"essid": "TyNikdy", "bssid": "5c:f4:ab:0d:f1:1b", "rssi": "164", "enc": "3", "channel": "1"},
    //    ]
    //  }
    // };

    if (status !== 200) {
      // bad response
      rescan(5000); // wait 5s then retry
      return;
    }

    try {
      resp = JSON.parse(resp);
    } catch (e) {
      console.log(e);
      rescan(5000);
      return;
    }

    var done = !resp.result.inProgress && resp.result.APs.length > 0;
    rescan(done ? 15000 : 1000);
    if (!done) return; // no redraw yet

    // clear the AP list
    var $list = $('#ap-list');
    // remove old APs
    $('#ap-list .AP').remove();

    $list.toggleClass('hidden', !done);
    $('#ap-loader').toggleClass('hidden', done);

    // scan done
    resp.result.APs.sort(function (a, b) {
      return b.rssi - a.rssi;
    }).forEach(function (ap) {
      ap.enc = parseInt(ap.enc);

      if (ap.enc > 4) return; // hide unsupported auths

      var item = mk('div');

      var $item = $(item).data('ssid', ap.essid).data('pwd', ap.enc).attr('tabindex', 0).addClass('AP');

      // mark current SSID
      if (ap.essid === curSSID) {
        $item.addClass('selected');
      }

      var inner = mk('div');
      var escapedSSID = $.htmlEscape(ap.essid);
      $(inner).addClass('inner').htmlAppend('<div class="rssi">' + ap.rssi_perc + '</div>').htmlAppend('<div class="essid" title="' + escapedSSID + '">' + escapedSSID + '</div>').htmlAppend('<div class="auth">' + authTypes[ap.enc] + '</div>');

      $item.on('click', function () {
        var $th = $(this);

        var conn_ssid = $th.data('ssid');
        var conn_pass = '';

        if (+$th.data('pwd')) {
          // this AP needs a password
          conn_pass = window.prompt(tr('wifi.enter_passwd').replace(':ssid:', conn_ssid));
          if (!conn_pass) return;
        }

        $('#sta_password').val(conn_pass);
        $('#sta_ssid').val(conn_ssid);
        selectSta(conn_ssid, conn_pass, '');
      });

      item.appendChild(inner);
      $list[0].appendChild(item);
    });
  };

  var startScanning = function startScanning() {
    $('#ap-loader').removeClass('hidden');
    $('#ap-scan').addClass('hidden');
    $('#ap-loader .anim-dots').html('.');

    scanAPs();
  };

  /** Ask the CGI what APs are visible (async) */


  var scanAPs = function scanAPs() {
    if (window._demo) {
      onScan(window._demo_aps, 200);
    } else {
      $.get((HTTPS ? 'https' : 'http') + '://' + window._root + '/cfg/wifi/scan', onScan);
    }
  };

  var rescan = function rescan(time) {
    setTimeout(scanAPs, time);
  };

  /** Set up the WiFi page */


  var wifiInit = function wifiInit(cfg) {
    // Update slider value displays
    $('.Row.range').forEach(function (x) {
      var inp = x.querySelector('input');
      var disp1 = x.querySelector('.x-disp1');
      var disp2 = x.querySelector('.x-disp2');
      var t = calc_dBm(inp);
      $(disp1).html(t);
      $(disp2).html(t);
      $(inp).on('input', function () {
        t = calc_dBm(inp);
        $(disp1).html(t);
        $(disp2).html(t);
      });
    });

    // Forget STA credentials
    $('#forget-sta').on('click', function () {
      selectSta('', '', '');
      return false;
    });

    selectSta(cfg.sta_ssid, cfg.sta_password, cfg.sta_active_ip);
    curSSID = cfg.sta_active_ssid;
  };

  var w = window.WiFi = {};

  var authTypes = ['Open', 'WEP', 'WPA', 'WPA2', 'WPA/WPA2'];
  var curSSID = void 0;

  w.init = wifiInit;
  w.startScanning = startScanning;
}

/***/ }),
/* 14 */
/***/ (function(module, exports) {

/* Generated language file */
module.exports={"wifi.connected_ip_is":"Connected, IP is ","wifi.not_conn":"Not connected.","wifi.enter_passwd":"Enter password for \":ssid:\"","term_nav.fullscreen":"Fullscreen","term_conn.connecting":"Connecting","term_conn.waiting_content":"Waiting for content","term_conn.disconnected":"Disconnected","term_conn.waiting_server":"Waiting for server","term_conn.reconnecting":"Reconnecting"}


/***/ }),
/* 15 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _utils = __webpack_require__(0);

var $ = __webpack_require__(1);

var HTTPS = window.location.protocol.match(/s:/);

var PERIOD_NORMAL = 500;
var PERIOD_FAIL = 2500;

var w = window.GPIO_Ctl = {};

var scheduledSampleTimeout = null;
var lastState = { 'io2': -1, 'io4': -1, 'io5': -1 };

var $in2 = void 0,
    $in4 = void 0,
    $in5 = void 0;

var enablePolling = void 0;

function scheduleSample(time) {
  if (!enablePolling || window._demo) return; // no scanning in demo mode

  clearTimeout(scheduledSampleTimeout);
  scheduledSampleTimeout = setTimeout(sampleGPIOs, time);
}

function onSampled(resp, status) {
  if (status !== 200) {
    // bad response
    scheduleSample(PERIOD_FAIL); // wait 5s then retry
    return;
  }

  try {
    if ((typeof resp === 'undefined' ? 'undefined' : _typeof(resp)) !== 'object') resp = JSON.parse(resp);

    if (resp.io2 !== lastState.io2) $in2.toggleClass('active', resp.io2);
    if (resp.io4 !== lastState.io4) $in4.toggleClass('active', resp.io4);
    if (resp.io5 !== lastState.io5) $in5.toggleClass('active', resp.io5);
  } catch (e) {
    console.log(e);
    scheduleSample(PERIOD_FAIL);
    return;
  }

  lastState = resp;

  scheduleSample(PERIOD_NORMAL);
}

function sampleGPIOs() {
  var getargs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  clearTimeout(scheduledSampleTimeout);
  $.get((HTTPS ? 'https' : 'http') + '://' + window._root + '/api/v1/gpio' + getargs, onSampled, { loader: getargs !== '' });
}

w.init = function (state, doPoll) {

  $in2 = $('.x-in2');
  $in4 = $('.x-in4');
  $in5 = $('.x-in5');

  enablePolling = doPoll;

  $('.gpio-indicator, .x-in-handle').on('click', function (e) {
    var num = $(this).data('num');
    sampleGPIOs('?do' + num + '=' + (1 - lastState['io' + num]));
  });

  $('.x-in-handle').on('keypress', (0, _utils.cr)(function (e) {
    var num = $(this).data('num');
    sampleGPIOs('?do' + num + '=' + (1 - lastState['io' + num]));
  }));

  onSampled(state, 200);
};

/***/ }),
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var $ = __webpack_require__(1);

var _require = __webpack_require__(0),
    qs = _require.qs,
    mk = _require.mk;

var localize = __webpack_require__(9);
var Notify = __webpack_require__(5);
var TermScreen = __webpack_require__(17);
var TermConnection = __webpack_require__(21);
var TermInput = __webpack_require__(22);
var TermUpload = __webpack_require__(23);
var initSoftKeyboard = __webpack_require__(24);
var attachDebugger = __webpack_require__(25);
var initButtons = __webpack_require__(26);

/** Init the terminal sub-module - called from HTML */
module.exports = function (opts) {
  var screen = new TermScreen();
  var conn = new TermConnection(screen);
  var input = TermInput(conn, screen);
  var termUpload = TermUpload(conn, input, screen);
  input.termUpload = termUpload;

  // forward screen input events
  screen.on('mousedown', function () {
    return input.onMouseDown.apply(input, arguments);
  });
  screen.on('mousemove', function () {
    return input.onMouseMove.apply(input, arguments);
  });
  screen.on('mouseup', function () {
    return input.onMouseUp.apply(input, arguments);
  });
  screen.on('mousewheel', function () {
    return input.onMouseWheel.apply(input, arguments);
  });
  screen.on('input-alts', function () {
    return input.setAlts.apply(input, arguments);
  });
  screen.on('mouse-mode', function () {
    return input.setMouseMode.apply(input, arguments);
  });

  // touch selection menu (the Copy button)
  $.ready(function () {
    var touchSelectMenu = qs('#touch-select-menu');
    screen.on('show-touch-select-menu', function (x, y) {
      var rect = touchSelectMenu.getBoundingClientRect();
      x -= rect.width / 2;
      y -= rect.height / 2;

      touchSelectMenu.classList.add('open');
      touchSelectMenu.style.transform = 'translate(' + x + 'px,' + y + 'px)';
    });
    screen.on('hide-touch-select-menu', function () {
      return touchSelectMenu.classList.remove('open');
    });

    var copyButton = qs('#touch-select-copy-btn');
    if (copyButton) {
      copyButton.addEventListener('click', function () {
        screen.copySelectionToClipboard();
      });
    }
  });

  // buttons
  var buttons = initButtons(input);
  screen.on('buttons-update', function (update) {
    buttons.labels = update.labels;
    buttons.colors = update.colors;
  });
  // TODO: don't access the renderer here
  buttons.palette = screen.layout.renderer.palette;
  screen.layout.renderer.on('palette-update', function (palette) {
    buttons.palette = palette;
  });

  screen.on('full-load', function () {
    var scr = qs('#screen');
    var errmsg = qs('#load-failed');
    if (scr) scr.classList.remove('failed');
    if (errmsg) errmsg.parentNode.removeChild(errmsg);
  });

  var setLinkVisibility = function setLinkVisibility(visible) {
    var buttons = [].concat(_toConsumableArray(document.querySelectorAll('.x-term-conf-btn')));
    if (visible) buttons.forEach(function (x) {
      return x.classList.remove('hidden');
    });else buttons.forEach(function (x) {
      return x.classList.add('hidden');
    });
  };
  var setButtonVisibility = function setButtonVisibility(visible) {
    if (visible) qs('#action-buttons').classList.remove('hidden');else qs('#action-buttons').classList.add('hidden');
  };

  screen.on('opts-update', function () {
    setLinkVisibility(screen.showLinks);
    setButtonVisibility(screen.showButtons);
  });

  screen.on('title-update', function (text) {
    qs('#screen-title').textContent = text;
    if (!text) text = 'Terminal';
    qs('title').textContent = text + ' :: ESPTerm';
  });

  // connection status

  var showSplashTimeout = null;
  var showSplash = function showSplash(obj) {
    var delay = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 250;

    clearTimeout(showSplashTimeout);
    showSplashTimeout = setTimeout(function () {
      screen.window.statusScreen = obj;
    }, delay);
  };

  conn.on('open', function () {
    // console.log('*open')
    showSplash({ title: localize('term_conn.connecting'), loading: true });
  });
  conn.on('connect', function () {
    // console.log('*connect')
    showSplash({ title: localize('term_conn.waiting_content'), loading: true });
  });
  screen.on('load', function () {
    // console.log('*load')
    clearTimeout(showSplashTimeout);
    if (screen.window.statusScreen) screen.window.statusScreen = null;
  });
  conn.on('disconnect', function () {
    // console.log('*disconnect')
    showSplash({ title: localize('term_conn.disconnected') }, 500);
    screen.screen = [];
    screen.screenFG = [];
    screen.screenBG = [];
    screen.screenAttrs = [];
  });
  conn.on('silence', function () {
    // console.log('*silence')
    showSplash({ title: localize('term_conn.waiting_server'), loading: true }, 0);
  });
  // conn.on('ping-fail', () => { screen.window.statusScreen = { title: 'Disconnected' } })
  conn.on('ping-success', function () {
    // console.log('*ping-success')
    showSplash({ title: localize('term_conn.reconnecting'), loading: true }, 0);
  });

  conn.init();
  input.init(opts);
  termUpload.init();
  Notify.init();

  window.onerror = function (errorMsg, file, line, col) {
    Notify.show('<b>JS ERROR!</b><br>' + errorMsg + '<br>at ' + file + ':' + line + ':' + col, 10000, true);
    return false;
  };

  qs('#screen').appendChild(screen.layout.canvas);

  initSoftKeyboard(screen, input);
  if (attachDebugger) attachDebugger(screen, conn);

  // fullscreen mode

  var fullscreenIcon = {}; // dummy
  var isFullscreen = false;
  var properFullscreen = false;
  var fitScreen = false;
  var screenPadding = screen.layout.window.padding;
  var fitScreenIfNeeded = function fitScreenIfNeeded() {
    if (isFullscreen) {
      fullscreenIcon.className = 'icn-resize-small';
      if (properFullscreen) {
        screen.layout.window.fitIntoWidth = window.screen.width;
        screen.layout.window.fitIntoHeight = window.screen.height;
        screen.layout.window.padding = 0;
      } else {
        screen.layout.window.fitIntoWidth = window.innerWidth;
        if (qs('#term-nav').classList.contains('hidden')) {
          screen.layout.window.fitIntoHeight = window.innerHeight;
        } else {
          screen.layout.window.fitIntoHeight = window.innerHeight - 24;
        }
        screen.layout.window.padding = 0;
      }
    } else {
      fullscreenIcon.className = 'icn-resize-full';
      screen.layout.window.fitIntoWidth = fitScreen ? window.innerWidth - 4 : 0;
      screen.layout.window.fitIntoHeight = fitScreen ? window.innerHeight : 0;
      screen.layout.window.padding = screenPadding;
    }
  };
  fitScreenIfNeeded();
  window.addEventListener('resize', fitScreenIfNeeded);

  var toggleFitScreen = function toggleFitScreen() {
    fitScreen = !fitScreen;
    var resizeButtonIcon = qs('#resize-button-icon');
    if (fitScreen) {
      resizeButtonIcon.classList.remove('icn-resize-small');
      resizeButtonIcon.classList.add('icn-resize-full');
    } else {
      resizeButtonIcon.classList.remove('icn-resize-full');
      resizeButtonIcon.classList.add('icn-resize-small');
    }
    fitScreenIfNeeded();
  };

  qs('#term-fit-screen').addEventListener('click', function () {
    toggleFitScreen();
    return false;
  });

  // add fullscreen mode & button
  if (window.Element.prototype.requestFullscreen || window.Element.prototype.webkitRequestFullscreen) {
    properFullscreen = true;

    var checkForFullscreen = function checkForFullscreen() {
      // document.fullscreenElement is not really supported yet, so here's a hack
      if (isFullscreen && (window.innerWidth !== window.screen.width || window.innerHeight !== window.screen.height)) {
        isFullscreen = false;
        fitScreenIfNeeded();
      }
    };
    setInterval(checkForFullscreen, 500);
  }

  // (why are the buttons anchors?)
  var button = mk('a');
  button.id = 'fullscreen-button';
  button.href = '#';
  button.addEventListener('click', function (e) {
    e.preventDefault();

    if (document.body.classList.contains('pseudo-fullscreen')) {
      document.body.classList.remove('pseudo-fullscreen');
      isFullscreen = false;
      fitScreenIfNeeded();
      return;
    }

    isFullscreen = true;
    fitScreenIfNeeded();
    screen.layout.updateSize();

    if (properFullscreen) {
      if (screen.layout.canvas.requestFullscreen) screen.layout.canvas.requestFullscreen();else screen.layout.canvas.webkitRequestFullscreen();
    } else {
      document.body.classList.add('pseudo-fullscreen');
    }
  });
  fullscreenIcon = mk('i');
  fullscreenIcon.className = 'icn-resize-full';
  button.appendChild(fullscreenIcon);
  var span = mk('span');
  span.textContent = localize('term_nav.fullscreen');
  button.appendChild(span);
  qs('#term-nav').insertBefore(button, qs('#term-nav').firstChild);

  // for debugging
  window.termScreen = screen;
  window.buttons = buttons;
  window.conn = conn;
  window.input = input;
  window.termUpl = termUpload;
};

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventEmitter = __webpack_require__(2);

var _require = __webpack_require__(0),
    mk = _require.mk;

var notify = __webpack_require__(5);
var ScreenParser = __webpack_require__(18);
var ScreenLayout = __webpack_require__(19);

var _require2 = __webpack_require__(6),
    ATTR_BLINK = _require2.ATTR_BLINK;

/**
 * A terminal screen.
 */


module.exports = function (_EventEmitter) {
  _inherits(TermScreen, _EventEmitter);

  function TermScreen() {
    _classCallCheck(this, TermScreen);

    var _this = _possibleConstructorReturn(this, (TermScreen.__proto__ || Object.getPrototypeOf(TermScreen)).call(this));

    _this.parser = new ScreenParser();
    _this.layout = new ScreenLayout();

    // debug screen handle
    _this._debug = null;

    if ('AudioContext' in window || 'webkitAudioContext' in window) {
      _this.audioCtx = new (window.AudioContext || window.webkitAudioContext)();
    } else {
      console.warn('No AudioContext!');
    }

    _this._window = {
      width: 0,
      height: 0,
      // two bits. LSB: debug enabled by user, MSB: debug enabled by server
      debug: 0,
      statusScreen: null

      // make writing to window update size and draw
    };_this.window = new Proxy(_this._window, {
      set: function set(target, key, value) {
        if (target[key] !== value) {
          target[key] = value;
          self.updateLayout();
          self.renderScreen('window:' + key + '=' + value);
          self.emit('update-window:' + key, value);
        }
        return true;
      }
    });

    _this.on('update-window:debug', function (debug) {
      _this.layout.window.debug = !!debug;
    });

    _this.cursor = {
      x: 0,
      y: 0,
      blinking: true,
      visible: true,
      hanging: false,
      style: 'block'
    };

    var self = _this;

    // current selection
    _this.selection = {
      // when false, this will prevent selection in favor of mouse events,
      // though alt can be held to override it
      selectable: null,

      // selection start and end (x, y) tuples
      start: [0, 0],
      end: [0, 0],

      setSelectable: function setSelectable(value) {
        if (value !== this.selectable) {
          this.selectable = self.layout.selectable = value;
        }
      }
    };

    // mouse features
    _this.mouseMode = { clicks: false, movement: false };

    _this.showLinks = false;
    _this.showButtons = false;
    _this.title = '';

    _this.bracketedPaste = false;
    _this.blinkingCellCount = 0;
    _this.reverseVideo = false;

    _this.screen = [];
    _this.screenFG = [];
    _this.screenBG = [];
    _this.screenAttrs = [];
    _this.screenLines = [];

    // For testing TODO remove
    //   this.screenLines[0] = 0b001
    //   this.screenLines[1] = 0b010
    //   this.screenLines[2] = 0b100
    //   this.screenLines[3] = 0b011
    //   this.screenLines[4] = 0b101

    var selecting = false;

    var selectStart = function selectStart(x, y) {
      if (selecting) return;
      selecting = true;
      _this.selection.start = _this.selection.end = _this.layout.screenToGrid(x, y, true);
      _this.renderScreen('select-start');
    };

    var selectMove = function selectMove(x, y) {
      if (!selecting) return;
      _this.selection.end = _this.layout.screenToGrid(x, y, true);
      _this.renderScreen('select-move');
    };

    var selectEnd = function selectEnd(x, y) {
      if (!selecting) return;
      selecting = false;
      _this.selection.end = _this.layout.screenToGrid(x, y, true);
      _this.renderScreen('select-end');
      Object.assign(_this.selection, _this.getNormalizedSelection());
    };

    // bind event listeners

    _this.layout.on('mousedown', function (e) {
      _this.emit('hide-touch-select-menu');
      if ((_this.selection.selectable || e.altKey) && e.button === 0) {
        selectStart(e.offsetX, e.offsetY);
      } else {
        _this.emit.apply(_this, ['mousedown'].concat(_toConsumableArray(_this.layout.screenToGrid(e.offsetX, e.offsetY)), [e.button + 1]));
      }
    });

    window.addEventListener('mousemove', function (e) {
      selectMove(e.offsetX, e.offsetY);
    });

    window.addEventListener('mouseup', function (e) {
      selectEnd(e.offsetX, e.offsetY);
    });

    // touch event listeners

    var touchPosition = null;
    var touchDownTime = 0;
    var touchSelectMinTime = 500;
    var touchDidMove = false;

    var getTouchPositionOffset = function getTouchPositionOffset(touch) {
      var rect = _this.layout.canvas.getBoundingClientRect();
      return [touch.clientX - rect.left, touch.clientY - rect.top];
    };

    _this.layout.on('touchstart', function (e) {
      touchPosition = getTouchPositionOffset(e.touches[0]);
      touchDidMove = false;
      touchDownTime = Date.now();

      if (_this.mouseMode.clicks) {
        var _this$layout;

        _this.emit.apply(_this, ['mousedown'].concat(_toConsumableArray((_this$layout = _this.layout).screenToGrid.apply(_this$layout, _toConsumableArray(touchPosition))), [1]));
        e.preventDefault();
      }
    });

    _this.layout.on('touchmove', function (e) {
      touchPosition = getTouchPositionOffset(e.touches[0]);

      if (!selecting && touchDidMove === false) {
        if (touchDownTime < Date.now() - touchSelectMinTime) {
          selectStart.apply(undefined, _toConsumableArray(touchPosition));
        }
      } else if (selecting) {
        e.preventDefault();
        selectMove.apply(undefined, _toConsumableArray(touchPosition));
      } else if (_this.mouseMode.movement && !selecting) {
        var _this$layout2;

        _this.emit.apply(_this, ['mousemove'].concat(_toConsumableArray((_this$layout2 = _this.layout).screenToGrid.apply(_this$layout2, _toConsumableArray(touchPosition)))));
        e.preventDefault();
      }

      touchDidMove = true;
    });

    _this.layout.on('touchend', function (e) {
      if (e.touches[0]) {
        touchPosition = getTouchPositionOffset(e.touches[0]);
      }

      if (selecting) {
        e.preventDefault();
        selectEnd.apply(undefined, _toConsumableArray(touchPosition));

        // selection ended; show touch select menu
        // use middle position for x and one line above for y
        var selectionPos = _this.layout.gridToScreen((_this.selection.start[0] + _this.selection.end[0]) / 2, _this.selection.start[1] - 1);

        _this.emit('show-touch-select-menu', selectionPos[0], selectionPos[1]);
      } else if (_this.mouseMode.clicks) {
        var _this$layout3;

        _this.emit.apply(_this, ['mouseup'].concat(_toConsumableArray((_this$layout3 = _this.layout).screenToGrid.apply(_this$layout3, _toConsumableArray(touchPosition))), [1]));
        e.preventDefault();
      }

      if (!touchDidMove && !_this.mouseMode.clicks) {
        _this.emit('tap', Object.assign(e, {
          x: touchPosition[0],
          y: touchPosition[1]
        }));
      } else if (!touchDidMove) _this.resetSelection();

      touchPosition = null;
    });

    _this.on('tap', function (e) {
      if (_this.selection.start[0] !== _this.selection.end[0] || _this.selection.start[1] !== _this.selection.end[1]) {
        // selection is not empty
        _this.resetSelection();
      } else {
        e.preventDefault();
        _this.emit('open-soft-keyboard');
      }
    });

    _this.layout.on('mousemove', function (e) {
      if (!selecting) {
        _this.emit.apply(_this, ['mousemove'].concat(_toConsumableArray(_this.layout.screenToGrid(e.offsetX, e.offsetY))));
      }
    });

    _this.layout.on('mouseup', function (e) {
      if (!selecting) {
        _this.emit.apply(_this, ['mouseup'].concat(_toConsumableArray(_this.layout.screenToGrid(e.offsetX, e.offsetY)), [e.button + 1]));
      }
    });

    var aggregateWheelDelta = 0;
    _this.layout.on('wheel', function (e) {
      if (_this.mouseMode.clicks) {
        if (Math.abs(e.wheelDeltaY) === 120) {
          // mouse wheel scrolling
          _this.emit.apply(_this, ['mousewheel'].concat(_toConsumableArray(_this.layout.screenToGrid(e.offsetX, e.offsetY)), [e.deltaY > 0 ? 1 : -1]));
        } else {
          // smooth scrolling
          aggregateWheelDelta -= e.wheelDeltaY;
          if (Math.abs(aggregateWheelDelta) >= 40) {
            _this.emit.apply(_this, ['mousewheel'].concat(_toConsumableArray(_this.layout.screenToGrid(e.offsetX, e.offsetY)), [aggregateWheelDelta > 0 ? 1 : -1]));
            aggregateWheelDelta = 0;
          }
        }

        // prevent page scrolling
        e.preventDefault();
      }
    });

    _this.layout.on('contextmenu', function (e) {
      if (_this.mouseMode.clicks) {
        // prevent mouse keys getting stuck
        e.preventDefault();
      }
      selectEnd(e.offsetX, e.offsetY);
    });
    return _this;
  }

  _createClass(TermScreen, [{
    key: 'resetScreen',
    value: function resetScreen() {
      var _window = this.window,
          width = _window.width,
          height = _window.height;

      this.blinkingCellCount = 0;
      this.screen.screen = new Array(width * height).fill(' ');
      this.screen.screenFG = new Array(width * height).fill(0);
      this.screen.screenBG = new Array(width * height).fill(0);
      this.screen.screenAttrs = new Array(width * height).fill(0);
      this.screen.screenLines = new Array(height).fill(0);
    }
  }, {
    key: 'updateLayout',
    value: function updateLayout() {
      this.layout.window.width = this.window.width;
      this.layout.window.height = this.window.height;
    }
  }, {
    key: 'renderScreen',
    value: function renderScreen(reason) {
      var selection = [];

      for (var cell = 0; cell < this.screen.length; cell++) {
        selection.push(this.isInSelection(cell % this.window.width, Math.floor(cell / this.window.width)));
      }

      this.layout.render(reason, {
        width: this.window.width,
        height: this.window.height,
        screen: this.screen,
        screenFG: this.screenFG,
        screenBG: this.screenBG,
        screenSelection: selection,
        screenAttrs: this.screenAttrs,
        screenLines: this.screenLines,
        cursor: this.cursor,
        statusScreen: this.window.statusScreen,
        reverseVideo: this.reverseVideo,
        hasBlinkingCells: !!this.blinkingCellCount
      });
    }
  }, {
    key: 'resetSelection',
    value: function resetSelection() {
      this.selection.start = this.selection.end = [0, 0];
      this.emit('hide-touch-select-menu');
      this.renderScreen('select-reset');
    }

    /**
     * Returns a normalized version of the current selection, such that `start`
     * is always before `end`.
     * @returns {Object} the normalized selection, with `start` and `end`
     */

  }, {
    key: 'getNormalizedSelection',
    value: function getNormalizedSelection() {
      var _selection = this.selection,
          start = _selection.start,
          end = _selection.end;
      // if the start line is after the end line, or if they're both on the same
      // line but the start column comes after the end column, swap

      if (start[1] > end[1] || start[1] === end[1] && start[0] > end[0]) {
        var _ref = [end, start];
        start = _ref[0];
        end = _ref[1];
      }
      return { start: start, end: end };
    }

    /**
     * Returns whether or not a given cell is in the current selection.
     * @param {number} col - the column (x)
     * @param {number} line - the line (y)
     * @returns {boolean}
     */

  }, {
    key: 'isInSelection',
    value: function isInSelection(col, line) {
      var _getNormalizedSelecti = this.getNormalizedSelection(),
          start = _getNormalizedSelecti.start,
          end = _getNormalizedSelecti.end;

      var colAfterStart = start[0] <= col;
      var colBeforeEnd = col < end[0];
      var onStartLine = line === start[1];
      var onEndLine = line === end[1];

      if (onStartLine && onEndLine) return colAfterStart && colBeforeEnd;else if (onStartLine) return colAfterStart;else if (onEndLine) return colBeforeEnd;else return start[1] < line && line < end[1];
    }

    /**
     * Sweeps for selected cells and joins them in a multiline string.
     * @returns {string} the selection
     */

  }, {
    key: 'getSelectedText',
    value: function getSelectedText() {
      var screenLength = this.window.width * this.window.height;
      var lines = [];
      var previousLineIndex = -1;

      for (var cell = 0; cell < screenLength; cell++) {
        var x = cell % this.window.width;
        var y = Math.floor(cell / this.window.width);

        if (this.isInSelection(x, y)) {
          if (previousLineIndex !== y) {
            previousLineIndex = y;
            lines.push('');
          }
          lines[lines.length - 1] += this.screen[cell];
        }
      }

      return lines.join('\n');
    }

    /**
     * Copies the selection to clipboard and creates a notification balloon.
     */

  }, {
    key: 'copySelectionToClipboard',
    value: function copySelectionToClipboard() {
      var selectedText = this.getSelectedText();
      // don't copy anything if nothing is selected
      if (!selectedText) return;
      var textarea = mk('textarea');
      document.body.appendChild(textarea);
      textarea.value = selectedText;
      textarea.select();
      if (document.execCommand('copy')) {
        notify.show('Copied to clipboard');
      } else {
        notify.show('Failed to copy');
      }
      document.body.removeChild(textarea);
    }

    /**
     * Shows an actual notification (if possible) or a notification balloon.
     * @param {string} text - the notification content
     */

  }, {
    key: 'showNotification',
    value: function showNotification(text) {
      console.info('Notification: ' + text);
      if (window.Notification && window.Notification.permission === 'granted') {
        var notification = new window.Notification('ESPTerm', {
          body: text
        });
        notification.addEventListener('click', function () {
          return window.focus();
        });
      } else {
        if (window.Notification && window.Notification.permission !== 'denied') {
          window.Notification.requestPermission();
        } else {
          // Fallback using the built-in notification balloon
          notify.show(text);
        }
      }
    }

    /**
     * Creates a beep sound.
     */

  }, {
    key: 'beep',
    value: function beep() {
      var audioCtx = this.audioCtx;
      if (!audioCtx) return;

      // prevent screeching
      if (this._lastBeep && this._lastBeep > Date.now() - 50) return;
      this._lastBeep = Date.now();

      if (!this._convolver) {
        this._convolver = audioCtx.createConvolver();
        var impulseLength = audioCtx.sampleRate * 0.8;
        var impulse = audioCtx.createBuffer(2, impulseLength, audioCtx.sampleRate);
        for (var i = 0; i < impulseLength; i++) {
          impulse.getChannelData(0)[i] = Math.pow(1 - i / impulseLength, 7 + Math.random());
          impulse.getChannelData(1)[i] = Math.pow(1 - i / impulseLength, 7 + Math.random());
        }
        this._convolver.buffer = impulse;
        this._convolver.connect(audioCtx.destination);
      }

      // main beep
      var mainOsc = audioCtx.createOscillator();
      var mainGain = audioCtx.createGain();
      mainOsc.connect(mainGain);
      mainGain.gain.value = 4;
      mainOsc.frequency.value = 750;
      mainOsc.type = 'sine';

      // surrogate beep (making it sound like 'oops')
      var surrOsc = audioCtx.createOscillator();
      var surrGain = audioCtx.createGain();
      surrOsc.connect(surrGain);
      surrGain.gain.value = 2;
      surrOsc.frequency.value = 400;
      surrOsc.type = 'sine';

      mainGain.connect(this._convolver);
      surrGain.connect(this._convolver);

      var startTime = audioCtx.currentTime;
      mainOsc.start();
      mainOsc.stop(startTime + 0.5);
      surrOsc.start(startTime + 0.05);
      surrOsc.stop(startTime + 0.8);

      var loop = function loop() {
        if (audioCtx.currentTime < startTime + 0.8) window.requestAnimationFrame(loop);
        mainGain.gain.value *= 0.8;
        surrGain.gain.value *= 0.8;
      };
      loop();
    }
  }, {
    key: 'load',
    value: function load() {
      var _parser;

      var updates = (_parser = this.parser).parse.apply(_parser, arguments);

      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = updates[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var update = _step.value;

          switch (update.topic) {
            case 'screen-opts':
              if (update.width !== this.window.width || update.height !== this.window.height) {
                this.window.width = update.width;
                this.window.height = update.height;
                this.resetScreen();
              }
              this.layout.renderer.loadTheme(update.theme);
              this.layout.renderer.setDefaultColors(update.defFG, update.defBG);
              this.cursor.visible = update.cursorVisible;
              this.emit.apply(this, ['input-alts'].concat(_toConsumableArray(update.inputAlts)));
              this.mouseMode.clicks = update.trackMouseClicks;
              this.mouseMode.movement = update.trackMouseMovement;
              this.emit('mouse-mode', update.trackMouseClicks, update.trackMouseMovement);
              this.selection.setSelectable(!update.trackMouseClicks && !update.trackMouseMovement);
              if (this.cursor.blinking !== update.cursorBlinking) {
                this.cursor.blinking = update.cursorBlinking;
                this.layout.renderer.resetCursorBlink();
              }
              this.cursor.style = update.cursorStyle;
              this.bracketedPaste = update.bracketedPaste;
              this.reverseVideo = update.reverseVideo;
              this.window.debug &= 1;
              this.window.debug |= +update.debugEnabled << 1;

              this.showLinks = update.showConfigLinks;
              this.showButtons = update.showButtons;
              this.emit('opts-update');
              break;

            case 'double-lines':
              this.screenLines = update.lines;
              this.renderScreen('double-lines');
              break;

            case 'static-opts':
              this.layout.window.fontFamily = update.fontStack || null;
              this.layout.window.fontSize = update.fontSize;
              break;

            case 'cursor':
              if (this.cursor.x !== update.x || this.cursor.y !== update.y || this.cursor.hanging !== update.hanging) {
                this.cursor.x = update.x;
                this.cursor.y = update.y;
                this.cursor.hanging = update.hanging;
                this.layout.renderer.resetCursorBlink();
                this.emit('cursor-moved');
                this.renderScreen('cursor-moved');
              }
              break;

            case 'title':
              this.emit('title-update', this.title = update.title);
              break;

            case 'buttons-update':
              this.emit('buttons-update', update);
              break;

            case 'backdrop':
              this.backgroundImage = update.image;
              break;

            case 'bell':
              this.beep();
              break;

            case 'internal':
              this.emit('internal', update);
              break;

            case 'content':
              var frameX = update.frameX,
                  frameY = update.frameY,
                  frameWidth = update.frameWidth,
                  frameHeight = update.frameHeight,
                  cells = update.cells;


              if (this._debug && this.window.debug) {
                this._debug.pushFrame([frameX, frameY, frameWidth, frameHeight]);
              }

              for (var cell = 0; cell < cells.length; cell++) {
                var data = cells[cell];

                var cellXInFrame = cell % frameWidth;
                var cellYInFrame = Math.floor(cell / frameWidth);
                var index = (frameY + cellYInFrame) * this.window.width + frameX + cellXInFrame;

                if ((this.screenAttrs[index] & ATTR_BLINK) !== (data[3] & ATTR_BLINK)) {
                  if (data[3] & ATTR_BLINK) this.blinkingCellCount++;else this.blinkingCellCount--;
                }

                this.screen[index] = data[0];
                this.screenFG[index] = data[1];
                this.screenBG[index] = data[2];
                this.screenAttrs[index] = data[3];
              }

              if (this.window.debug) console.log('Blinking cells: ' + this.blinkingCellCount);

              this.renderScreen('load');
              this.emit('load');
              break;

            case 'full-load-complete':
              this.emit('full-load');
              break;

            case 'notification':
              this.showNotification(update.content);
              break;

            default:
              console.warn('Unhandled update', update);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.emit('update');
    }
  }]);

  return TermScreen;
}(EventEmitter);

/***/ }),
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var _require = __webpack_require__(6),
    ATTR_FG = _require.ATTR_FG,
    ATTR_BG = _require.ATTR_BG,
    ATTR_BOLD = _require.ATTR_BOLD,
    ATTR_UNDERLINE = _require.ATTR_UNDERLINE,
    ATTR_BLINK = _require.ATTR_BLINK,
    ATTR_STRIKE = _require.ATTR_STRIKE,
    ATTR_OVERLINE = _require.ATTR_OVERLINE,
    ATTR_FAINT = _require.ATTR_FAINT;

// constants for decoding the update blob


var SEQ_SKIP = 1;
var SEQ_REPEAT = 2;
var SEQ_SET_COLORS = 3;
var SEQ_SET_ATTRS = 4;
var SEQ_SET_FG = 5;
var SEQ_SET_BG = 6;
var SEQ_SET_ATTR_0 = 7;

// decode a number encoded as a unicode code point
function du(str) {
  if (!str) return NaN;
  var num = str.codePointAt(0);
  if (num > 0xDFFF) num -= 0x800;
  return num - 1;
}

/* eslint-disable no-multi-spaces */
//                                mnemonic
var TOPIC_SCREEN_OPTS = 'O'; // O-ptions
var TOPIC_STATIC_OPTS = 'P'; // P-arams
var TOPIC_CONTENT = 'S'; // S-creen
var TOPIC_TITLE = 'T'; // T-itle
var TOPIC_BUTTONS = 'B'; // B-uttons
var TOPIC_CURSOR = 'C'; // C-ursor
var TOPIC_INTERNAL = 'D'; // D-ebug
var TOPIC_BELL = '!'; // !!!
var TOPIC_BACKDROP = 'W'; // W-allpaper
var TOPIC_DOUBLE_LINES = 'H'; // H-uge

var OPT_CURSOR_VISIBLE = 1 << 0;
var OPT_DEBUGBAR = 1 << 1;
var OPT_CURSORS_ALT_MODE = 1 << 2;
var OPT_NUMPAD_ALT_MODE = 1 << 3;
var OPT_FN_ALT_MODE = 1 << 4;
var OPT_CLICK_TRACKING = 1 << 5;
var OPT_MOVE_TRACKING = 1 << 6;
var OPT_SHOW_BUTTONS = 1 << 7;
var OPT_SHOW_CONFIG_LINKS = 1 << 8;
// const OPT_CURSOR_SHAPE   = (7 << 9)
var OPT_CRLF_MODE = 1 << 12;
var OPT_BRACKETED_PASTE = 1 << 13;
var OPT_REVERSE_VIDEO = 1 << 14;

/* eslint-enable no-multi-spaces */

/**
 * A parser for screen update messages
 */
module.exports = function () {
  function ScreenParser() {
    _classCallCheck(this, ScreenParser);

    // true if full content was loaded
    this.contentLoaded = false;
  }

  _createClass(ScreenParser, [{
    key: 'parseUpdate',
    value: function parseUpdate(str) {
      // console.log(`update ${str}`)

      // current index
      var ci = 0;
      var strArray = Array.from ? Array.from(str) : str.split('');

      var text = void 0;
      var topics = du(strArray[ci++]);

      var collectOneTerminatedString = function collectOneTerminatedString() {
        // TODO optimize this
        text = '';
        while (ci < strArray.length) {
          var c = strArray[ci++];
          if (c !== '\x01') {
            text += c;
          } else {
            break;
          }
        }
        return text;
      };

      var collectColor = function collectColor() {
        var c = du(strArray[ci++]);
        if (c & 0x10000) {
          // support for trueColor
          c &= 0xFFF;
          c |= (du(strArray[ci++]) & 0xFFF) << 12;
          c += 256;
        }
        return c;
      };

      var updates = [];

      while (ci < strArray.length) {
        var topic = strArray[ci++];

        if (topic === TOPIC_SCREEN_OPTS) {
          var height = du(strArray[ci++]);
          var width = du(strArray[ci++]);
          var theme = du(strArray[ci++]);
          var defFG = collectColor();
          var defBG = collectColor();

          // process attributes
          var attributes = du(strArray[ci++]);

          var cursorVisible = !!(attributes & OPT_CURSOR_VISIBLE);

          // HACK: input alts are formatted as arguments for Input#setAlts
          var inputAlts = [!!(attributes & OPT_CURSORS_ALT_MODE), !!(attributes & OPT_NUMPAD_ALT_MODE), !!(attributes & OPT_FN_ALT_MODE), !!(attributes & OPT_CRLF_MODE)];

          var trackMouseClicks = !!(attributes & OPT_CLICK_TRACKING);
          var trackMouseMovement = !!(attributes & OPT_MOVE_TRACKING);

          // 0 - Block blink     2 - Block steady (1 is unused)
          // 3 - Underline blink 4 - Underline steady
          // 5 - I-bar blink     6 - I-bar steady
          var cursorShape = attributes >> 9 & 0x07;
          // if it's not zero, decrement such that the two most significant bits
          // are the type and the least significant bit is the blink state
          if (cursorShape > 0) cursorShape--;
          var cursorStyle = cursorShape >> 1;
          var cursorBlinking = !(cursorShape & 1);
          if (cursorStyle === 0) cursorStyle = 'block';else if (cursorStyle === 1) cursorStyle = 'line';else cursorStyle = 'bar';

          var showButtons = !!(attributes & OPT_SHOW_BUTTONS);
          var showConfigLinks = !!(attributes & OPT_SHOW_CONFIG_LINKS);

          var bracketedPaste = !!(attributes & OPT_BRACKETED_PASTE);
          var reverseVideo = !!(attributes & OPT_REVERSE_VIDEO);

          var debugEnabled = !!(attributes & OPT_DEBUGBAR);

          updates.push({
            topic: 'screen-opts',
            width: width,
            height: height,
            theme: theme,
            defFG: defFG,
            defBG: defBG,
            cursorVisible: cursorVisible,
            cursorBlinking: cursorBlinking,
            cursorStyle: cursorStyle,
            inputAlts: inputAlts,
            trackMouseClicks: trackMouseClicks,
            trackMouseMovement: trackMouseMovement,
            showButtons: showButtons,
            showConfigLinks: showConfigLinks,
            bracketedPaste: bracketedPaste,
            reverseVideo: reverseVideo,
            debugEnabled: debugEnabled
          });
        } else if (topic === TOPIC_CURSOR) {
          // cursor position
          var y = du(strArray[ci++]);
          var x = du(strArray[ci++]);
          var hanging = !!du(strArray[ci++]);

          updates.push({
            topic: 'cursor',
            x: x,
            y: y,
            hanging: hanging
          });
        } else if (topic === TOPIC_STATIC_OPTS) {
          var fontStack = collectOneTerminatedString();
          var fontSize = du(strArray[ci++]);

          updates.push({
            topic: 'static-opts',
            fontStack: fontStack,
            fontSize: fontSize
          });
        } else if (topic === TOPIC_DOUBLE_LINES) {
          var lines = [];
          var count = du(strArray[ci++]);
          for (var i = 0; i < count; i++) {
            // format: INDEX<<3 | (dbl-h-bot : dbl-h-top : dbl-w)
            var n = du(strArray[ci++]);
            lines[n >> 3] = n & 7;
          }
          updates.push({ topic: 'double-lines', lines: lines });
        } else if (topic === TOPIC_TITLE) {
          updates.push({ topic: 'title', title: collectOneTerminatedString() });
        } else if (topic === TOPIC_BUTTONS) {
          var _count = du(strArray[ci++]);

          var labels = [];
          var colors = [];
          for (var j = 0; j < _count; j++) {
            colors.push(collectColor());
            labels.push(collectOneTerminatedString());
          }

          updates.push({
            topic: 'buttons-update',
            labels: labels,
            colors: colors
          });
        } else if (topic === TOPIC_BACKDROP) {
          updates.push({ topic: 'backdrop', image: collectOneTerminatedString() });
        } else if (topic === TOPIC_BELL) {
          updates.push({ topic: 'bell' });
        } else if (topic === TOPIC_INTERNAL) {
          // debug info
          var flags = du(strArray[ci++]);
          var cursorAttrs = du(strArray[ci++]);
          var regionStart = du(strArray[ci++]);
          var regionEnd = du(strArray[ci++]);
          var charsetGx = du(strArray[ci++]);
          var charsetG0 = strArray[ci++];
          var charsetG1 = strArray[ci++];

          var cursorFg = collectColor();
          var cursorBg = collectColor();

          var freeHeap = du(strArray[ci++]);
          var clientCount = du(strArray[ci++]);

          updates.push({
            topic: 'internal',
            flags: flags,
            cursorAttrs: cursorAttrs,
            regionStart: regionStart,
            regionEnd: regionEnd,
            charsetGx: charsetGx,
            charsetG0: charsetG0,
            charsetG1: charsetG1,
            cursorFg: cursorFg,
            cursorBg: cursorBg,
            freeHeap: freeHeap,
            clientCount: clientCount
          });
        } else if (topic === TOPIC_CONTENT) {
          (function () {
            // set screen content
            var frameY = du(strArray[ci++]);
            var frameX = du(strArray[ci++]);
            var frameHeight = du(strArray[ci++]);
            var frameWidth = du(strArray[ci++]);

            // content
            var fg = 7;
            var bg = 0;
            var attrs = 0;
            var cell = 0; // cell index
            var lastChar = ' ';
            var frameLength = frameWidth * frameHeight;

            var MASK_LINE_ATTR = ATTR_UNDERLINE | ATTR_OVERLINE | ATTR_STRIKE;
            var MASK_BLINK = ATTR_BLINK;

            var cells = [];

            var pushCell = function pushCell() {
              var hasFG = attrs & ATTR_FG;
              var hasBG = attrs & ATTR_BG;
              var cellFG = fg;
              var cellBG = bg;
              var cellAttrs = attrs;

              // use 0,0 if no fg/bg. this is to match back-end implementation
              // and allow leaving out fg/bg setting for cells with none
              if (!hasFG) cellFG = 0;
              if (!hasBG) cellBG = 0;

              // Remove blink attribute if it wouldn't have any effect
              if (cellAttrs & MASK_BLINK && (lastChar === ' ' && (cellAttrs & MASK_LINE_ATTR) === 0 || // no line styles
              fg === bg && hasFG && hasBG // invisible text
              )) {
                cellAttrs ^= MASK_BLINK;
              }

              // 8 dark system colors turn bright when bold
              if (cellAttrs & ATTR_BOLD && !(cellAttrs & ATTR_FAINT) && hasFG && cellFG < 8) {
                cellFG += 8;
              }

              cells.push([lastChar, cellFG, cellBG, cellAttrs]);
            };

            while (ci < strArray.length && cell < frameLength) {
              var character = strArray[ci++];
              var charCode = character.codePointAt(0);

              var data = void 0,
                  _count2 = void 0;
              switch (charCode) {
                case SEQ_REPEAT:
                  _count2 = du(strArray[ci++]);
                  for (var _j = 0; _j < _count2; _j++) {
                    pushCell();
                    if (++cell > frameLength) break;
                  }
                  break;

                case SEQ_SKIP:
                  cell += du(strArray[ci++]);
                  break;

                case SEQ_SET_COLORS:
                  data = du(strArray[ci++]);
                  fg = data & 0xFF;
                  bg = data >> 8 & 0xFF;
                  break;

                case SEQ_SET_ATTRS:
                  data = du(strArray[ci++]);
                  attrs = data & 0xFFFF;
                  break;

                case SEQ_SET_ATTR_0:
                  attrs = 0;
                  break;

                case SEQ_SET_FG:
                  data = du(strArray[ci++]);
                  if (data & 0x10000) {
                    data &= 0xFFF;
                    data |= (du(strArray[ci++]) & 0xFFF) << 12;
                    data += 256;
                  }
                  fg = data;
                  break;

                case SEQ_SET_BG:
                  data = du(strArray[ci++]);
                  if (data & 0x10000) {
                    data &= 0xFFF;
                    data |= (du(strArray[ci++]) & 0xFFF) << 12;
                    data += 256;
                  }
                  bg = data;
                  break;

                default:
                  if (charCode < 32) character = '\uFFFD';
                  lastChar = character;
                  pushCell();
                  cell++;
              }
            }

            updates.push({
              topic: 'content',
              frameX: frameX,
              frameY: frameY,
              frameWidth: frameWidth,
              frameHeight: frameHeight,
              cells: cells
            });
          })();
        }

        if (topics & 0x3B && !this.contentLoaded) {
          updates.push({ topic: 'full-load-complete' });
          this.contentLoaded = true;
        }
      }

      return updates;
    }

    /**
     * Parses a message from the server
     * @param {string} message - the message
     */

  }, {
    key: 'parse',
    value: function parse(message) {
      var content = message.substr(1);
      var updates = [];

      // This is a good place for debugging the message
      // console.log(message)

      switch (message[0]) {
        case 'U':
          updates.push.apply(updates, _toConsumableArray(this.parseUpdate(content)));
          break;

        case 'G':
          return [{
            topic: 'notification',
            content: content
          }];

        default:
          console.warn('Bad data message type; ignoring.\n' + JSON.stringify(message));
      }

      return updates;
    }
  }]);

  return ScreenParser;
}();

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventEmitter = __webpack_require__(2);
var CanvasRenderer = __webpack_require__(20);

var DEFAULT_FONT = '"DejaVu Sans Mono", "Liberation Mono", "Inconsolata", "Menlo", monospace';

/**
 * Manages terminal screen layout and sizing
 */
module.exports = function (_EventEmitter) {
  _inherits(ScreenLayout, _EventEmitter);

  function ScreenLayout() {
    _classCallCheck(this, ScreenLayout);

    var _this = _possibleConstructorReturn(this, (ScreenLayout.__proto__ || Object.getPrototypeOf(ScreenLayout)).call(this));

    _this.canvas = document.createElement('canvas');
    _this.renderer = new CanvasRenderer(_this.canvas);

    _this._window = {
      width: 0,
      height: 0,
      devicePixelRatio: 1,
      fontFamily: DEFAULT_FONT,
      fontSize: 20,
      padding: 6,
      gridScaleX: 1.0,
      gridScaleY: 1.2,
      fitIntoWidth: 0,
      fitIntoHeight: 0,
      debug: false

      // scaling caused by fitIntoWidth/fitIntoHeight
    };_this._windowScale = 1;

    // actual padding, as it may be disabled by fullscreen mode etc.
    _this._padding = 0;

    // properties of this.window that require updating size and redrawing
    _this.windowState = {
      width: 0,
      height: 0,
      devicePixelRatio: 0,
      padding: 0,
      gridScaleX: 0,
      gridScaleY: 0,
      fontFamily: '',
      fontSize: 0,
      fitIntoWidth: 0,
      fitIntoHeight: 0
    };

    _this.charSize = { width: 0, height: 0 };

    var self = _this;

    // make writing to window update size and draw
    _this.window = new Proxy(_this._window, {
      set: function set(target, key, value) {
        if (target[key] !== value) {
          target[key] = value;
          self.scheduleSizeUpdate();
          self.renderer.scheduleDraw('window:' + key + '=' + value);
          self.emit('update-window:' + key, value);
        }
        return true;
      }
    });

    _this.on('update-window:debug', function (debug) {
      _this.renderer.debug = debug;
    });

    _this.canvas.addEventListener('mousedown', function (e) {
      return _this.emit('mousedown', e);
    });
    _this.canvas.addEventListener('mousemove', function (e) {
      return _this.emit('mousemove', e);
    });
    _this.canvas.addEventListener('mouseup', function (e) {
      return _this.emit('mouseup', e);
    });
    _this.canvas.addEventListener('touchstart', function (e) {
      return _this.emit('touchstart', e);
    });
    _this.canvas.addEventListener('touchmove', function (e) {
      return _this.emit('touchmove', e);
    });
    _this.canvas.addEventListener('touchend', function (e) {
      return _this.emit('touchend', e);
    });
    _this.canvas.addEventListener('wheel', function (e) {
      return _this.emit('wheel', e);
    });
    _this.canvas.addEventListener('contextmenu', function (e) {
      return _this.emit('contextmenu', e);
    });
    return _this;
  }

  /**
   * Schedule a size update in the next millisecond
   */


  _createClass(ScreenLayout, [{
    key: 'scheduleSizeUpdate',
    value: function scheduleSizeUpdate() {
      var _this2 = this;

      clearTimeout(this._scheduledSizeUpdate);
      this._scheduledSizeUpdate = setTimeout(function () {
        return _this2.updateSize();
      }, 1);
    }
  }, {
    key: 'getFont',


    /**
     * Returns a CSS font string with the current font settings and the
     * specified modifiers.
     * @param {Object} modifiers
     * @param {string} [modifiers.style] - the font style
     * @param {string} [modifiers.weight] - the font weight
     * @returns {string} a CSS font string
     */
    value: function getFont() {
      var modifiers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      var fontStyle = modifiers.style || 'normal';
      var fontWeight = modifiers.weight || 'normal';
      var fontFamily = this.window.fontFamily || '';
      if (fontFamily.length > 0) fontFamily += ',';
      fontFamily += DEFAULT_FONT;
      return fontStyle + ' normal ' + fontWeight + ' ' + this.window.fontSize + 'px ' + fontFamily;
    }

    /**
     * Converts screen coordinates to grid coordinates.
     * @param {number} x - x in pixels
     * @param {number} y - y in pixels
     * @param {boolean} rounded - whether to round the coord, used for select highlighting
     * @returns {number[]} a tuple of (x, y) in cells
     */

  }, {
    key: 'screenToGrid',
    value: function screenToGrid(x, y) {
      var rounded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var cellSize = this.getCellSize();

      x = x / this._windowScale - this._padding;
      y = y / this._windowScale - this._padding;
      y = Math.floor(y / cellSize.height);
      if (this.renderer.drawnScreenLines[y]) x /= 2; // double size
      x = Math.floor((x + (rounded ? cellSize.width / 2 : 0)) / cellSize.width);
      x = Math.max(0, Math.min(this.window.width - 1, x));
      y = Math.max(0, Math.min(this.window.height - 1, y));

      return [x, y];
    }

    /**
     * Converts grid coordinates to screen coordinates.
     * @param {number} x - x in cells
     * @param {number} y - y in cells
     * @param {boolean} [withScale] - when true, will apply window scale
     * @returns {number[]} a tuple of (x, y) in pixels
     */

  }, {
    key: 'gridToScreen',
    value: function gridToScreen(x, y) {
      var _this3 = this;

      var withScale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

      var cellSize = this.getCellSize();

      if (this.renderer.drawnScreenLines[y]) x *= 2; // double size

      return [x * cellSize.width, y * cellSize.height].map(function (v) {
        return _this3._padding + (withScale ? v * _this3._windowScale : v);
      });
    }

    /**
     * Update the character size, used for calculating the cell size.
     * The space character is used for measuring.
     * @returns {Object} the character size with `width` and `height` in pixels
     */

  }, {
    key: 'updateCharSize',
    value: function updateCharSize() {
      this.charSize = {
        width: this.renderer.getCharWidthFor(this.getFont()),
        height: this.window.fontSize
      };

      return this.charSize;
    }

    /**
     * The cell size, which is the character size multiplied by the grid scale.
     * @returns {Object} the cell size with `width` and `height` in pixels
     */

  }, {
    key: 'getCellSize',
    value: function getCellSize() {
      if (!this.charSize.height && this.window.fontSize) this.updateCharSize();

      return {
        width: Math.ceil(this.charSize.width * this.window.gridScaleX),
        height: Math.ceil(this.charSize.height * this.window.gridScaleY)
      };
    }

    /**
     * Updates the canvas size if it changed
     */

  }, {
    key: 'updateSize',
    value: function updateSize() {
      // see below (this is just updating it)
      this._window.devicePixelRatio = Math.ceil(this._windowScale * (window.devicePixelRatio || 1));

      var didChange = false;
      for (var key in this.windowState) {
        if (this.windowState.hasOwnProperty(key) && this.windowState[key] !== this.window[key]) {
          didChange = true;
          this.windowState[key] = this.window[key];
        }
      }

      if (didChange) {
        var _window = this.window,
            width = _window.width,
            height = _window.height,
            fitIntoWidth = _window.fitIntoWidth,
            fitIntoHeight = _window.fitIntoHeight,
            padding = _window.padding;


        this.updateCharSize();
        var cellSize = this.getCellSize();

        // real height of the canvas element in pixels
        var realWidth = width * cellSize.width;
        var realHeight = height * cellSize.height;
        var originalWidth = realWidth;

        if (fitIntoWidth && fitIntoHeight) {
          var terminalAspect = realWidth / realHeight;
          var fitAspect = fitIntoWidth / fitIntoHeight;

          if (terminalAspect < fitAspect) {
            // align heights
            realHeight = fitIntoHeight - 2 * padding;
            realWidth = realHeight * terminalAspect;
          } else {
            // align widths
            realWidth = fitIntoWidth - 2 * padding;
            realHeight = realWidth / terminalAspect;
          }
        }

        // store new window scale
        this._windowScale = realWidth / originalWidth;

        realWidth += 2 * padding;
        realHeight += 2 * padding;

        // store padding
        this._padding = padding * (originalWidth / realWidth);

        // the DPR must be rounded to a very nice value to prevent gaps between cells
        var devicePixelRatio = this._window.devicePixelRatio = Math.ceil(this._windowScale * (window.devicePixelRatio || 1));

        this.canvas.width = (width * cellSize.width + 2 * Math.round(this._padding)) * devicePixelRatio;
        this.canvas.style.width = realWidth + 'px';
        this.canvas.height = (height * cellSize.height + 2 * Math.round(this._padding)) * devicePixelRatio;
        this.canvas.style.height = realHeight + 'px';

        // the screen has been cleared (by changing canvas width)
        this.renderer.resetDrawn();

        this.renderer.render('update-size', this.serializeRenderData());

        this.emit('size-update');
      }
    }
  }, {
    key: 'serializeRenderData',
    value: function serializeRenderData() {
      return {
        padding: Math.round(this._padding),
        devicePixelRatio: this.window.devicePixelRatio,
        charSize: this.charSize,
        cellSize: this.getCellSize(),
        fonts: [this.getFont(), this.getFont({ weight: 'bold' }), this.getFont({ style: 'italic' }), this.getFont({ weight: 'bold', style: 'italic' })]
      };
    }
  }, {
    key: 'render',
    value: function render(reason, data) {
      this.window.width = data.width;
      this.window.height = data.height;

      Object.assign(data, this.serializeRenderData());

      this.renderer.render(reason, data);
    }
  }, {
    key: 'backgroundImage',
    get: function get() {
      return this.canvas.style.backgroundImage;
    },
    set: function set(value) {
      this.canvas.style.backgroundImage = value ? 'url(' + value + ')' : '';
      if (this.renderer.backgroundImage !== !!value) {
        this.renderer.backgroundImage = !!value;
        this.renderer.resetDrawn();
        this.renderer.scheduleDraw('background-image');
      }
    }
  }, {
    key: 'selectable',
    get: function get() {
      return this.canvas.classList.contains('selectable');
    },
    set: function set(selectable) {
      if (selectable) this.canvas.classList.add('selectable');else this.canvas.classList.remove('selectable');
    }
  }]);

  return ScreenLayout;
}(EventEmitter);

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventEmitter = __webpack_require__(2);

var _require = __webpack_require__(3),
    themes = _require.themes,
    _getColor = _require.getColor;

var _require2 = __webpack_require__(6),
    ATTR_FG = _require2.ATTR_FG,
    ATTR_BG = _require2.ATTR_BG,
    ATTR_BOLD = _require2.ATTR_BOLD,
    ATTR_UNDERLINE = _require2.ATTR_UNDERLINE,
    ATTR_INVERSE = _require2.ATTR_INVERSE,
    ATTR_BLINK = _require2.ATTR_BLINK,
    ATTR_ITALIC = _require2.ATTR_ITALIC,
    ATTR_STRIKE = _require2.ATTR_STRIKE,
    ATTR_OVERLINE = _require2.ATTR_OVERLINE,
    ATTR_FAINT = _require2.ATTR_FAINT,
    ATTR_FRAKTUR = _require2.ATTR_FRAKTUR;

// Some non-bold Fraktur symbols are outside the contiguous block


var frakturExceptions = {
  'C': '\u212D',
  'H': '\u210C',
  'I': '\u2111',
  'R': '\u211C',
  'Z': '\u2128'

  /**
   * A terminal screen renderer, using canvas 2D
   */
};module.exports = function (_EventEmitter) {
  _inherits(CanvasRenderer, _EventEmitter);

  function CanvasRenderer(canvas) {
    _classCallCheck(this, CanvasRenderer);

    var _this = _possibleConstructorReturn(this, (CanvasRenderer.__proto__ || Object.getPrototypeOf(CanvasRenderer)).call(this));

    _this.canvas = canvas;
    _this.ctx = _this.canvas.getContext('2d');

    _this._palette = null; // colors 0-15
    _this.defaultBG = 0;
    _this.defaultFG = 7;

    _this.debug = false;
    _this._debug = null;

    _this.graphics = 0;

    _this.statusFont = "-apple-system, BlinkMacSystemFont, 'Helvetica Neue', Helvetica, Roboto, Arial, sans-serif";

    // screen data, considered immutable
    _this.width = 0;
    _this.height = 0;
    _this.padding = 0;
    _this.charSize = { width: 0, height: 0 };
    _this.cellSize = { width: 0, height: 0 };
    _this.fonts = ['', '', '', '']; // normal, bold, italic, bold-italic
    _this.screen = [];
    _this.screenFG = [];
    _this.screenBG = [];
    _this.screenAttrs = [];
    _this.screenSelection = [];
    _this.screenLines = [];
    _this.cursor = {};
    _this.reverseVideo = false;
    _this.hasBlinkingCells = false;
    _this.statusScreen = null;

    _this.resetDrawn();

    _this.blinkStyleOn = false;
    _this.blinkInterval = null;
    _this.cursorBlinkOn = false;
    _this.cursorBlinkInterval = null;

    // start blink timers
    _this.resetBlink();
    _this.resetCursorBlink();
    return _this;
  }

  _createClass(CanvasRenderer, [{
    key: 'render',
    value: function render(reason, data) {
      if ('hasBlinkingCells' in data && data.hasBlinkingCells !== this.hasBlinkingCells) {
        if (data.hasBlinkingCells) this.resetBlink();else clearInterval(this.blinkInterval);
      }

      Object.assign(this, data);
      this.scheduleDraw(reason);
    }
  }, {
    key: 'resetDrawn',
    value: function resetDrawn() {
      // used to determine if a cell should be redrawn; storing the current state
      // as it is on screen
      if (this.debug) console.log('Resetting drawn screen');

      this.drawnScreen = [];
      this.drawnScreenFG = [];
      this.drawnScreenBG = [];
      this.drawnScreenAttrs = [];
      this.drawnScreenLines = [];
      this.drawnCursor = [-1, -1, '', false];
    }

    /**
     * The color palette. Should define 16 colors in an array.
     * @type {string[]}
     */

  }, {
    key: 'getCharWidthFor',
    value: function getCharWidthFor(font) {
      this.ctx.font = font;
      return Math.floor(this.ctx.measureText(' ').width);
    }
  }, {
    key: 'loadTheme',
    value: function loadTheme(i) {
      if (i in themes) this.palette = themes[i];
    }
  }, {
    key: 'setDefaultColors',
    value: function setDefaultColors(fg, bg) {
      if (fg !== this.defaultFG || bg !== this.defaultBG) {
        this.resetDrawn();
        this.defaultFG = fg;
        this.defaultBG = bg;
        this.scheduleDraw('default-colors');

        // full bg with default color (goes behind the image)
        this.canvas.style.backgroundColor = this.getColor(bg);
      }
    }

    /**
     * Schedule a draw in the next millisecond
     * @param {string} why - the reason why the draw occured (for debugging)
     * @param {number} [aggregateTime] - time to wait for more scheduleDraw calls
     *   to occur. 1 ms by default.
     */

  }, {
    key: 'scheduleDraw',
    value: function scheduleDraw(why) {
      var _this2 = this;

      var aggregateTime = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

      clearTimeout(this._scheduledDraw);
      this._scheduledDraw = setTimeout(function () {
        return _this2.draw(why);
      }, aggregateTime);
    }

    /**
     * Returns the specified color. If `i` is in the palette, it will return the
     * palette color. If `i` is between 16 and 255, it will return the 256color
     * value. If `i` is larger than 255, it will return an RGB color value. If `i`
     * is -1 (foreground) or -2 (background), it will return the selection colors.
     * @param {number} i - the color
     * @returns {string} the CSS color
     */

  }, {
    key: 'getColor',
    value: function getColor(i) {
      return _getColor(i, this.palette);
    }

    /**
     * Resets the cursor blink to on and restarts the timer
     */

  }, {
    key: 'resetCursorBlink',
    value: function resetCursorBlink() {
      var _this3 = this;

      this.cursorBlinkOn = true;
      clearInterval(this.cursorBlinkInterval);
      this.cursorBlinkInterval = setInterval(function () {
        _this3.cursorBlinkOn = _this3.cursor.blinking ? !_this3.cursorBlinkOn : true;
        if (_this3.cursor.blinking) _this3.scheduleDraw('cursor-blink');
      }, 500);
    }

    /**
     * Resets the blink style to on and restarts the timer
     */

  }, {
    key: 'resetBlink',
    value: function resetBlink() {
      var _this4 = this;

      this.blinkStyleOn = true;
      clearInterval(this.blinkInterval);
      var intervals = 0;
      this.blinkInterval = setInterval(function () {
        if (_this4.blinkingCellCount <= 0) return;

        intervals++;
        if (intervals >= 4 && _this4.blinkStyleOn) {
          _this4.blinkStyleOn = false;
          intervals = 0;
          _this4.scheduleDraw('blink-style');
        } else if (intervals >= 1 && !_this4.blinkStyleOn) {
          _this4.blinkStyleOn = true;
          intervals = 0;
          _this4.scheduleDraw('blink-style');
        }
      }, 200);
    }

    /**
     * Draws a cell's background with the given parameters.
     * @param {Object} options
     * @param {number} options.x - x in cells
     * @param {number} options.y - y in cells
     * @param {number} options.cellWidth - cell width in pixels
     * @param {number} options.cellHeight - cell height in pixels
     * @param {number} options.bg - the background color
     * @param {number} options.isDefaultBG - if true, will draw image background if available
     */

  }, {
    key: 'drawBackground',
    value: function drawBackground(_ref) {
      var x = _ref.x,
          y = _ref.y,
          cellWidth = _ref.cellWidth,
          cellHeight = _ref.cellHeight,
          bg = _ref.bg,
          isDefaultBG = _ref.isDefaultBG;
      var ctx = this.ctx,
          width = this.width,
          height = this.height,
          padding = this.padding;

      // is a double-width/double-height line

      if (this.screenLines[y] & 1) cellWidth *= 2;

      ctx.fillStyle = this.getColor(bg);
      var screenX = x * cellWidth + padding;
      var screenY = y * cellHeight + padding;
      var isBorderCell = x === 0 || y === 0 || x === width - 1 || y === height - 1;

      var fillX = void 0,
          fillY = void 0,
          fillWidth = void 0,
          fillHeight = void 0;
      if (isBorderCell) {
        var left = screenX;
        var top = screenY;
        var right = screenX + cellWidth;
        var bottom = screenY + cellHeight;
        if (x === 0) left -= padding;else if (x === width - 1) right += padding;
        if (y === 0) top -= padding;else if (y === height - 1) bottom += padding;

        fillX = left;
        fillY = top;
        fillWidth = right - left;
        fillHeight = bottom - top;
      } else {
        fillX = screenX;
        fillY = screenY;
        fillWidth = cellWidth;
        fillHeight = cellHeight;
      }

      ctx.clearRect(fillX, fillY, fillWidth, fillHeight);

      if (!isDefaultBG || bg < 0 || !this.backgroundImage) {
        ctx.fillRect(fillX, fillY, fillWidth, fillHeight);
      }
    }

    /**
     * Draws a cell's character with the given parameters. Won't do anything if
     * text is an empty string.
     * @param {Object} options
     * @param {number} options.x - x in cells
     * @param {number} options.y - y in cells
     * @param {Object} options.charSize - the character size, an object with
     *   `width` and `height` in pixels
     * @param {number} options.cellWidth - cell width in pixels
     * @param {number} options.cellHeight - cell height in pixels
     * @param {string} options.text - the cell content
     * @param {number} options.fg - the foreground color
     * @param {number} options.attrs - the cell's attributes
     */

  }, {
    key: 'drawCharacter',
    value: function drawCharacter(_ref2) {
      var x = _ref2.x,
          y = _ref2.y,
          charSize = _ref2.charSize,
          cellWidth = _ref2.cellWidth,
          cellHeight = _ref2.cellHeight,
          text = _ref2.text,
          fg = _ref2.fg,
          attrs = _ref2.attrs;

      if (!text) return;

      var ctx = this.ctx,
          padding = this.padding;


      var underline = false;
      var strike = false;
      var overline = false;
      if (attrs & ATTR_FAINT) ctx.globalAlpha = 0.5;
      if (attrs & ATTR_UNDERLINE) underline = true;
      if (attrs & ATTR_FRAKTUR) text = CanvasRenderer.alphaToFraktur(text);
      if (attrs & ATTR_STRIKE) strike = true;
      if (attrs & ATTR_OVERLINE) overline = true;

      ctx.fillStyle = this.getColor(fg);

      var screenX = x * cellWidth + padding;
      var screenY = y * cellHeight + padding;

      var dblWidth = this.screenLines[y] & 1;
      var dblHeightTop = this.screenLines[y] & 2;
      var dblHeightBot = this.screenLines[y] & 4;

      if (this.screenLines[y]) {
        // is a double-width/double-height line
        if (dblWidth) cellWidth *= 2;

        ctx.save();
        ctx.translate(padding, screenY + 0.5 * cellHeight);
        if (dblWidth) ctx.scale(2, 1);
        if (dblHeightTop) {
          // top half
          ctx.scale(1, 2);
          ctx.translate(0, cellHeight / 4);
        } else if (dblHeightBot) {
          // bottom half
          ctx.scale(1, 2);
          ctx.translate(0, -cellHeight / 4);
        }
        ctx.translate(-padding, -screenY - 0.5 * cellHeight);
        if (dblWidth) ctx.translate(-cellWidth / 4, 0);

        if (dblHeightBot || dblHeightTop) {
          // characters overflow -- needs clipping
          // TODO: clipping is really expensive
          ctx.beginPath();
          if (dblHeightTop) ctx.rect(screenX, screenY, cellWidth, cellHeight / 2);else ctx.rect(screenX, screenY + cellHeight / 2, cellWidth, cellHeight / 2);
          ctx.clip();
        }
      }

      var codePoint = text.codePointAt(0);
      if (codePoint >= 0x2580 && codePoint <= 0x259F) {
        // block elements
        ctx.beginPath();
        var left = screenX;
        var top = screenY;
        var cw = cellWidth;
        var ch = cellHeight;
        var c2w = cellWidth / 2;
        var c2h = cellHeight / 2;

        // http://www.fileformat.info/info/unicode/block/block_elements/utf8test.htm
        //         0x00  0x01  0x02  0x03  0x04  0x05  0x06  0x07  0x08  0x09  0x0A  0x0B  0x0C  0x0D  0x0E  0x0F
        // 0x2580     ▀     ▁     ▂     ▃     ▄     ▅     ▆     ▇     █     ▉     ▊     ▋     ▌     ▍     ▎     ▏
        // 0x2590     ▐     ░     ▒     ▓     ▔     ▕     ▖     ▗     ▘     ▙     ▚     ▛     ▜     ▝     ▞     ▟

        if (codePoint === 0x2580) {
          // upper half block >▀<
          ctx.rect(left, top, cw, c2h);
        } else if (codePoint <= 0x2588) {
          // lower n eighth block (increasing) >▁< to >█<
          var offset = (1 - (codePoint - 0x2580) / 8) * ch;
          ctx.rect(left, top + offset, cw, ch - offset);
        } else if (codePoint <= 0x258F) {
          // left n eighth block (decreasing) >▉< to >▏<
          var _offset = (codePoint - 0x2588) / 8 * cw;
          ctx.rect(left, top, cw - _offset, ch);
        } else if (codePoint === 0x2590) {
          // right half block >▐<
          ctx.rect(left + c2w, top, c2w, ch);
        } else if (codePoint <= 0x2593) {
          // shading >░< >▒< >▓<

          // dot spacing by dividing cell size by a constant. This could be
          // reworked to always return a whole number, but that would require
          // prime factorization, and doing that without a loop would let you
          // take over the world, which is not within the scope of this project.
          var dotSpacingX = void 0,
              dotSpacingY = void 0,
              dotSize = void 0;
          if (codePoint === 0x2591) {
            dotSpacingX = cw / 4;
            dotSpacingY = ch / 10;
            dotSize = 1;
          } else if (codePoint === 0x2592) {
            dotSpacingX = cw / 6;
            dotSpacingY = cw / 10;
            dotSize = 1;
          } else if (codePoint === 0x2593) {
            dotSpacingX = cw / 4;
            dotSpacingY = cw / 7;
            dotSize = 2;
          }

          var alignRight = false;
          for (var dy = 0; dy < ch; dy += dotSpacingY) {
            for (var dx = 0; dx < cw; dx += dotSpacingX) {
              // prevent overflow
              var dotSizeY = Math.min(dotSize, ch - dy);
              ctx.rect(left + (alignRight ? cw - dx - dotSize : dx), top + dy, dotSize, dotSizeY);
            }
            alignRight = !alignRight;
          }
        } else if (codePoint === 0x2594) {
          // upper one eighth block >▔<
          ctx.rect(left, top, cw, ch / 8);
        } else if (codePoint === 0x2595) {
          // right one eighth block >▕<
          ctx.rect(left + 7 / 8 * cw, top, cw / 8, ch);
        } else if (codePoint === 0x2596) {
          // left bottom quadrant >▖<
          ctx.rect(left, top + c2h, c2w, c2h);
        } else if (codePoint === 0x2597) {
          // right bottom quadrant >▗<
          ctx.rect(left + c2w, top + c2h, c2w, c2h);
        } else if (codePoint === 0x2598) {
          // left top quadrant >▘<
          ctx.rect(left, top, c2w, c2h);
        } else if (codePoint === 0x2599) {
          // left chair >▙<
          ctx.rect(left, top, c2w, ch);
          ctx.rect(left + c2w, top + c2h, c2w, c2h);
        } else if (codePoint === 0x259A) {
          // quadrants lt rb >▚<
          ctx.rect(left, top, c2w, c2h);
          ctx.rect(left + c2w, top + c2h, c2w, c2h);
        } else if (codePoint === 0x259B) {
          // left chair upside down >▛<
          ctx.rect(left, top, c2w, ch);
          ctx.rect(left + c2w, top, c2w, c2h);
        } else if (codePoint === 0x259C) {
          // right chair upside down >▜<
          ctx.rect(left, top, cw, c2h);
          ctx.rect(left + c2w, top + c2h, c2w, c2h);
        } else if (codePoint === 0x259D) {
          // right top quadrant >▝<
          ctx.rect(left + c2w, top, c2w, c2h);
        } else if (codePoint === 0x259E) {
          // quadrants lb rt >▞<
          ctx.rect(left, top + c2h, c2w, c2h);
          ctx.rect(left + c2w, top, c2w, c2h);
        } else if (codePoint === 0x259F) {
          // right chair upside down >▟<
          ctx.rect(left, top + c2h, c2w, c2h);
          ctx.rect(left + c2w, top, c2w, ch);
        }

        ctx.fill();
      } else if (codePoint >= 0xE0B0 && codePoint <= 0xE0B3) {
        // powerline symbols, except branch, line, and lock. Basically, just the triangles
        ctx.beginPath();

        if (codePoint === 0xE0B0 || codePoint === 0xE0B1) {
          // right-pointing triangle
          ctx.moveTo(screenX, screenY);
          ctx.lineTo(screenX + cellWidth, screenY + cellHeight / 2);
          ctx.lineTo(screenX, screenY + cellHeight);
        } else if (codePoint === 0xE0B2 || codePoint === 0xE0B3) {
          // left-pointing triangle
          ctx.moveTo(screenX + cellWidth, screenY);
          ctx.lineTo(screenX, screenY + cellHeight / 2);
          ctx.lineTo(screenX + cellWidth, screenY + cellHeight);
        }

        if (codePoint % 2 === 0) {
          // triangle
          ctx.fill();
        } else {
          // chevron
          ctx.strokeStyle = ctx.fillStyle;
          ctx.stroke();
        }
      } else {
        // Draw other characters using the text renderer
        ctx.fillText(text, screenX + 0.5 * cellWidth, screenY + 0.5 * cellHeight);
      }

      // -- line drawing - a reference for a possible future rect/line implementation ---
      // http://www.fileformat.info/info/unicode/block/box_drawing/utf8test.htm
      //         0x00  0x01  0x02  0x03  0x04  0x05  0x06  0x07  0x08  0x09  0x0A  0x0B  0x0C  0x0D  0x0E  0x0F
      // 0x2500     ─     ━     │     ┃     ┄     ┅     ┆     ┇     ┈     ┉     ┊     ┋     ┌     ┍     ┎     ┏
      // 0x2510     ┐     ┑     ┒     ┓     └     ┕     ┖     ┗     ┘     ┙     ┚     ┛     ├     ┝     ┞     ┟
      // 0x2520     ┠     ┡     ┢     ┣     ┤     ┥     ┦     ┧     ┨     ┩     ┪     ┫     ┬     ┭     ┮     ┯
      // 0x2530     ┰     ┱     ┲     ┳     ┴     ┵     ┶     ┷     ┸     ┹     ┺     ┻     ┼     ┽     ┾     ┿
      // 0x2540     ╀     ╁     ╂     ╃     ╄     ╅     ╆     ╇     ╈     ╉     ╊     ╋     ╌     ╍     ╎     ╏
      // 0x2550     ═     ║     ╒     ╓     ╔     ╕     ╖     ╗     ╘     ╙     ╚     ╛     ╜     ╝     ╞     ╟
      // 0x2560     ╠     ╡     ╢     ╣     ╤     ╥     ╦     ╧     ╨     ╩     ╪     ╫     ╬     ╭     ╮     ╯
      // 0x2570     ╰     ╱     ╲     ╳     ╴     ╵     ╶     ╷     ╸     ╹     ╺     ╻     ╼     ╽     ╾     ╿

      if (underline || strike || overline) {
        ctx.strokeStyle = this.getColor(fg);
        ctx.lineWidth = 1;
        ctx.lineCap = 'round';
        ctx.beginPath();

        if (underline) {
          var lineY = Math.round(screenY + charSize.height) + 0.5;
          ctx.moveTo(screenX, lineY);
          ctx.lineTo(screenX + cellWidth, lineY);
        }

        if (strike) {
          var _lineY = Math.round(screenY + 0.5 * cellHeight) + 0.5;
          ctx.moveTo(screenX, _lineY);
          ctx.lineTo(screenX + cellWidth, _lineY);
        }

        if (overline) {
          var _lineY2 = Math.round(screenY) + 0.5;
          ctx.moveTo(screenX, _lineY2);
          ctx.lineTo(screenX + cellWidth, _lineY2);
        }

        ctx.stroke();
      }

      if (this.screenLines[y]) ctx.restore();

      ctx.globalAlpha = 1;
    }

    /**
     * Returns all adjacent cell indices given a radius.
     * @param {number} cell - the center cell index
     * @param {number} [radius] - the radius. 1 by default
     * @returns {number[]} an array of cell indices
     */

  }, {
    key: 'getAdjacentCells',
    value: function getAdjacentCells(cell) {
      var radius = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
      var width = this.width,
          height = this.height;

      var screenLength = width * height;

      var cells = [];

      for (var x = -radius; x <= radius; x++) {
        for (var y = -radius; y <= radius; y++) {
          if (x === 0 && y === 0) continue;
          cells.push(cell + x + y * width);
        }
      }

      return cells.filter(function (cell) {
        return cell >= 0 && cell < screenLength;
      });
    }

    /**
     * Updates the screen.
     * @param {string} why - the draw reason (for debugging)
     */

  }, {
    key: 'draw',
    value: function draw(why) {
      var ctx = this.ctx;
      var width = this.width,
          height = this.height,
          devicePixelRatio = this.devicePixelRatio,
          statusScreen = this.statusScreen;


      if (statusScreen) {
        // draw status screen instead
        this.drawStatus(statusScreen);
        this.startDrawLoop();
        return;
      } else this.stopDrawLoop();

      var charSize = this.charSize;
      var _cellSize = this.cellSize,
          cellWidth = _cellSize.width,
          cellHeight = _cellSize.height;

      var screenLength = width * height;

      ctx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);

      if (this.debug && this._debug) this._debug.drawStart(why);

      ctx.font = this.fonts[0];
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';

      // bits in the attr value that affect the font
      var FONT_MASK = ATTR_BOLD | ATTR_ITALIC;

      // Map of (attrs & FONT_MASK) -> Array of cell indices
      var fontGroups = new Map();

      // Map of (cell index) -> boolean, whether or not a cell has updated
      var updateMap = new Map();

      for (var cell = 0; cell < screenLength; cell++) {
        var x = cell % width;
        var y = Math.floor(cell / width);
        var isCursor = this.cursorBlinkOn && this.cursor.x === x && this.cursor.y === y && this.cursor.visible;

        var wasCursor = x === this.drawnCursor[0] && y === this.drawnCursor[1];

        var text = this.screen[cell];
        var fg = this.screenFG[cell] | 0;
        var bg = this.screenBG[cell] | 0;
        var attrs = this.screenAttrs[cell] | 0;
        var inSelection = this.screenSelection[cell];

        var isDefaultBG = false;

        if (!(attrs & ATTR_FG)) fg = this.defaultFG;
        if (!(attrs & ATTR_BG)) {
          bg = this.defaultBG;
          isDefaultBG = true;
        }

        if (attrs & ATTR_INVERSE) {
          ;var _ref3 = [bg, fg];
          fg = _ref3[0];
          bg = _ref3[1];
        } // swap - reversed character colors
        if (this.reverseVideo) {
          ;var _ref4 = [bg, fg];
          fg = _ref4[0];
          bg = _ref4[1];
        } // swap - reversed all screen

        if (attrs & ATTR_BLINK && !this.blinkStyleOn) {
          // blinking is enabled and blink style is off
          // set text to nothing so drawCharacter only draws decoration
          text = ' ';
        }

        if (inSelection) {
          fg = -1;
          bg = -2;
        }

        var didUpdate = text !== this.drawnScreen[cell] || // text updated
        fg !== this.drawnScreenFG[cell] || // foreground updated, and this cell has text
        bg !== this.drawnScreenBG[cell] || // background updated
        attrs !== this.drawnScreenAttrs[cell] || // attributes updated
        this.screenLines[y] !== this.drawnScreenLines[y] || // line updated
        // TODO: fix artifacts or keep this hack:
        isCursor || wasCursor || // cursor blink/position updated
        isCursor && this.cursor.style !== this.drawnCursor[2] || // cursor style updated
        isCursor && this.cursor.hanging !== this.drawnCursor[3]; // cursor hanging updated

        var font = attrs & FONT_MASK;
        if (!fontGroups.has(font)) fontGroups.set(font, []);

        fontGroups.get(font).push({ cell: cell, x: x, y: y, text: text, fg: fg, bg: bg, attrs: attrs, isCursor: isCursor, inSelection: inSelection, isDefaultBG: isDefaultBG });
        updateMap.set(cell, didUpdate);
      }

      // set drawn screen lines
      this.drawnScreenLines = this.screenLines.slice();

      var debugFilledUpdates = [];

      if (this.graphics >= 1) {
        // fancy graphics gets really slow when there's a lot of masks
        // so here's an algorithm that fills in holes in the update map

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = updateMap.keys()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var _cell = _step.value;

            if (updateMap.get(_cell)) continue;
            var previous = updateMap.get(_cell - 1) || false;
            var next = updateMap.get(_cell + 1) || false;

            if (previous && next) {
              // set cell to true of horizontally adjacent updated
              updateMap.set(_cell, true);
              if (this.debug && this._debug) debugFilledUpdates.push(_cell);
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      // Map of (cell index) -> boolean, whether or not a cell should be redrawn
      var redrawMap = new Map();
      var maskedCells = new Map();

      var isTextWide = function isTextWide(text) {
        return text !== ' ' && ctx.measureText(text).width >= cellWidth + 0.05;
      };

      // decide for each cell if it should be redrawn
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = updateMap.keys()[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _cell2 = _step2.value;

          var shouldUpdate = updateMap.get(_cell2) || redrawMap.get(_cell2) || false;

          // TODO: fonts (necessary?)
          var _text = this.screen[_cell2];
          var isWideCell = isTextWide(_text);
          var checkRadius = isWideCell ? 2 : 1;

          if (!shouldUpdate) {
            // check adjacent cells
            var adjacentDidUpdate = false;

            var _iteratorNormalCompletion6 = true;
            var _didIteratorError6 = false;
            var _iteratorError6 = undefined;

            try {
              for (var _iterator6 = this.getAdjacentCells(_cell2, checkRadius)[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
                var adjacentCell = _step6.value;

                // update this cell if:
                // - the adjacent cell updated (For now, this'll always be true because characters can be slightly larger than they say they are)
                // - the adjacent cell updated and this cell or the adjacent cell is wide
                // - this or the adjacent cell is not double-sized
                if (updateMap.get(adjacentCell) && (this.graphics < 2 || isWideCell || isTextWide(this.screen[adjacentCell])) && !this.screenLines[Math.floor(_cell2 / this.width)] && !this.screenLines[Math.floor(adjacentCell / this.width)]) {
                  adjacentDidUpdate = true;

                  if (this.getAdjacentCells(_cell2, 1).includes(adjacentCell)) {
                    // this is within a radius of 1, therefore this cell should be included in the mask as well
                    maskedCells.set(_cell2, true);
                  }
                  break;
                }
              }
            } catch (err) {
              _didIteratorError6 = true;
              _iteratorError6 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion6 && _iterator6.return) {
                  _iterator6.return();
                }
              } finally {
                if (_didIteratorError6) {
                  throw _iteratorError6;
                }
              }
            }

            if (adjacentDidUpdate) shouldUpdate = true;
          }

          if (updateMap.get(_cell2)) {
            // this was updated, it should definitely be included in the mask
            maskedCells.set(_cell2, true);
          }

          redrawMap.set(_cell2, shouldUpdate);
        }

        // mask to masked regions only
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      if (this.graphics >= 1) {
        // TODO: include padding in border cells
        var padding = this.padding;

        var regions = [];

        for (var _y = 0; _y < height; _y++) {
          var regionStart = null;
          for (var _x3 = 0; _x3 < width; _x3++) {
            var _cell3 = _y * width + _x3;
            var masked = maskedCells.get(_cell3);
            if (masked && regionStart === null) regionStart = _x3;
            if (!masked && regionStart !== null) {
              regions.push([regionStart, _y, _x3, _y + 1]);
              regionStart = null;
            }
          }
          if (regionStart !== null) {
            regions.push([regionStart, _y, width, _y + 1]);
          }
        }

        // join regions if possible (O(n^2-1), sorry)
        var i = 0;
        while (i < regions.length) {
          var region = regions[i];
          var j = 0;
          while (j < regions.length) {
            var other = regions[j];
            if (other === region) {
              j++;
              continue;
            }
            if (other[0] === region[0] && other[2] === region[2] && other[3] === region[1]) {
              region[1] = other[1];
              regions.splice(j, 1);
              if (i > j) i--;
              j--;
            }
            j++;
          }
          i++;
        }

        ctx.save();
        ctx.beginPath();
        var _iteratorNormalCompletion3 = true;
        var _didIteratorError3 = false;
        var _iteratorError3 = undefined;

        try {
          for (var _iterator3 = regions[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
            var _region = _step3.value;

            var _region2 = _slicedToArray(_region, 4),
                _regionStart = _region2[0],
                _y2 = _region2[1],
                endX = _region2[2],
                endY = _region2[3];

            var rectX = padding + _regionStart * cellWidth;
            var rectY = padding + _y2 * cellHeight;
            var rectWidth = (endX - _regionStart) * cellWidth;
            var rectHeight = (endY - _y2) * cellHeight;

            // compensate for padding
            if (_regionStart === 0) {
              rectX -= padding;
              rectWidth += padding;
            }
            if (_y2 === 0) {
              rectY -= padding;
              rectHeight += padding;
            }
            if (endX === width - 1) rectWidth += padding;
            if (_y2 === height - 1) rectHeight += padding;

            ctx.rect(rectX, rectY, rectWidth, rectHeight);
          }
        } catch (err) {
          _didIteratorError3 = true;
          _iteratorError3 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion3 && _iterator3.return) {
              _iterator3.return();
            }
          } finally {
            if (_didIteratorError3) {
              throw _iteratorError3;
            }
          }
        }

        ctx.clip();
      }

      // pass 1: backgrounds
      var _iteratorNormalCompletion4 = true;
      var _didIteratorError4 = false;
      var _iteratorError4 = undefined;

      try {
        for (var _iterator4 = fontGroups.keys()[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
          var _font = _step4.value;
          var _iteratorNormalCompletion7 = true;
          var _didIteratorError7 = false;
          var _iteratorError7 = undefined;

          try {
            for (var _iterator7 = fontGroups.get(_font)[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
              var data = _step7.value;
              var _cell4 = data.cell,
                  _x4 = data.x,
                  _y3 = data.y,
                  _text2 = data.text,
                  _bg = data.bg,
                  _isDefaultBG = data.isDefaultBG;


              if (redrawMap.get(_cell4)) {
                this.drawBackground({ x: _x4, y: _y3, cellWidth: cellWidth, cellHeight: cellHeight, bg: _bg, isDefaultBG: _isDefaultBG });

                if (this.debug) {
                  // set cell flags
                  var flags = +redrawMap.get(_cell4);
                  flags |= +updateMap.get(_cell4) << 1;
                  flags |= +maskedCells.get(_cell4) << 2;
                  flags |= +isTextWide(_text2) << 3;
                  flags |= +debugFilledUpdates.includes(_cell4) << 4;
                  this._debug.setCell(_cell4, flags);
                }
              }
            }
          } catch (err) {
            _didIteratorError7 = true;
            _iteratorError7 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion7 && _iterator7.return) {
                _iterator7.return();
              }
            } finally {
              if (_didIteratorError7) {
                throw _iteratorError7;
              }
            }
          }
        }

        // reset drawn cursor
      } catch (err) {
        _didIteratorError4 = true;
        _iteratorError4 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion4 && _iterator4.return) {
            _iterator4.return();
          }
        } finally {
          if (_didIteratorError4) {
            throw _iteratorError4;
          }
        }
      }

      this.drawnCursor = [-1, -1, '', false];

      // pass 2: characters
      var _iteratorNormalCompletion5 = true;
      var _didIteratorError5 = false;
      var _iteratorError5 = undefined;

      try {
        for (var _iterator5 = fontGroups.keys()[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
          var _font2 = _step5.value;

          // set font once because in Firefox, this is a really slow action for some
          // reason
          var fontIndex = 0;
          if (_font2 & ATTR_BOLD) fontIndex |= 1;
          if (_font2 & ATTR_ITALIC) fontIndex |= 2;
          ctx.font = this.fonts[fontIndex];

          var _iteratorNormalCompletion8 = true;
          var _didIteratorError8 = false;
          var _iteratorError8 = undefined;

          try {
            for (var _iterator8 = fontGroups.get(_font2)[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
              var _data = _step8.value;
              var _cell5 = _data.cell,
                  _x5 = _data.x,
                  _y4 = _data.y,
                  _text3 = _data.text,
                  _fg = _data.fg,
                  _bg2 = _data.bg,
                  _attrs = _data.attrs,
                  _isCursor = _data.isCursor,
                  _inSelection = _data.inSelection;


              if (redrawMap.get(_cell5)) {
                this.drawCharacter({
                  x: _x5, y: _y4, charSize: charSize, cellWidth: cellWidth, cellHeight: cellHeight, text: _text3, fg: _fg, attrs: _attrs
                });

                this.drawnScreen[_cell5] = _text3;
                this.drawnScreenFG[_cell5] = _fg;
                this.drawnScreenBG[_cell5] = _bg2;
                this.drawnScreenAttrs[_cell5] = _attrs;

                if (_isCursor) this.drawnCursor = [_x5, _y4, this.cursor.style, this.cursor.hanging];

                // draw cursor
                if (_isCursor && !_inSelection) {
                  ctx.save();
                  ctx.beginPath();

                  var cursorX = _x5;
                  var cursorY = _y4;
                  var cursorWidth = cellWidth; // JS doesn't allow same-name assignment

                  if (this.cursor.hanging) {
                    // draw hanging cursor in the margin
                    cursorX += 1;
                  }

                  // double-width lines
                  if (this.screenLines[cursorY] & 1) cursorWidth *= 2;

                  var screenX = cursorX * cursorWidth + this.padding;
                  var screenY = cursorY * cellHeight + this.padding;

                  if (this.cursor.style === 'block') {
                    // block
                    ctx.rect(screenX, screenY, cursorWidth, cellHeight);
                  } else if (this.cursor.style === 'bar') {
                    // vertical bar
                    var barWidth = 2;
                    ctx.rect(screenX, screenY, barWidth, cellHeight);
                  } else if (this.cursor.style === 'line') {
                    // underline
                    var lineHeight = 2;
                    ctx.rect(screenX, screenY + charSize.height, cursorWidth, lineHeight);
                  }
                  ctx.clip()

                  // swap foreground/background
                  ;

                  // HACK: ensure cursor is visible
                  var _ref5 = [_bg2, _fg];
                  _fg = _ref5[0];
                  _bg2 = _ref5[1];
                  if (_fg === _bg2) _bg2 = _fg === 0 ? 7 : 0;

                  this.drawBackground({ x: cursorX, y: cursorY, cellWidth: cellWidth, cellHeight: cellHeight, bg: _bg2 });
                  this.drawCharacter({
                    x: cursorX, y: cursorY, charSize: charSize, cellWidth: cellWidth, cellHeight: cellHeight, text: _text3, fg: _fg, attrs: _attrs
                  });
                  ctx.restore();
                }
              }
            }
          } catch (err) {
            _didIteratorError8 = true;
            _iteratorError8 = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion8 && _iterator8.return) {
                _iterator8.return();
              }
            } finally {
              if (_didIteratorError8) {
                throw _iteratorError8;
              }
            }
          }
        }
      } catch (err) {
        _didIteratorError5 = true;
        _iteratorError5 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion5 && _iterator5.return) {
            _iterator5.return();
          }
        } finally {
          if (_didIteratorError5) {
            throw _iteratorError5;
          }
        }
      }

      if (this.graphics >= 1) ctx.restore();

      if (this.debug && this._debug) this._debug.drawEnd();

      this.emit('draw', why);
    }
  }, {
    key: 'drawStatus',
    value: function drawStatus(statusScreen) {
      var ctx = this.ctx,
          width = this.width,
          height = this.height,
          devicePixelRatio = this.devicePixelRatio;

      // reset drawnScreen to force redraw when statusScreen is disabled

      this.drawnScreen = [];

      var cellSize = this.cellSize;
      var screenWidth = width * cellSize.width + 2 * this.padding;
      var screenHeight = height * cellSize.height + 2 * this.padding;

      ctx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
      ctx.fillStyle = this.getColor(this.defaultBG);
      ctx.fillRect(0, 0, screenWidth, screenHeight);

      ctx.font = '24px ' + this.statusFont;
      ctx.fillStyle = this.getColor(this.defaultFG);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillText(statusScreen.title || '', screenWidth / 2, screenHeight / 2 - 50);

      if (statusScreen.loading) {
        // show loading spinner
        ctx.save();
        ctx.translate(screenWidth / 2, screenHeight / 2 + 20);

        ctx.strokeStyle = this.getColor(this.defaultFG);
        ctx.lineWidth = 5;
        ctx.lineCap = 'round';

        var t = Date.now() / 1000;

        for (var i = 0; i < 12; i++) {
          ctx.rotate(Math.PI / 6);
          var offset = (t * 12 - i) % 12;
          ctx.globalAlpha = Math.max(0.2, 1 - offset / 3);
          ctx.beginPath();
          ctx.moveTo(0, 15);
          ctx.lineTo(0, 30);
          ctx.stroke();
        }

        ctx.restore();
      }
    }
  }, {
    key: 'startDrawLoop',
    value: function startDrawLoop() {
      if (this._drawTimerThread) return;
      var threadID = Math.random().toString(36);
      this._drawTimerThread = threadID;
      this.drawTimerLoop(threadID);
    }
  }, {
    key: 'stopDrawLoop',
    value: function stopDrawLoop() {
      this._drawTimerThread = null;
    }
  }, {
    key: 'drawTimerLoop',
    value: function drawTimerLoop(threadID) {
      var _this5 = this;

      if (!threadID || threadID !== this._drawTimerThread) return;
      window.requestAnimationFrame(function () {
        return _this5.drawTimerLoop(threadID);
      });
      this.draw('draw-loop');
    }

    /**
     * Converts an alphabetic character to its fraktur variant.
     * @param {string} character - the character
     * @returns {string} the converted character
     */

  }, {
    key: 'palette',
    get: function get() {
      return this._palette || themes[0];
    }

    /** @type {string[]} */
    ,
    set: function set(palette) {
      if (this._palette !== palette) {
        this._palette = palette;
        this.resetDrawn();
        this.emit('palette-update', palette);
        this.scheduleDraw('palette');
      }
    }
  }], [{
    key: 'alphaToFraktur',
    value: function alphaToFraktur(character) {
      if (character >= 'a' && character <= 'z') {
        character = String.fromCodePoint(0x1d51e - 0x61 + character.charCodeAt(0));
      } else if (character >= 'A' && character <= 'Z') {
        character = frakturExceptions[character] || String.fromCodePoint(0x1d504 - 0x41 + character.charCodeAt(0));
      }
      return character;
    }
  }]);

  return CanvasRenderer;
}(EventEmitter);

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EventEmitter = __webpack_require__(2);
var $ = __webpack_require__(1);
var demo = void 0;
try {
  demo = __webpack_require__(8);
} catch (err) {}

var RECONN_DELAY = 2000;
var HEARTBEAT_TIME = 3000;
var HTTPS = window.location.protocol.match(/s:/);

/** Handle connections */
module.exports = function (_EventEmitter) {
  _inherits(TermConnection, _EventEmitter);

  function TermConnection(screen) {
    _classCallCheck(this, TermConnection);

    var _this = _possibleConstructorReturn(this, (TermConnection.__proto__ || Object.getPrototypeOf(TermConnection)).call(this));

    _this.screen = screen;
    _this.ws = null;
    _this.heartbeatTimeout = null;
    _this.pingInterval = null;
    _this.xoff = false;
    _this.autoXoffTimeout = null;
    _this.reconnTimeout = null;
    _this.forceClosing = false;
    _this.queue = [];

    try {
      _this.blobReader = new window.FileReader();
      _this.blobReader.onload = function (evt) {
        _this.onDecodedWSMessage(_this.blobReader.result);
      };
      _this.blobReader.onerror = function (evt) {
        console.error(evt);
      };
    } catch (e) {
      _this.blobReader = null;
    }

    _this.pageShown = false;

    _this.disconnectTimeout = null;

    document.addEventListener('visibilitychange', function () {
      if (document.hidden === true) {
        console.info('Window lost focus, freeing socket');
        // Delayed, avoid disconnecting if the background time is short
        _this.disconnectTimeout = setTimeout(function () {
          _this.closeSocket();
          clearTimeout(_this.heartbeatTimeout);
        }, 1000);
      } else {
        clearTimeout(_this.disconnectTimeout);
        console.info('Window got focus, re-connecting');
        _this.init();
      }
    }, false);
    return _this;
  }

  _createClass(TermConnection, [{
    key: 'onWSOpen',
    value: function onWSOpen(evt) {
      console.log('CONNECTED');
      this.heartbeat();
      this.send('i');
      this.forceClosing = false;

      this.emit('connect');
    }
  }, {
    key: 'onWSClose',
    value: function onWSClose(evt) {
      var _this2 = this;

      if (this.forceClosing) {
        this.forceClosing = false;
        return;
      }
      console.warn('SOCKET CLOSED, code ' + evt.code + '. Reconnecting...');
      if (evt.code < 1000) {
        console.error('Bad code from socket!');
        // this sometimes happens for unknown reasons, code < 1000 is invalid
        // location.reload()
      }

      clearTimeout(this.reconnTimeout);
      this.reconnTimeout = setTimeout(function () {
        return _this2.init();
      }, RECONN_DELAY);

      this.emit('disconnect', evt.code);
    }
  }, {
    key: 'onDecodedWSMessage',
    value: function onDecodedWSMessage(str) {
      var _this3 = this;

      switch (str.charAt(0)) {
        case '.':
          // heartbeat, no-op message
          break;

        case '-':
          // console.log('xoff');
          this.xoff = true;
          this.autoXoffTimeout = setTimeout(function () {
            _this3.xoff = false;
            _this3.flushQueue();
          }, 250);
          break;

        case '+':
          // console.log('xon');
          this.xoff = false;
          this.flushQueue();
          clearTimeout(this.autoXoffTimeout);
          break;

        default:
          this.screen.load(str);
          if (!this.pageShown) {
            window.showPage();
            this.pageShown = true;
          }
          break;
      }
      this.heartbeat();
    }
  }, {
    key: 'onWSMessage',
    value: function onWSMessage(evt) {
      var _this4 = this;

      if (typeof evt.data === 'string') this.onDecodedWSMessage(evt.data);else {
        if (!this.blobReader) {
          console.error('No FileReader!');
          return;
        }

        if (this.blobReader.readyState !== 1) {
          this.blobReader.readAsText(evt.data);
        } else {
          setTimeout(function () {
            _this4.onWSMessage(evt);
          }, 1);
        }
      }
    }
  }, {
    key: 'canSend',
    value: function canSend() {
      return !this.xoff;
    }
  }, {
    key: 'send',
    value: function send(message) {
      if (window._demo) {
        if (typeof window.demoInterface !== 'undefined') {
          demo.input(message);
        } else {
          console.log('TX: ' + JSON.stringify(message));
        }
        return true; // Simulate success
      }
      if (this.xoff) {
        console.log("Can't send, flood control. Queueing");
        this.queue.push(message);
        return false;
      }

      if (!this.ws) return false; // for dry testing
      if (this.ws.readyState !== 1) {
        console.error('Socket not ready');
        return false;
      }
      if (typeof message !== 'string') {
        message = JSON.stringify(message);
      }
      this.ws.send(message);
      return true;
    }
  }, {
    key: 'flushQueue',
    value: function flushQueue() {
      console.log('Flushing input queue');
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = this.queue[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var message = _step.value;
          this.send(message);
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      this.queue = [];
    }

    /** Safely close the socket */

  }, {
    key: 'closeSocket',
    value: function closeSocket() {
      if (this.ws) {
        this.forceClosing = true;
        if (this.ws.readyState === 1) this.ws.close();
        this.ws = null;
      }
    }
  }, {
    key: 'init',
    value: function init() {
      var _this5 = this;

      if (window._demo) {
        if (typeof window.demoInterface === 'undefined') {
          window.alert('Demoing non-demo build!'); // this will catch mistakes when deploying to the website
        } else {
          demo.init(this.screen);
        }
        return;
      }

      clearTimeout(this.reconnTimeout);
      clearTimeout(this.heartbeatTimeout);

      this.closeSocket();

      this.ws = new window.WebSocket((HTTPS ? 'wss' : 'ws') + '://' + window._root + '/term/update.ws');
      this.ws.addEventListener('open', function () {
        return _this5.onWSOpen.apply(_this5, arguments);
      });
      this.ws.addEventListener('close', function () {
        return _this5.onWSClose.apply(_this5, arguments);
      });
      this.ws.addEventListener('message', function () {
        return _this5.onWSMessage.apply(_this5, arguments);
      });
      console.log('Opening socket.');
      this.heartbeat();

      this.emit('open');
    }
  }, {
    key: 'heartbeat',
    value: function heartbeat() {
      var _this6 = this;

      this.emit('heartbeat');
      clearTimeout(this.heartbeatTimeout);
      this.heartbeatTimeout = setTimeout(function () {
        return _this6.onHeartbeatFail();
      }, HEARTBEAT_TIME);
    }
  }, {
    key: 'sendPing',
    value: function sendPing() {
      var _this7 = this;

      console.log('> ping');
      this.emit('ping');
      $.get((HTTPS ? 'https' : 'http') + '://' + window._root + '/api/v1/ping', function (resp, status) {
        if (status === 200) {
          clearInterval(_this7.pingInterval);
          console.info('Server ready, opening socket…');
          _this7.emit('ping-success');
          _this7.init();
          // location.reload()
        } else _this7.emit('ping-fail', status);
      }, {
        timeout: 100,
        loader: false // we have loader on-screen
      });
    }
  }, {
    key: 'onHeartbeatFail',
    value: function onHeartbeatFail() {
      var _this8 = this;

      this.closeSocket();
      this.emit('silence');
      console.error('Heartbeat lost, probing server...');
      clearInterval(this.pingInterval);
      this.pingInterval = setInterval(function () {
        _this8.sendPing();
      }, 1000);

      // first ping, if this gets through, it'll will reduce delay
      setTimeout(function () {
        _this8.sendPing();
      }, 200);
    }
  }]);

  return TermConnection;
}(EventEmitter);

/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _require = __webpack_require__(0),
    encode2B = _require.encode2B;

/**
 * User input
 *
 * --- Rx messages: ---
 * S - screen content (binary encoding of the entire screen with simple compression)
 * T - text labels - Title and buttons, \0x01-separated
 * B - beep
 * . - heartbeat
 *
 * --- Tx messages ---
 * s - string
 * b - action button
 * p - mb press
 * r - mb release
 * m - mouse move
 */


module.exports = function (conn, screen) {
  // handle for input object
  var input = void 0;

  var KEY_NAMES = {
    0x03: 'Cancel',
    0x06: 'Help',
    0x08: 'Backspace',
    0x09: 'Tab',
    0x0C: 'Clear',
    0x0D: 'Enter',
    0x10: 'Shift',
    0x11: 'Control',
    0x12: 'Alt',
    0x13: 'Pause',
    0x14: 'CapsLock',
    0x1B: 'Escape',
    0x20: ' ',
    0x21: 'PageUp',
    0x22: 'PageDown',
    0x23: 'End',
    0x24: 'Home',
    0x25: 'ArrowLeft',
    0x26: 'ArrowUp',
    0x27: 'ArrowRight',
    0x28: 'ArrowDown',
    0x29: 'Select',
    0x2A: 'Print',
    0x2B: 'Execute',
    0x2C: 'PrintScreen',
    0x2D: 'Insert',
    0x2E: 'Delete',
    0x3A: ':',
    0x3B: ';',
    0x3C: '<',
    0x3D: '=',
    0x3E: '>',
    0x3F: '?',
    0x40: '@',
    0x5B: 'Meta',
    0x5C: 'Meta',
    0x5D: 'ContextMenu',
    0x6A: 'Numpad*',
    0x6B: 'Numpad+',
    0x6D: 'Numpad-',
    0x6E: 'Numpad.',
    0x6F: 'Numpad/',
    0x90: 'NumLock',
    0x91: 'ScrollLock',
    0xA0: '^',
    0xA1: '!',
    0xA2: '"',
    0xA3: '#',
    0xA4: '$',
    0xA5: '%',
    0xA6: '&',
    0xA7: '_',
    0xA8: '(',
    0xA9: ')',
    0xAA: '*',
    0xAB: '+',
    0xAC: '|',
    0xAD: '-',
    0xAE: '{',
    0xAF: '}',
    0xB0: '~',
    0xBA: ';',
    0xBB: '=',
    0xBC: 'Numpad,',
    0xBD: '-',
    0xBE: 'Numpad,',
    0xC0: '`',
    0xC2: 'Numpad,',
    0xDB: '[',
    0xDC: '\\',
    0xDD: ']',
    0xDE: "'",
    0xE0: 'Meta'
    // numbers 0-9
  };for (var i = 0x30; i <= 0x39; i++) {
    KEY_NAMES[i] = String.fromCharCode(i);
  } // characters A-Z
  for (var _i = 0x41; _i <= 0x5A; _i++) {
    KEY_NAMES[_i] = String.fromCharCode(_i);
  } // function F1-F20
  for (var _i2 = 0x70; _i2 <= 0x83; _i2++) {
    KEY_NAMES[_i2] = 'F' + (_i2 - 0x70 + 1);
  } // numpad 0-9
  for (var _i3 = 0x60; _i3 <= 0x69; _i3++) {
    KEY_NAMES[_i3] = 'Numpad' + (_i3 - 0x60);
  }var cfg = {
    np_alt: false, // Application Numpad Mode
    cu_alt: false, // Application Cursors Mode
    fn_alt: false, // SS3 function keys mode
    mt_click: false, // Mouse click tracking
    mt_move: false, // Mouse move tracking
    no_keys: false, // Suppress any key / clipboard event intercepting
    crlf_mode: false, // Enter sends CR LF
    all_fn: false // Capture also F5, F11 and F12


    /** Fn alt choice for key message */
  };var fa = function fa(alt, normal) {
    return cfg.fn_alt ? alt : normal;
  };

  /** Cursor alt choice for key message */
  var ca = function ca(alt, normal) {
    return cfg.cu_alt ? alt : normal;
  };

  /** Numpad alt choice for key message */
  var na = function na(alt, normal) {
    return cfg.np_alt ? alt : normal;
  };

  var keymap = {
    /* eslint-disable key-spacing */
    'Backspace': '\x08',
    'Tab': '\x09',
    'Enter': function Enter() {
      return cfg.crlf_mode ? '\x0d\x0a' : '\x0d';
    },
    'Control+Enter': '\x0a',
    'Escape': '\x1b',
    'ArrowUp': function ArrowUp() {
      return ca('\x1bOA', '\x1b[A');
    },
    'ArrowDown': function ArrowDown() {
      return ca('\x1bOB', '\x1b[B');
    },
    'ArrowRight': function ArrowRight() {
      return ca('\x1bOC', '\x1b[C');
    },
    'ArrowLeft': function ArrowLeft() {
      return ca('\x1bOD', '\x1b[D');
    },
    'Home': function Home() {
      return ca('\x1bOH', fa('\x1b[H', '\x1b[1~'));
    },
    'Insert': '\x1b[2~',
    'Delete': '\x1b[3~',
    'End': function End() {
      return ca('\x1bOF', fa('\x1b[F', '\x1b[4~'));
    },
    'PageUp': '\x1b[5~',
    'PageDown': '\x1b[6~',
    'F1': function F1() {
      return fa('\x1bOP', '\x1b[11~');
    },
    'F2': function F2() {
      return fa('\x1bOQ', '\x1b[12~');
    },
    'F3': function F3() {
      return fa('\x1bOR', '\x1b[13~');
    },
    'F4': function F4() {
      return fa('\x1bOS', '\x1b[14~');
    },
    'F5': '\x1b[15~', // note the disconnect
    'F6': '\x1b[17~',
    'F7': '\x1b[18~',
    'F8': '\x1b[19~',
    'F9': '\x1b[20~',
    'F10': '\x1b[21~', // note the disconnect
    'F11': '\x1b[23~',
    'F12': '\x1b[24~',
    'Shift+F1': function ShiftF1() {
      return fa('\x1bO1;2P', '\x1b[25~');
    },
    'Shift+F2': function ShiftF2() {
      return fa('\x1bO1;2Q', '\x1b[26~');
    }, // note the disconnect
    'Shift+F3': function ShiftF3() {
      return fa('\x1bO1;2R', '\x1b[28~');
    },
    'Shift+F4': function ShiftF4() {
      return fa('\x1bO1;2S', '\x1b[29~');
    }, // note the disconnect
    'Shift+F5': function ShiftF5() {
      return fa('\x1b[15;2~', '\x1b[31~');
    },
    'Shift+F6': function ShiftF6() {
      return fa('\x1b[17;2~', '\x1b[32~');
    },
    'Shift+F7': function ShiftF7() {
      return fa('\x1b[18;2~', '\x1b[33~');
    },
    'Shift+F8': function ShiftF8() {
      return fa('\x1b[19;2~', '\x1b[34~');
    },
    'Shift+F9': function ShiftF9() {
      return fa('\x1b[20;2~', '\x1b[35~');
    }, // 35-38 are not standard - but what is?
    'Shift+F10': function ShiftF10() {
      return fa('\x1b[21;2~', '\x1b[36~');
    },
    'Shift+F11': function ShiftF11() {
      return fa('\x1b[22;2~', '\x1b[37~');
    },
    'Shift+F12': function ShiftF12() {
      return fa('\x1b[23;2~', '\x1b[38~');
    },
    'Numpad0': function Numpad0() {
      return na('\x1bOp', '0');
    },
    'Numpad1': function Numpad1() {
      return na('\x1bOq', '1');
    },
    'Numpad2': function Numpad2() {
      return na('\x1bOr', '2');
    },
    'Numpad3': function Numpad3() {
      return na('\x1bOs', '3');
    },
    'Numpad4': function Numpad4() {
      return na('\x1bOt', '4');
    },
    'Numpad5': function Numpad5() {
      return na('\x1bOu', '5');
    },
    'Numpad6': function Numpad6() {
      return na('\x1bOv', '6');
    },
    'Numpad7': function Numpad7() {
      return na('\x1bOw', '7');
    },
    'Numpad8': function Numpad8() {
      return na('\x1bOx', '8');
    },
    'Numpad9': function Numpad9() {
      return na('\x1bOy', '9');
    },
    'Numpad*': function Numpad() {
      return na('\x1bOR', '*');
    },
    'Numpad+': function Numpad() {
      return na('\x1bOl', '+');
    },
    'Numpad-': function Numpad() {
      return na('\x1bOS', '-');
    },
    'Numpad.': function Numpad() {
      return na('\x1bOn', '.');
    },
    'Numpad/': function Numpad() {
      return na('\x1bOQ', '/');
    },
    // we don't implement numlock key (should change in numpad_alt mode,
    // but it's even more useless than the rest and also has the side
    // effect of changing the user's numlock state)

    // shortcuts
    'Control+]': '\x1b', // alternate way to enter ESC
    'Control+\\': '\x1c',
    'Control+[': '\x1d',
    'Control+^': '\x1e',
    'Control+_': '\x1f',

    // extra controls
    'Control+ArrowLeft': '\x1f[1;5D',
    'Control+ArrowRight': '\x1f[1;5C',
    'Control+ArrowUp': '\x1f[1;5A',
    'Control+ArrowDown': '\x1f[1;5B',
    'Control+Home': '\x1f[1;5H',
    'Control+End': '\x1f[1;5F',

    // extra shift controls
    'Shift+ArrowLeft': '\x1f[1;2D',
    'Shift+ArrowRight': '\x1f[1;2C',
    'Shift+ArrowUp': '\x1f[1;2A',
    'Shift+ArrowDown': '\x1f[1;2B',
    'Shift+Home': '\x1f[1;2H',
    'Shift+End': '\x1f[1;2F',

    // macOS text editing commands
    'Alt+ArrowLeft': '\x1bb', // ⌥← to go back a word (^[b)
    'Alt+ArrowRight': '\x1bf', // ⌥→ to go forward one word (^[f)
    'Meta+ArrowLeft': '\x01', // ⌘← to go to the beginning of a line (^A)
    'Meta+ArrowRight': '\x05', // ⌘→ to go to the end of a line (^E)
    'Alt+Backspace': '\x17', // ⌥⌫ to delete a word (^W)
    'Meta+Backspace': '\x15', // ⌘⌫ to delete to the beginning of a line (^U)

    // copy to clipboard
    'Control+Shift+C': function ControlShiftC() {
      screen.copySelectionToClipboard();
    },
    'Control+Insert': function ControlInsert() {
      screen.copySelectionToClipboard();
    },


    // toggle debug mode
    'Control+F12': function ControlF12() {
      screen.window.debug ^= 1;
    }
    /* eslint-enable key-spacing */

  };

  // ctrl+[A-Z] sent as simple low ASCII codes
  for (var _i4 = 1; _i4 <= 26; _i4++) {
    keymap['Control+' + String.fromCharCode(0x40 + _i4)] = String.fromCharCode(_i4);
  }

  /** Send a literal message */
  function sendString(str) {
    return conn.send('s' + str);
  }

  /** Send a button event */
  function sendButton(index) {
    conn.send('b' + String.fromCharCode(index + 1));
  }

  var shouldAcceptEvent = function shouldAcceptEvent() {
    if (cfg.no_keys) return false;
    if (document.activeElement instanceof window.HTMLTextAreaElement) return false;
    return true;
  };

  var keyBlacklist = ['F5', 'F11', 'F12', 'Shift+F5'];

  var softModifiers = {
    alt: false,
    ctrl: false,
    meta: false,
    shift: false
  };

  var handleKeyDown = function handleKeyDown(e) {
    if (!shouldAcceptEvent()) return;

    var modifiers = [];
    // sorted alphabetically
    if (e.altKey || softModifiers.alt) modifiers.push('Alt');
    if (e.ctrlKey || softModifiers.ctrl) modifiers.push('Control');
    if (e.metaKey || softModifiers.meta) modifiers.push('Meta');
    if (e.shiftKey || softModifiers.shift) modifiers.push('Shift');

    var key = KEY_NAMES[e.which] || e.key;

    // ignore clipboard events
    if ((e.ctrlKey || e.metaKey) && key === 'V') return;

    var binding = null;

    for (var name in keymap) {
      var itemModifiers = name.split('+');
      var itemKey = itemModifiers.pop();

      if (itemKey === key && itemModifiers.sort().join() === modifiers.join()) {
        if (keyBlacklist.includes(name) && !cfg.all_fn) continue;
        binding = keymap[name];
        break;
      }
    }

    if (binding) {
      if (binding instanceof Function) binding = binding();
      e.preventDefault();
      if (typeof binding === 'string') {
        sendString(binding);
      }
    }
  };

  /** Bind/rebind key messages */
  function initKeys(_ref) {
    var allFn = _ref.allFn;

    // This takes care of text characters typed
    window.addEventListener('keypress', function (evt) {
      if (!shouldAcceptEvent()) return;
      if (evt.ctrlKey || evt.metaKey) return;

      var str = '';
      if (evt.key && evt.key.length === 1) str = evt.key;else if (evt.which && evt.which !== 229) str = String.fromCodePoint(evt.which);

      if (str.length > 0 && str.charCodeAt(0) >= 32) {
        // prevent space from scrolling
        if (evt.which === 32) evt.preventDefault();
        sendString(str);
      }
    });

    window.addEventListener('keydown', handleKeyDown);
    window.addEventListener('copy', function (e) {
      if (!shouldAcceptEvent()) return;
      var selectedText = screen.getSelectedText();
      if (selectedText) {
        e.preventDefault();
        e.clipboardData.setData('text/plain', selectedText);
      }
    });
    window.addEventListener('paste', function (e) {
      if (!shouldAcceptEvent()) return;
      e.preventDefault();
      var string = e.clipboardData.getData('text/plain');
      if (string.includes('\n') || string.length > 90) {
        if (!input.termUpload) console.error('input.termUpload is undefined');
        input.termUpload.setContent(string);
        input.termUpload.open();
      } else {
        // simple string, just paste it
        if (screen.bracketedPaste) string = '\x1B[200~' + string + '\x1B[201~';
        sendString(string);
      }
    });

    cfg.all_fn = allFn;
  }

  // mouse button states
  var mb1 = 0;
  var mb2 = 0;
  var mb3 = 0;

  /** Init the Input module */
  function init(opts) {
    initKeys(opts);

    // global mouse state tracking - for motion reporting
    window.addEventListener('mousedown', function (evt) {
      if (evt.button === 0) mb1 = 1;
      if (evt.button === 1) mb2 = 1;
      if (evt.button === 2) mb3 = 1;
    });

    window.addEventListener('mouseup', function (evt) {
      if (evt.button === 0) mb1 = 0;
      if (evt.button === 1) mb2 = 0;
      if (evt.button === 2) mb3 = 0;
    });
  }

  // record modifier keys
  // bits: Meta, Alt, Shift, Ctrl
  var modifiers = 0;

  window.addEventListener('keydown', function (e) {
    if (e.ctrlKey) modifiers |= 1;
    if (e.shiftKey) modifiers |= 2;
    if (e.altKey) modifiers |= 4;
    if (e.metaKey) modifiers |= 8;
  });
  window.addEventListener('keyup', function (e) {
    modifiers = 0;
    if (e.ctrlKey) modifiers |= 1;
    if (e.shiftKey) modifiers |= 2;
    if (e.altKey) modifiers |= 4;
    if (e.metaKey) modifiers |= 8;
  });

  /** Prepare modifiers byte for mouse message */
  function packModifiersForMouse() {
    return modifiers;
  }

  input = {
    /** Init the Input module */
    init: init,

    /** Send a literal string message */
    sendString: sendString,
    sendButton: sendButton,

    /** Enable alternate key modes (cursors, numpad, fn) */
    setAlts: function setAlts(cu, np, fn, crlf) {
      if (cfg.cu_alt !== cu || cfg.np_alt !== np || cfg.fn_alt !== fn || cfg.crlf_mode !== crlf) {
        cfg.cu_alt = cu;
        cfg.np_alt = np;
        cfg.fn_alt = fn;
        cfg.crlf_mode = crlf;
      }
    },

    setMouseMode: function setMouseMode(click, move) {
      cfg.mt_click = click;
      cfg.mt_move = move;
    },


    // Mouse events
    onMouseMove: function onMouseMove(x, y) {
      if (!cfg.mt_move) return;
      var b = mb1 ? 1 : mb2 ? 2 : mb3 ? 3 : 0;
      var m = packModifiersForMouse();
      conn.send('m' + encode2B(y) + encode2B(x) + encode2B(b) + encode2B(m));
    },
    onMouseDown: function onMouseDown(x, y, b) {
      if (!cfg.mt_click) return;
      if (b > 3 || b < 1) return;
      var m = packModifiersForMouse();
      conn.send('p' + encode2B(y) + encode2B(x) + encode2B(b) + encode2B(m));
    },
    onMouseUp: function onMouseUp(x, y, b) {
      if (!cfg.mt_click) return;
      if (b > 3 || b < 1) return;
      var m = packModifiersForMouse();
      conn.send('r' + encode2B(y) + encode2B(x) + encode2B(b) + encode2B(m));
      // console.log("B ",b," M ",m);
    },
    onMouseWheel: function onMouseWheel(x, y, dir) {
      if (!cfg.mt_click) return;
      // -1 ... btn 4 (away from user)
      // +1 ... btn 5 (towards user)
      var m = packModifiersForMouse();
      var b = dir < 0 ? 4 : 5;
      conn.send('p' + encode2B(y) + encode2B(x) + encode2B(b) + encode2B(m));
      // console.log("B ",b," M ",m);
    },


    /**
     * Prevent capturing keys. This is used for text input
     * modals on the terminal screen
     */
    blockKeys: function blockKeys(yes) {
      cfg.no_keys = yes;
    },


    handleKeyDown: handleKeyDown,
    softModifiers: softModifiers
  };
  return input;
};

/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var $ = __webpack_require__(1);

var _require = __webpack_require__(0),
    qs = _require.qs;

var modal = __webpack_require__(4);

/** File upload utility */
module.exports = function (conn, input, screen) {
  var lines = void 0,
      // array of lines without newlines
  line_i = void 0,
      // current line index
  fuTout = void 0,
      // timeout handle for line sending
  send_delay_ms = void 0,
      // delay between lines (ms)
  nl_str = void 0,
      // newline string to use
  curLine = void 0,
      // current line (when using fuOil)
  inline_pos = void 0; // Offset in line (for long lines)

  // lines longer than this are split to chunks
  // sending a super-ling string through the socket is not a good idea
  var MAX_LINE_LEN = 128;

  function openUploadDialog() {
    updateStatus('Ready...');
    modal.show('#fu_modal', onDialogClose);
    $('#fu_form').toggleClass('busy', false);
    input.blockKeys(true);
  }

  function onDialogClose() {
    console.log('Upload modal closed.');
    clearTimeout(fuTout);
    line_i = 0;
    input.blockKeys(false);
  }

  function updateStatus(msg) {
    qs('#fu_prog').textContent = msg;
  }

  function startUpload() {
    var v = qs('#fu_text').value;
    if (!v.length) {
      fuClose();
      return;
    }

    lines = v.split('\n');
    line_i = 0;
    inline_pos = 0; // offset in line
    send_delay_ms = +qs('#fu_delay').value;

    // sanitize - 0 causes overflows
    if (send_delay_ms < 0) {
      send_delay_ms = 0;
      qs('#fu_delay').value = send_delay_ms;
    }

    nl_str = {
      'CR': '\r',
      'LF': '\n',
      'CRLF': '\r\n'
    }[qs('#fu_crlf').value];

    $('#fu_form').toggleClass('busy', true);
    updateStatus('Starting...');
    uploadLine();
  }

  function uploadLine() {
    if (!$('#fu_modal').hasClass('visible')) {
      // Modal is closed, cancel
      return;
    }

    if (!conn.canSend()) {
      // postpone
      fuTout = setTimeout(uploadLine, 1);
      return;
    }

    if (inline_pos === 0) {
      curLine = '';
      if (line_i === 0) {
        if (screen.bracketedPaste) {
          curLine = '\x1b[200~';
        }
      }

      curLine += lines[line_i++] + nl_str;

      if (line_i === lines.length) {
        if (screen.bracketedPaste) {
          curLine += '\x1b[201~';
        }
      }
    }

    var maxChunk = +qs('#fu_chunk').value;
    if (maxChunk === 0 || maxChunk > MAX_LINE_LEN) {
      maxChunk = MAX_LINE_LEN;
    }

    var chunk = void 0;
    if (curLine.length - inline_pos <= maxChunk) {
      chunk = curLine.substr(inline_pos, maxChunk);
      inline_pos = 0;
    } else {
      chunk = curLine.substr(inline_pos, maxChunk);
      inline_pos += maxChunk;
    }

    if (!input.sendString(chunk)) {
      updateStatus('FAILED!');
      return;
    }

    var pt = Math.round(line_i / lines.length * 1000) / 10;
    updateStatus(line_i + ' / ' + lines.length + ' (' + pt + '%)');

    if (lines.length > line_i || inline_pos > 0) {
      fuTout = setTimeout(uploadLine, send_delay_ms);
    } else {
      closeWhenReady();
    }
  }

  function closeWhenReady() {
    if (!conn.canSend()) {
      // stuck in XOFF still, wait to process...
      updateStatus('Waiting for Tx buffer...');
      setTimeout(closeWhenReady, 100);
    } else {
      updateStatus('Done.');
      // delay to show it
      fuClose();
    }
  }

  function fuClose() {
    modal.hide('#fu_modal');
  }

  return {
    init: function init() {
      qs('#fu_file').addEventListener('change', function (evt) {
        var reader = new window.FileReader();
        var file = evt.target.files[0];
        var ftype = file.type || 'application/octet-stream';
        console.log('Selected file type: ' + ftype);
        if (!ftype.match(/text\/.*|application\/(json|csv|.*xml.*|.*script.*|x-php)/)) {
          // Deny load of blobs like img - can crash browser and will get corrupted anyway
          if (!window.confirm('This does not look like a text file: ' + ftype + '\nReally load?')) {
            qs('#fu_file').value = '';
            return;
          }
        }
        reader.onload = function (e) {
          var txt = e.target.result.replace(/[\r\n]+/, '\n');
          qs('#fu_text').value = txt;
        };
        console.log('Loading file...');
        reader.readAsText(file);
      }, false);

      qs('#term-fu-open').addEventListener('click', function (e) {
        e.preventDefault();
        openUploadDialog();
      });

      qs('#term-fu-start').addEventListener('click', function (e) {
        e.preventDefault();
        startUpload();
      });

      qs('#term-fu-close').addEventListener('click', function (e) {
        e.preventDefault();
        fuClose();
      });
    },
    open: openUploadDialog,
    setContent: function setContent(content) {
      qs('#fu_text').value = content;
    }
  };
};

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _require = __webpack_require__(0),
    qs = _require.qs;

module.exports = function (screen, input) {
  var keyInput = qs('#softkb-input');
  if (!keyInput) return; // abort, we're not on the terminal page

  var shortcutBar = document.createElement('div');
  shortcutBar.id = 'keyboard-shortcut-bar';
  if (navigator.userAgent.match(/iPad|iPhone|iPod/)) {
    qs('#screen').appendChild(shortcutBar);
  }

  var keyboardOpen = false;

  // moves the input to where the cursor is on the canvas.
  // this is because most browsers will always scroll to wherever the focused
  // input is
  var updateInputPosition = function updateInputPosition() {
    if (!keyboardOpen) return;

    var _screen$layout$gridTo = screen.layout.gridToScreen(screen.cursor.x, screen.cursor.y, true),
        _screen$layout$gridTo2 = _slicedToArray(_screen$layout$gridTo, 2),
        x = _screen$layout$gridTo2[0],
        y = _screen$layout$gridTo2[1];

    keyInput.style.transform = 'translate(' + x + 'px, ' + y + 'px)';
  };

  keyInput.addEventListener('focus', function () {
    keyboardOpen = true;
    updateInputPosition();
    shortcutBar.classList.add('open');
  });

  keyInput.addEventListener('blur', function () {
    keyboardOpen = false;
    shortcutBar.classList.remove('open');
  });

  screen.on('cursor-moved', updateInputPosition);

  qs('#term-kb-open').addEventListener('click', function (e) {
    e.preventDefault();
    keyInput.focus();
  });

  // Chrome for Android doesn't send proper keydown/keypress events with
  // real key values instead of 229 “Unidentified,” so here's a workaround
  // that deals with the input composition events.

  var lastCompositionString = '';

  // sends the difference between the last and the new composition string
  var sendInputDelta = function sendInputDelta(newValue) {
    if (newValue === null) newValue = ''; // this sometimes happens, why?
    var resend = false;
    if (newValue.length > lastCompositionString.length) {
      if (newValue.startsWith(lastCompositionString)) {
        // characters have been added at the end
        input.sendString(newValue.substr(lastCompositionString.length));
      } else resend = true;
    } else if (newValue.length < lastCompositionString.length) {
      if (lastCompositionString.startsWith(newValue)) {
        // characters have been removed at the end
        input.sendString('\b'.repeat(lastCompositionString.length - newValue.length));
      } else resend = true;
    } else if (newValue !== lastCompositionString) resend = true;

    if (resend) {
      // the entire string changed; resend everything
      input.sendString('\b'.repeat(lastCompositionString.length) + newValue);
    }
    lastCompositionString = newValue;
  };

  keyInput.addEventListener('keydown', function (e) {
    if (e.key === 'Unidentified') return;

    keyInput.value = '';

    e.stopPropagation();
    input.handleKeyDown(e);
  });

  keyInput.addEventListener('keypress', function (e) {
    // prevent key duplication on iOS (because Safari *does* send proper events)
    e.stopPropagation();
  });

  keyInput.addEventListener('input', function (e) {
    e.stopPropagation();

    if (e.isComposing && 'data' in e) {
      sendInputDelta(e.data);
    } else if (e.isComposing) {
      // Firefox Mobile doesn't support InputEvent#data, so here's a hack
      // that just takes the input value and uses that
      sendInputDelta(keyInput.value);
    } else {
      if (e.inputType === 'insertCompositionText') input.sendString(e.data);else if (e.inputType === 'deleteContentBackward') {
        lastCompositionString = '';
        sendInputDelta('');
      } else if (e.inputType === 'insertText') {
        input.sendString(e.data);
      }
    }
  });

  keyInput.addEventListener('compositionstart', function (e) {
    lastCompositionString = '';
  });

  keyInput.addEventListener('compositionend', function (e) {
    lastCompositionString = '';
    keyInput.value = '';
  });

  screen.on('open-soft-keyboard', function () {
    return keyInput.focus();
  });

  // shortcut bar
  var shortcuts = {
    Control: 'ctrl',
    Esc: 0x1b,
    Tab: 0x09,
    '←': 0x25,
    '↓': 0x28,
    '↑': 0x26,
    '→': 0x27
  };

  var touchMoved = false;

  var _loop = function _loop(shortcut) {
    var button = document.createElement('button');
    button.classList.add('shortcut-button');
    button.textContent = shortcut;
    shortcutBar.appendChild(button);

    var key = shortcuts[shortcut];
    if (typeof key === 'string') button.classList.add('modifier');
    button.addEventListener('touchstart', function (e) {
      touchMoved = false;
      if (typeof key === 'string') {
        // modifier button
        input.softModifiers[key] = true;
        button.classList.add('enabled');

        // prevent default. This prevents scrolling, but also prevents the
        // selection popup
        e.preventDefault();
      }
    });
    window.addEventListener('touchmove', function (e) {
      touchMoved = true;
    });
    button.addEventListener('touchend', function (e) {
      e.preventDefault();
      if (typeof key === 'number') {
        if (touchMoved) return;
        var fakeEvent = { which: key, preventDefault: function preventDefault() {} };
        input.handleKeyDown(fakeEvent);
      } else if (typeof key === 'string') {
        button.classList.remove('enabled');
        input.softModifiers[key] = false;
      }
    });
  };

  for (var shortcut in shortcuts) {
    _loop(shortcut);
  }
};

/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _require = __webpack_require__(3),
    getColor = _require.getColor;

var _require2 = __webpack_require__(6),
    ATTR_FG = _require2.ATTR_FG,
    ATTR_BG = _require2.ATTR_BG,
    ATTR_BOLD = _require2.ATTR_BOLD,
    ATTR_UNDERLINE = _require2.ATTR_UNDERLINE,
    ATTR_BLINK = _require2.ATTR_BLINK,
    ATTR_ITALIC = _require2.ATTR_ITALIC,
    ATTR_STRIKE = _require2.ATTR_STRIKE,
    ATTR_OVERLINE = _require2.ATTR_OVERLINE,
    ATTR_FAINT = _require2.ATTR_FAINT,
    ATTR_FRAKTUR = _require2.ATTR_FRAKTUR;

// debug toolbar, tooltip and screen


module.exports = function attachDebugger(screen, connection) {
  // debug screen overlay
  var debugCanvas = document.createElement('canvas');
  debugCanvas.classList.add('debug-canvas');
  var ctx = debugCanvas.getContext('2d');

  // debug toolbar
  var toolbar = document.createElement('div');
  toolbar.classList.add('debug-toolbar');

  // debug tooltip
  var tooltip = document.createElement('div');
  tooltip.classList.add('debug-tooltip');
  tooltip.classList.add('hidden');

  // update functions, defined somewhere below
  var updateTooltip = void 0;
  var updateToolbar = void 0;

  // tooltip cell
  var selectedCell = null;

  // update tooltip cell when mouse moves
  var onMouseMove = function onMouseMove(e) {
    if (e.target !== screen.layout.canvas) {
      selectedCell = null;
      return;
    }
    selectedCell = screen.layout.screenToGrid(e.offsetX, e.offsetY);
    updateTooltip();
  };

  // hide tooltip when mouse leaves
  var onMouseOut = function onMouseOut(e) {
    selectedCell = null;
    tooltip.classList.add('hidden');
  };

  // updates debug canvas size
  var updateCanvasSize = function updateCanvasSize() {
    var _screen$layout$window = screen.layout.window,
        width = _screen$layout$window.width,
        height = _screen$layout$window.height,
        devicePixelRatio = _screen$layout$window.devicePixelRatio;

    var cellSize = screen.layout.getCellSize();
    var padding = Math.round(screen.layout._padding);
    debugCanvas.width = (width * cellSize.width + 2 * padding) * devicePixelRatio;
    debugCanvas.height = (height * cellSize.height + 2 * padding) * devicePixelRatio;
    debugCanvas.style.width = width * cellSize.width + 2 * screen.layout._padding + 'px';
    debugCanvas.style.height = height * cellSize.height + 2 * screen.layout._padding + 'px';
  };

  // defined somewhere below
  var startDrawLoop = void 0;

  var screenAttached = false;

  // node to which events were bound (kept here for when they need to be removed)
  var eventNode = void 0;

  // attaches/detaches debug screen overlay to/from DOM
  var setScreenAttached = function setScreenAttached(attached) {
    if (attached && !debugCanvas.parentNode) {
      screen.layout.canvas.parentNode.appendChild(debugCanvas);
      eventNode = debugCanvas.parentNode;
      eventNode.addEventListener('mousemove', onMouseMove);
      eventNode.addEventListener('mouseout', onMouseOut);
      screen.layout.on('size-update', updateCanvasSize);
      updateCanvasSize();
      screenAttached = true;
      startDrawLoop();
    } else if (!attached && debugCanvas.parentNode) {
      debugCanvas.parentNode.removeChild(debugCanvas);
      eventNode.removeEventListener('mousemove', onMouseMove);
      eventNode.removeEventListener('mouseout', onMouseOut);
      screen.layout.removeListener('size-update', updateCanvasSize);
      screenAttached = false;
    }
  };

  // attaches/detaches toolbar and tooltip to/from DOM
  var setToolbarAttached = function setToolbarAttached(attached) {
    if (attached && !toolbar.parentNode) {
      screen.layout.canvas.parentNode.appendChild(toolbar);
      screen.layout.canvas.parentNode.appendChild(tooltip);
      updateToolbar();
    } else if (!attached && toolbar.parentNode) {
      screen.layout.canvas.parentNode.removeChild(toolbar);
      screen.layout.canvas.parentNode.removeChild(tooltip);
    }
  };

  // attach/detach toolbar when debug mode is enabled/disabled
  screen.on('update-window:debug', function (enabled) {
    setToolbarAttached(enabled);
  });

  // ditto ^
  screen.layout.on('update-window:debug', function (enabled) {
    setScreenAttached(enabled);
  });

  var drawData = {
    // last draw reason
    reason: '',

    // when true, will show colored cell update overlays
    showUpdates: false,

    // draw start time in milliseconds
    startTime: 0,

    // end time
    endTime: 0,

    // partial update frames
    frames: [],

    // cell data
    cells: new Map(),

    // scroll region
    scrollRegion: null

    // debug interface
  };screen._debug = screen.layout.renderer._debug = {
    drawStart: function drawStart(reason) {
      drawData.reason = reason;
      drawData.startTime = window.performance.now();
    },
    drawEnd: function drawEnd() {
      drawData.endTime = window.performance.now();
    },
    setCell: function setCell(cell, flags) {
      drawData.cells.set(cell, [flags, window.performance.now()]);
    },
    pushFrame: function pushFrame(frame) {
      drawData.frames.push([].concat(_toConsumableArray(frame), [window.performance.now()]));
    }
  };

  var isDrawing = false;
  var drawLoop = function drawLoop() {
    // draw while the screen is attached
    if (screenAttached) window.requestAnimationFrame(drawLoop);else isDrawing = false;

    var now = window.performance.now();

    var _screen$layout$window2 = screen.layout.window,
        width = _screen$layout$window2.width,
        height = _screen$layout$window2.height,
        devicePixelRatio = _screen$layout$window2.devicePixelRatio;

    var padding = Math.round(screen.layout._padding);
    var cellSize = screen.layout.getCellSize();

    ctx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, 0, 0);
    ctx.clearRect(0, 0, width * cellSize.width + 2 * padding, height * cellSize.height + 2 * padding);
    ctx.translate(padding, padding);

    ctx.lineWidth = 2;
    ctx.lineJoin = 'round';

    if (drawData.showUpdates) {
      var cells = drawData.cells;
      for (var cell = 0; cell < width * height; cell++) {
        // cell does not exist or has no flags set
        if (!cells.has(cell) || cells.get(cell)[0] === 0) continue;

        var _cells$get = cells.get(cell),
            _cells$get2 = _slicedToArray(_cells$get, 2),
            flags = _cells$get2[0],
            timestamp = _cells$get2[1];

        var elapsedTime = (now - timestamp) / 1000;

        if (elapsedTime > 1) {
          cells.delete(cell);
          continue;
        }

        ctx.globalAlpha = 0.5 * Math.max(0, 1 - elapsedTime);

        var x = cell % width;
        var y = Math.floor(cell / width);

        if (flags & 2) {
          // updated
          ctx.fillStyle = '#0f0';
        } else if (flags & 1) {
          // redrawn
          ctx.fillStyle = '#f0f';
        }

        if (!(flags & 4)) {
          // outside a clipped region
          ctx.fillStyle = '#0ff';
        }

        if (flags & 16) {
          // was filled to speed up rendering
          ctx.globalAlpha /= 2;
        }

        ctx.fillRect(x * cellSize.width, y * cellSize.height, cellSize.width, cellSize.height);

        if (flags & 8) {
          // wide cell
          ctx.strokeStyle = '#f00';
          ctx.beginPath();
          ctx.moveTo(x * cellSize.width, (y + 1) * cellSize.height);
          ctx.lineTo((x + 1) * cellSize.width, (y + 1) * cellSize.height);
          ctx.stroke();
        }
      }

      var framesToDelete = [];
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = drawData.frames[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var frame = _step.value;

          var _timestamp = frame[4];
          var _elapsedTime = (now - _timestamp) / 1000;
          if (_elapsedTime > 1) framesToDelete.push(frame);else {
            ctx.globalAlpha = 1 - _elapsedTime;
            ctx.strokeStyle = '#ff0';
            ctx.strokeRect(frame[0] * cellSize.width, frame[1] * cellSize.height, frame[2] * cellSize.width, frame[3] * cellSize.height);
          }
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = framesToDelete[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _frame = _step2.value;

          drawData.frames.splice(drawData.frames.indexOf(_frame), 1);
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }
    }

    if (selectedCell !== null) {
      // draw a dashed outline around the selected cell
      var _selectedCell = selectedCell,
          _selectedCell2 = _slicedToArray(_selectedCell, 2),
          _x = _selectedCell2[0],
          _y = _selectedCell2[1];

      ctx.save();
      ctx.globalAlpha = 0.5;
      ctx.lineWidth = 1;

      // draw X line
      ctx.beginPath();
      ctx.moveTo(0, _y * cellSize.height);
      ctx.lineTo(_x * cellSize.width, _y * cellSize.height);
      ctx.strokeStyle = '#f00';
      ctx.setLineDash([cellSize.width]);
      ctx.stroke();

      // draw Y line
      ctx.beginPath();
      ctx.moveTo(_x * cellSize.width, 0);
      ctx.lineTo(_x * cellSize.width, _y * cellSize.height);
      ctx.strokeStyle = '#0f0';
      ctx.setLineDash([cellSize.height]);
      ctx.stroke();

      ctx.globalAlpha = 1;
      ctx.lineWidth = 1 + 0.5 * Math.sin(now / 1000 * 10);
      ctx.strokeStyle = '#fff';
      ctx.lineJoin = 'round';
      ctx.setLineDash([2, 2]);
      ctx.lineDashOffset = now / 1000 * 10;
      ctx.strokeRect(_x * cellSize.width, _y * cellSize.height, cellSize.width, cellSize.height);
      ctx.lineDashOffset += 2;
      ctx.strokeStyle = '#000';
      ctx.strokeRect(_x * cellSize.width, _y * cellSize.height, cellSize.width, cellSize.height);
      ctx.restore();
    }

    if (drawData.scrollRegion !== null) {
      // draw two lines marking the scroll region bounds
      var _drawData$scrollRegio = _slicedToArray(drawData.scrollRegion, 2),
          start = _drawData$scrollRegio[0],
          end = _drawData$scrollRegio[1];

      ctx.save();
      ctx.globalAlpha = 1;
      ctx.strokeStyle = '#00f';
      ctx.lineWidth = 2;
      ctx.setLineDash([2, 2]);

      ctx.beginPath();
      ctx.moveTo(0, start * cellSize.height);
      ctx.lineTo(width * cellSize.width, start * cellSize.height);
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(0, (end + 1) * cellSize.height);
      ctx.lineTo(width * cellSize.width, (end + 1) * cellSize.height);
      ctx.stroke();

      ctx.restore();
    }
  };

  startDrawLoop = function startDrawLoop() {
    if (isDrawing) return;
    isDrawing = true;
    drawLoop();
  };

  var pad2 = function pad2(i) {
    return ('00' + i.toString()).substr(-2);
  };
  var formatColor = function formatColor(color) {
    return color < 256 ? color.toString() : '#' + pad2(color >> 16) + pad2(color >> 8 & 0xFF) + pad2(color & 0xFF);
  };

  var makeSpan = function makeSpan(text, styles) {
    var span = document.createElement('span');
    span.textContent = text;
    Object.assign(span.style, styles || {});
    return span;
  };
  var formatAttributes = function formatAttributes(target, attrs) {
    if (attrs & ATTR_FG) target.appendChild(makeSpan('HasFG'));
    if (attrs & ATTR_BG) target.appendChild(makeSpan('HasBG'));
    if (attrs & ATTR_BOLD) target.appendChild(makeSpan('Bold', { fontWeight: 'bold' }));
    if (attrs & ATTR_UNDERLINE) target.appendChild(makeSpan('Uline', { textDecoration: 'underline' }));
    if (attrs & ATTR_BLINK) target.appendChild(makeSpan('Blink'));
    if (attrs & ATTR_ITALIC) target.appendChild(makeSpan('Italic', { fontStyle: 'italic' }));
    if (attrs & ATTR_STRIKE) target.appendChild(makeSpan('Strike', { textDecoration: 'line-through' }));
    if (attrs & ATTR_OVERLINE) target.appendChild(makeSpan('Oline', { textDecoration: 'overline' }));
    if (attrs & ATTR_FAINT) target.appendChild(makeSpan('Faint', { opacity: 0.5 }));
    if (attrs & ATTR_FRAKTUR) target.appendChild(makeSpan('Fraktur'));
  };

  updateTooltip = function updateTooltip() {
    // TODO: make this not destroy and recreate the same nodes every time
    tooltip.classList.remove('hidden');
    tooltip.innerHTML = '';
    var cell = selectedCell[1] * screen.window.width + selectedCell[0];
    if (!screen.screen[cell]) return;

    var foreground = document.createElement('span');
    foreground.textContent = formatColor(screen.screenFG[cell]);
    var preview = document.createElement('span');
    preview.textContent = ' ●';
    preview.style.color = getColor(screen.screenFG[cell], screen.layout.renderer.palette);
    foreground.appendChild(preview);

    var background = document.createElement('span');
    background.textContent = formatColor(screen.screenBG[cell]);
    var bgPreview = document.createElement('span');
    bgPreview.textContent = ' ●';
    bgPreview.style.color = getColor(screen.screenBG[cell], screen.layout.renderer.palette);
    background.appendChild(bgPreview);

    var character = screen.screen[cell];
    var codePoint = character.codePointAt(0);
    var formattedCodePoint = codePoint.toString(16).length <= 4 ? ('0000' + codePoint.toString(16)).substr(-4) : codePoint.toString(16);

    var attributes = document.createElement('span');
    attributes.classList.add('attributes');
    formatAttributes(attributes, screen.screenAttrs[cell]);

    var data = {
      Cell: 'col ' + (selectedCell[0] + 1) + ', ln ' + (selectedCell[1] + 1) + ' (' + cell + ')',
      Foreground: foreground,
      Background: background,
      Character: 'U+' + formattedCodePoint,
      Attributes: attributes
    };

    var table = document.createElement('table');

    for (var name in data) {
      var row = document.createElement('tr');
      var label = document.createElement('td');
      label.appendChild(new window.Text(name));
      label.classList.add('label');

      var value = document.createElement('td');
      value.appendChild(typeof data[name] === 'string' ? new window.Text(data[name]) : data[name]);
      value.classList.add('value');

      row.appendChild(label);
      row.appendChild(value);
      table.appendChild(row);
    }

    tooltip.appendChild(table);

    var cellSize = screen.layout.getCellSize();
    // add 3 to the position because for some reason the corner is off
    var posX = (selectedCell[0] + 1) * cellSize.width + 3;
    var posY = (selectedCell[1] + 1) * cellSize.height + 3;
    tooltip.style.transform = 'translate(' + posX + 'px, ' + posY + 'px)';
  };

  var toolbarData = null;
  var toolbarNodes = {};

  // construct the toolbar if it wasn't already
  var initToolbar = function initToolbar() {
    if (toolbarData) return;

    var showUpdates = document.createElement('input');
    showUpdates.type = 'checkbox';
    showUpdates.addEventListener('change', function (e) {
      drawData.showUpdates = showUpdates.checked;
    });

    var fancyGraphics = document.createElement('input');
    fancyGraphics.type = 'checkbox';
    fancyGraphics.value = !!screen.layout.renderer.graphics;
    fancyGraphics.addEventListener('change', function (e) {
      screen.layout.renderer.graphics = +fancyGraphics.checked;
    });

    toolbarData = {
      cursor: {
        title: 'Cursor',
        Position: '',
        Style: '',
        Visible: true,
        Hanging: false
      },
      internal: {
        Flags: '',
        'Cursor Attributes': '',
        'Code Page': '',
        Heap: 0,
        Clients: 0
      },
      drawing: {
        title: 'Drawing',
        'Last Update': '',
        'Show Updates': showUpdates,
        'Fancy Graphics': fancyGraphics,
        'Redraw Screen': function RedrawScreen() {
          screen.layout.renderer.resetDrawn();
          screen.layout.renderer.draw('debug-redraw');
        }
      }
    };

    var _loop = function _loop(i) {
      var group = toolbarData[i];
      var table = document.createElement('table');
      table.classList.add('toolbar-group');

      toolbarNodes[i] = {};

      var _loop2 = function _loop2(key) {
        var item = document.createElement('tr');
        var name = document.createElement('td');
        name.classList.add('name');
        var value = document.createElement('td');
        value.classList.add('value');

        toolbarNodes[i][key] = { name: name, value: value };

        if (key === 'title') {
          name.textContent = group[key];
          name.classList.add('title');
        } else {
          name.textContent = key;
          if (group[key] instanceof Function) {
            name.textContent = '';
            var button = document.createElement('button');
            name.classList.add('has-button');
            name.appendChild(button);
            button.textContent = key;
            button.addEventListener('click', function (e) {
              return group[key](e);
            });
          } else if (group[key] instanceof window.Node) value.appendChild(group[key]);else value.textContent = group[key];
        }

        item.appendChild(name);
        item.appendChild(value);
        table.appendChild(item);
      };

      for (var key in group) {
        _loop2(key);
      }

      toolbar.appendChild(table);
    };

    for (var i in toolbarData) {
      _loop(i);
    }

    var heartbeat = toolbarNodes.heartbeat = document.createElement('div');
    heartbeat.classList.add('heartbeat');
    heartbeat.textContent = '❤';
    toolbar.appendChild(heartbeat);
  };

  connection.on('heartbeat', function () {
    if (screenAttached && toolbarNodes.heartbeat) {
      toolbarNodes.heartbeat.classList.remove('beat');
      window.requestAnimationFrame(function () {
        toolbarNodes.heartbeat.classList.add('beat');
      });
    }
  });

  updateToolbar = function updateToolbar() {
    initToolbar();

    Object.assign(toolbarData.cursor, {
      Position: 'col ' + (screen.cursor.x + 1) + ', ln ' + (screen.cursor.y + 1),
      Style: screen.cursor.style + (screen.cursor.blinking ? ', blink' : ''),
      Visible: screen.cursor.visible,
      Hanging: screen.cursor.hanging
    });

    var drawTime = Math.round((drawData.endTime - drawData.startTime) * 100) / 100;
    toolbarData.drawing['Last Update'] = drawData.reason + ' (' + drawTime + 'ms)';
    toolbarData.drawing['Fancy Graphics'].checked = !!screen.layout.renderer.graphics;

    for (var i in toolbarData) {
      var _group = toolbarData[i];
      var nodes = toolbarNodes[i];
      for (var key in _group) {
        if (key === 'title') continue;
        var _value = nodes[key].value;
        if (!(_group[key] instanceof window.Node) && !(_group[key] instanceof Function)) {
          _value.textContent = _group[key];
        }
      }
    }
  };

  screen.on('update', updateToolbar);
  screen.on('internal', function (data) {
    if (screenAttached && toolbarData) {
      Object.assign(toolbarData.internal, {
        Flags: data.flags.toString(2),
        'Cursor Attributes': data.cursorAttrs.toString(2),
        'Code Page': data.charsetGx + ' (' + data.charsetG0 + ', ' + data.charsetG1 + ')',
        Heap: data.freeHeap,
        Clients: data.clientCount
      });
      drawData.scrollRegion = [data.regionStart, data.regionEnd];
      updateToolbar();
    }
  });
};

/***/ }),
/* 26 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var _require = __webpack_require__(3),
    getColor = _require.getColor;

var _require2 = __webpack_require__(0),
    qs = _require2.qs;

var _require3 = __webpack_require__(7),
    rgb2hsl = _require3.rgb2hsl,
    hex2rgb = _require3.hex2rgb,
    rgb2hex = _require3.rgb2hex,
    hsl2rgb = _require3.hsl2rgb;

module.exports = function initButtons(input) {
  var container = qs('#action-buttons');

  // current color palette
  var palette = [];

  // button labels
  var labels = [];

  // button colors
  var colors = {};

  // button elements
  var buttons = [];

  // add a button element
  var pushButton = function pushButton() {
    var button = document.createElement('button');
    button.classList.add('action-button');
    button.setAttribute('data-n', buttons.length);
    buttons.push(button);
    container.appendChild(button);

    button.addEventListener('click', function (e) {
      // might as well use the attribute ¯\_(ツ)_/¯
      var index = +button.getAttribute('data-n');
      input.sendButton(index);

      e.target.blur(); // if it keeps focus, spacebar will push it
    });

    // this prevents button retaining focus after half-click/drag-away
    button.addEventListener('mouseleave', function (e) {
      e.target.blur();
    });

    return button;
  };

  // remove a button element
  var popButton = function popButton() {
    var button = buttons.pop();
    button.parentNode.removeChild(button);
  };

  // sync with DOM
  var update = function updateButtons() {
    if (labels.length > buttons.length) {
      for (var i = buttons.length; i < labels.length; i++) {
        pushButton();
      }
    } else if (buttons.length > labels.length) {
      for (var _i = buttons.length; _i > labels.length; _i--) {
        popButton();
      }
    }

    for (var _i2 = 0; _i2 < labels.length; _i2++) {
      var label = labels[_i2].trim();
      var button = buttons[_i2];
      var color = colors[_i2];

      button.textContent = label || '\xA0'; // label or nbsp

      if (!label) button.classList.add('inactive');else button.classList.remove('inactive');

      // 0 or undefined can be used to disable custom color
      if (Number.isFinite(color) && color !== 0) {
        var clr = getColor(color, palette);
        button.style.background = clr;

        // darken the color a bit for the 3D side
        var hsl = rgb2hsl.apply(undefined, _toConsumableArray(hex2rgb(clr)));
        var hex = rgb2hex.apply(undefined, _toConsumableArray(hsl2rgb(hsl[0], hsl[1], hsl[2] * 0.7)));
        button.style.boxShadow = '0 3px 0 ' + hex;
      } else {
        button.style.background = null;
        button.style.boxShadow = null;
      }
    }
  };

  return {
    update: update,
    get labels() {
      return labels;
    },
    set labels(value) {
      labels = value;
      update();
    },
    get colors() {
      return colors;
    },
    set colors(value) {
      colors = value;
      update();
    },
    get palette() {
      return palette;
    },
    set palette(value) {
      palette = value;
      update();
    }
  };
};

/***/ }),
/* 27 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var ColorTriangle = __webpack_require__(28);
var $ = __webpack_require__(1);
var themes = __webpack_require__(3);

var _require = __webpack_require__(0),
    qs = _require.qs;

function selectedTheme() {
  return +$('#theme').val();
}

exports.init = function () {
  $('#theme').on('change', showColor);
  $('#default_fg,#default_bg').on('input', showColor);

  var opts = {
    padding: 10,
    event: 'drag',
    uppercase: true,
    trianglePointerSize: 20,
    // wheelPointerSize: 12,
    size: 200,
    parseColor: function parseColor(color) {
      return themes.toHex(color, selectedTheme());
    }
  };

  ColorTriangle.initInput(qs('#default_fg'), opts);
  ColorTriangle.initInput(qs('#default_bg'), opts);
  for (var i = 1; i <= 5; i++) {
    ColorTriangle.initInput(qs('#bc' + i), opts);
  }

  $('.colorprev.bg span').on('click', function () {
    var bg = this.dataset.bg;
    if (typeof bg != 'undefined') $('#default_bg').val(bg);
    showColor();
  });

  $('.colorprev.fg span').on('click', function () {
    var fg = this.dataset.fg;
    if (typeof fg != 'undefined') $('#default_fg').val(fg);
    showColor();
  });

  var $presets = $('#fgbg_presets');
  for (var _i = 0; _i < themes.fgbgThemes.length; _i++) {
    var thm = themes.fgbgThemes[_i];
    var fg = thm[0];
    var bg = thm[1];
    var lbl = thm[2];
    var tit = thm[3];
    $presets.htmlAppend('<span class="preset" ' + 'data-xfg="' + fg + '" data-xbg="' + bg + '" ' + 'style="color:' + fg + ';background:' + bg + '" title="' + tit + '">&nbsp;' + lbl + '&nbsp;</span>');

    if ((_i + 1) % 5 === 0) $presets.htmlAppend('<br>');
  }

  $('.preset').on('click', function () {
    $('#default_fg').val(this.dataset.xfg);
    $('#default_bg').val(this.dataset.xbg);
    showColor();
  });

  showColor();
};

function showColor() {
  var ex = qs('.color-example');
  var fg = $('#default_fg').val();
  var bg = $('#default_bg').val();

  if (/^\d+$/.test(fg)) {
    fg = +fg;
  } else if (!/^#[\da-f]{6}$/i.test(fg)) {
    fg = 'black';
  }

  if (/^\d+$/.test(bg)) {
    bg = +bg;
  } else if (!/^#[\da-f]{6}$/i.test(bg)) {
    bg = 'black';
  }

  var themeN = selectedTheme();
  ex.dataset.fg = fg;
  ex.dataset.bg = bg;

  themes.themePreview(themeN);

  $('.colorprev.fg span').css('background', themes.toHex(bg, themeN));
}

exports.nextTheme = function () {
  var sel = qs('#theme');
  var i = sel.selectedIndex;
  sel.options[++i % sel.options.length].selected = true;
  showColor();
};

exports.prevTheme = function () {
  var sel = qs('#theme');
  var i = sel.selectedIndex;
  sel.options[(sel.options.length + --i) % sel.options.length].selected = true;
  showColor();
};

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/*
 * Copyright (c) 2010 Tim Baumann
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */

// NOTE: Converted to ES6 by MightyPork (2017)
// Modified for ESPTerm

var EventEmitter = __webpack_require__(2);

var _require = __webpack_require__(7),
    rgb2hex = _require.rgb2hex,
    hex2rgb = _require.hex2rgb,
    hsl2rgb = _require.hsl2rgb,
    rgb2hsl = _require.rgb2hsl;

var win = window;
var doc = document;
var M = Math;
var TAU = 2 * M.PI;

function times(i, fn) {
  for (var j = 0; j < i; j++) {
    fn(j);
  }
}

function each(obj, fn) {
  if (obj.length) {
    times(obj.length, function (i) {
      fn(obj[i], i);
    });
  } else {
    for (var key in obj) {
      if (obj.hasOwnProperty(key)) {
        fn(obj[key], key);
      }
    }
  }
}

module.exports = function (_EventEmitter) {
  _inherits(ColorTriangle, _EventEmitter);

  /****************
   * ColorTriangle *
   ****************/

  // Constructor function:
  function ColorTriangle(color, options) {
    _classCallCheck(this, ColorTriangle);

    var _this = _possibleConstructorReturn(this, (ColorTriangle.__proto__ || Object.getPrototypeOf(ColorTriangle)).call(this));

    _this.options = {
      size: 150,
      padding: 8,
      triangleSize: 0.8,
      wheelPointerColor1: '#444',
      wheelPointerColor2: '#eee',
      trianglePointerSize: 16,
      // wheelPointerSize: 16,
      trianglePointerColor1: '#eee',
      trianglePointerColor2: '#444',
      background: 'transparent'
    };

    _this.pixelRatio = window.devicePixelRatio;

    _this.setOptions(options);
    _this.calculateProperties();

    _this.createContainer();
    _this.createTriangle();
    _this.createWheel();
    _this.createWheelPointer();
    _this.createTrianglePointer();
    _this.attachEvents();

    color = color || '#f00';
    if (typeof color == 'string') {
      _this.setHEX(color);
    }
    return _this;
  }

  _createClass(ColorTriangle, [{
    key: 'calculateProperties',
    value: function calculateProperties() {
      var opts = this.options;

      this.padding = opts.padding;
      this.innerSize = opts.size - opts.padding * 2;
      this.triangleSize = opts.triangleSize * this.innerSize;
      this.wheelThickness = (this.innerSize - this.triangleSize) / 2;
      this.wheelPointerSize = opts.wheelPointerSize || this.wheelThickness;

      this.wheelRadius = this.innerSize / 2;
      this.triangleRadius = this.triangleSize / 2;
      this.triangleSideLength = M.sqrt(3) * this.triangleRadius;
    }
  }, {
    key: 'calculatePositions',
    value: function calculatePositions() {
      var r = this.triangleRadius;
      var hue = this.hue;
      var third = TAU / 3;
      var s = this.saturation;
      var l = this.lightness;

      // Colored point
      var hx = this.hx = M.cos(hue) * r;
      var hy = this.hy = -M.sin(hue) * r;
      // Black point
      var sx = this.sx = M.cos(hue - third) * r;
      var sy = this.sy = -M.sin(hue - third) * r;
      // White point
      var vx = this.vx = M.cos(hue + third) * r;
      var vy = this.vy = -M.sin(hue + third) * r;
      // Current point
      var mx = (sx + vx) / 2;
      var my = (sy + vy) / 2;
      var a = (1 - 2 * M.abs(l - 0.5)) * s;
      this.x = sx + (vx - sx) * l + (hx - mx) * a;
      this.y = sy + (vy - sy) * l + (hy - my) * a;
    }
  }, {
    key: 'createContainer',
    value: function createContainer() {
      var c = this.container = doc.createElement('div');
      c.className = 'color-triangle';

      c.style.display = 'block';
      c.style.padding = this.padding + 'px';
      c.style.position = 'relative';
      c.style.boxShadow = '0 1px 10px black';
      c.style.borderRadius = '5px';
      c.style.width = c.style.height = this.innerSize + 2 * this.padding + 'px';
      c.style.background = this.options.background;
    }
  }, {
    key: 'createWheel',
    value: function createWheel() {
      var c = this.wheel = doc.createElement('canvas');
      c.width = c.height = this.innerSize * this.pixelRatio;
      c.style.width = c.style.height = this.innerSize + 'px';
      c.style.position = 'absolute';
      c.style.margin = c.style.padding = '0';
      c.style.left = c.style.top = this.padding + 'px';

      this.drawWheel(c.getContext('2d'));
      this.container.appendChild(c);
    }
  }, {
    key: 'drawWheel',
    value: function drawWheel(ctx) {
      var s = void 0,
          i = void 0;

      ctx.save();
      ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
      ctx.translate(this.wheelRadius, this.wheelRadius);
      s = this.wheelRadius - this.triangleRadius;
      // Draw a circle for every color
      for (i = 0; i < 360; i++) {
        ctx.rotate(TAU / -360); // rotate one degree
        ctx.beginPath();
        ctx.fillStyle = 'hsl(' + i + ', 100%, 50%)';
        ctx.arc(this.wheelRadius - s / 2, 0, s / 2, 0, TAU, true);
        ctx.fill();
      }
      ctx.restore();
    }
  }, {
    key: 'createTriangle',
    value: function createTriangle() {
      var c = this.triangle = doc.createElement('canvas');

      c.width = c.height = this.innerSize * this.pixelRatio;
      c.style.width = c.style.height = this.innerSize + 'px';
      c.style.position = 'absolute';
      c.style.margin = c.style.padding = '0';
      c.style.left = c.style.top = this.padding + 'px';

      this.triangleCtx = c.getContext('2d');

      this.container.appendChild(c);
    }
  }, {
    key: 'drawTriangle',
    value: function drawTriangle() {
      var hx = this.hx;
      var hy = this.hy;
      var sx = this.sx;
      var sy = this.sy;
      var vx = this.vx;
      var vy = this.vy;
      var size = this.innerSize;

      var ctx = this.triangleCtx;

      // clear
      ctx.clearRect(0, 0, size * this.pixelRatio, size * this.pixelRatio);

      ctx.save();
      ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
      ctx.translate(this.wheelRadius, this.wheelRadius);

      // make a triangle
      ctx.beginPath();
      ctx.moveTo(hx, hy);
      ctx.lineTo(sx, sy);
      ctx.lineTo(vx, vy);
      ctx.closePath();
      ctx.clip();

      ctx.fillStyle = '#000';
      ctx.fillRect(-this.wheelRadius, -this.wheelRadius, size, size);
      // => black triangle

      // create gradient from hsl(hue, 1, 1) to transparent
      var grad0 = ctx.createLinearGradient(hx, hy, (sx + vx) / 2, (sy + vy) / 2);
      var hsla = 'hsla(' + M.round(this.hue * (360 / TAU)) + ', 100%, 50%, ';
      grad0.addColorStop(0, hsla + '1)');
      grad0.addColorStop(1, hsla + '0)');
      ctx.fillStyle = grad0;
      ctx.fillRect(-this.wheelRadius, -this.wheelRadius, size, size);
      // => gradient: one side of the triangle is black, the opponent angle is $color

      // create color gradient from white to transparent
      var grad1 = ctx.createLinearGradient(vx, vy, (hx + sx) / 2, (hy + sy) / 2);
      grad1.addColorStop(0, '#fff');
      grad1.addColorStop(1, 'rgba(255, 255, 255, 0)');
      ctx.globalCompositeOperation = 'lighter';
      ctx.fillStyle = grad1;
      ctx.fillRect(-this.wheelRadius, -this.wheelRadius, size, size);
      // => white angle

      ctx.restore();
    }

    // The two pointers

  }, {
    key: 'createWheelPointer',
    value: function createWheelPointer() {
      var c = this.wheelPointer = doc.createElement('canvas');
      var size = this.wheelPointerSize;
      c.width = c.height = size * this.pixelRatio;
      c.style.width = c.style.height = size + 'px';
      c.style.position = 'absolute';
      c.style.margin = c.style.padding = '0';
      this.drawPointer(c.getContext('2d'), size / 2, this.options.wheelPointerColor1, this.options.wheelPointerColor2);
      this.container.appendChild(c);
    }
  }, {
    key: 'moveWheelPointer',
    value: function moveWheelPointer() {
      var r = this.wheelPointerSize / 2;
      var s = this.wheelPointer.style;
      s.top = this.padding + this.wheelRadius - M.sin(this.hue) * (this.triangleRadius + this.wheelThickness / 2) - r + 'px';
      s.left = this.padding + this.wheelRadius + M.cos(this.hue) * (this.triangleRadius + this.wheelThickness / 2) - r + 'px';
    }
  }, {
    key: 'createTrianglePointer',
    value: function createTrianglePointer() {
      // create pointer in the triangle
      var c = this.trianglePointer = doc.createElement('canvas');
      var size = this.options.trianglePointerSize;

      c.width = c.height = size * this.pixelRatio;
      c.style.width = c.style.height = size + 'px';
      c.style.position = 'absolute';
      c.style.margin = c.style.padding = '0';
      this.drawPointer(c.getContext('2d'), size / 2, this.options.trianglePointerColor1, this.options.trianglePointerColor2);
      this.container.appendChild(c);
    }
  }, {
    key: 'moveTrianglePointer',
    value: function moveTrianglePointer(x, y) {
      var s = this.trianglePointer.style;
      var r = this.options.trianglePointerSize / 2;
      s.top = this.y + this.wheelRadius + this.padding - r + 'px';
      s.left = this.x + this.wheelRadius + this.padding - r + 'px';
    }
  }, {
    key: 'drawPointer',
    value: function drawPointer(ctx, r, color1, color2) {
      ctx.setTransform(this.pixelRatio, 0, 0, this.pixelRatio, 0, 0);
      ctx.fillStyle = color2;
      ctx.beginPath();
      ctx.arc(r, r, r, 0, TAU, true);
      ctx.fill(); // => black circle
      ctx.fillStyle = color1;
      ctx.beginPath();
      ctx.arc(r, r, r - 2, 0, TAU, true);
      ctx.fill(); // => white circle with 1px black border
      ctx.fillStyle = color2;
      ctx.beginPath();
      ctx.arc(r, r, r / 4 + 2, 0, TAU, true);
      ctx.fill(); // => black circle with big white border and a small black border
      ctx.globalCompositeOperation = 'destination-out';
      ctx.beginPath();
      ctx.arc(r, r, r / 4, 0, TAU, true);
      ctx.fill(); // => transparent center
    }

    // The Element and the DOM

  }, {
    key: 'inject',
    value: function inject(parent) {
      parent.appendChild(this.container);
    }
  }, {
    key: 'getRelativeCoordinates',
    value: function getRelativeCoordinates(evt) {
      var elem = this.triangle;
      var rect = elem.getBoundingClientRect();

      return {
        x: evt.clientX - rect.x,
        y: evt.clientY - rect.y
      };
    }
  }, {
    key: 'dispose',
    value: function dispose() {
      var parent = this.container.parentNode;
      if (parent) {
        parent.removeChild(this.container);
      }
    }
  }, {
    key: 'getElement',
    value: function getElement() {
      return this.container;
    }

    // Color accessors

  }, {
    key: 'getCSS',
    value: function getCSS() {
      var h = Math.round(this.hue * (360 / TAU));
      var s = Math.round(this.saturation * 100);
      var l = Math.round(this.lightness * 100);

      return 'hsl(' + h + ', ' + s + '%, ' + l + '%)';
    }
  }, {
    key: 'getHEX',
    value: function getHEX() {
      return rgb2hex.apply(undefined, _toConsumableArray(this.getRGB()));
    }
  }, {
    key: 'setHEX',
    value: function setHEX(hex) {
      this.setRGB.apply(this, _toConsumableArray(hex2rgb(hex)));
    }
  }, {
    key: 'getRGB',
    value: function getRGB() {
      return hsl2rgb.apply(undefined, _toConsumableArray(this.getHSL()));
    }
  }, {
    key: 'setRGB',
    value: function setRGB(r, g, b) {
      this.setHSL.apply(this, _toConsumableArray(rgb2hsl(r, g, b)));
    }
  }, {
    key: 'getHSL',
    value: function getHSL() {
      return [this.hue, this.saturation, this.lightness];
    }
  }, {
    key: 'setHSL',
    value: function setHSL(h, s, l) {
      this.hue = h;
      this.saturation = s;
      this.lightness = l;

      this.initColor();
    }
  }, {
    key: 'initColor',
    value: function initColor() {
      this.calculatePositions();
      this.moveWheelPointer();
      this.drawTriangle();
      this.moveTrianglePointer();
    }

    // Mouse event handling

  }, {
    key: 'attachEvents',
    value: function attachEvents() {
      var _this2 = this;

      this.down = null;

      var mousedown = function mousedown(evt) {
        evt.stopPropagation();
        evt.preventDefault();

        doc.body.addEventListener('mousemove', mousemove, false);
        doc.body.addEventListener('mouseup', mouseup, false);

        var xy = _this2.getRelativeCoordinates(evt);
        _this2.map(xy.x, xy.y);
      };

      var mousemove = function mousemove(evt) {
        var xy = _this2.getRelativeCoordinates(evt);
        _this2.move(xy.x, xy.y);
      };

      var mouseup = function mouseup(evt) {
        if (_this2.down) {
          _this2.down = null;
          _this2.emit('dragend');
        }
        doc.body.removeEventListener('mousemove', mousemove, false);
        doc.body.removeEventListener('mouseup', mouseup, false);
      };

      this.container.addEventListener('mousedown', mousedown, false);
      this.container.addEventListener('mousemove', mousemove, false);
    }
  }, {
    key: 'map',
    value: function map(x, y) {
      var x0 = x;
      var y0 = y;
      x -= this.wheelRadius;
      y -= this.wheelRadius;

      var r = M.sqrt(x * x + y * y); // Pythagoras
      if (r > this.triangleRadius && r < this.wheelRadius) {
        // Wheel
        this.down = 'wheel';
        this.emit('dragstart');
        this.move(x0, y0);
      } else if (r < this.triangleRadius) {
        // Inner circle
        this.down = 'triangle';
        this.emit('dragstart');
        this.move(x0, y0);
      }
    }
  }, {
    key: 'move',
    value: function move(x, y) {
      if (!this.down) {
        return;
      }

      x -= this.wheelRadius;
      y -= this.wheelRadius;

      var rad = M.atan2(-y, x);
      if (rad < 0) {
        rad += TAU;
      }

      if (this.down === 'wheel') {
        this.hue = rad;
        this.initColor();
        this.emit('drag');
      } else if (this.down === 'triangle') {
        // get radius and max radius
        var rad0 = (rad + TAU - this.hue) % TAU;
        var rad1 = rad0 % (TAU / 3) - TAU / 6;
        var a = 0.5 * this.triangleRadius;
        var b = M.tan(rad1) * a;
        var r = M.sqrt(x * x + y * y); // Pythagoras
        var maxR = M.sqrt(a * a + b * b); // Pythagoras

        if (r > maxR) {
          var dx = M.tan(rad1) * r;
          var rad2 = M.atan(dx / maxR);
          if (rad2 > TAU / 6) {
            rad2 = TAU / 6;
          } else if (rad2 < -TAU / 6) {
            rad2 = -TAU / 6;
          }
          rad += rad2 - rad1;

          rad0 = (rad + TAU - this.hue) % TAU;
          rad1 = rad0 % (TAU / 3) - TAU / 6;
          b = M.tan(rad1) * a;
          r = maxR = M.sqrt(a * a + b * b); // Pythagoras
        }

        x = M.round(M.cos(rad) * r);
        y = M.round(-M.sin(rad) * r);

        var l = this.lightness = M.sin(rad0) * r / this.triangleSideLength + 0.5;

        var widthShare = 1 - M.abs(l - 0.5) * 2;
        var s = this.saturation = (M.cos(rad0) * r + this.triangleRadius / 2) / (1.5 * this.triangleRadius) / widthShare;
        s = M.max(0, s); // cannot be lower than 0
        s = M.min(1, s); // cannot be greater than 1

        this.lightness = l;
        this.saturation = s;

        this.x = x;
        this.y = y;
        this.moveTrianglePointer();

        this.emit('drag');
      }
    }

    /***************
     * Init helpers *
     ***************/

  }, {
    key: 'setOptions',


    /*******************
     * Helper functions *
     *******************/

    value: function setOptions(opts) {
      opts = opts || {};
      var dflt = this.options;
      var options = this.options = {};

      each(dflt, function (val, key) {
        options[key] = opts.hasOwnProperty(key) ? opts[key] : val;
      });
    }
  }], [{
    key: 'initInput',
    value: function initInput(input, options) {
      options = options || {};

      var ct = void 0;
      var openColorTriangle = function openColorTriangle() {
        var hex = input.value;
        if (options.parseColor) hex = options.parseColor(hex);
        if (!ct) {
          options.size = options.size || input.offsetWidth;
          options.background = win.getComputedStyle(input, null).backgroundColor;
          options.margin = options.margin || 10;
          options.event = options.event || 'dragend';

          ct = new ColorTriangle(hex, options);
          ct.on(options.event, function () {
            var hex = ct.getHEX();
            input.value = options.uppercase ? hex.toUpperCase() : hex;
            fireChangeEvent();
          });
        } else {
          ct.setHEX(hex);
        }

        var top = input.offsetTop;
        if (win.innerHeight - input.getBoundingClientRect().top > input.offsetHeight + options.margin + options.size) {
          top += input.offsetHeight + options.margin; // below
        } else {
          top -= options.margin + options.size; // above
        }

        var el = ct.getElement();
        el.style.position = 'absolute';
        el.style.left = input.offsetLeft + 'px';
        el.style.top = top + 'px';
        el.style.zIndex = '1338'; // above everything

        ct.inject(input.parentNode);
      };

      var closeColorTriangle = function closeColorTriangle() {
        if (ct) {
          ct.dispose();
        }
      };

      var fireChangeEvent = function fireChangeEvent() {
        var evt = doc.createEvent('HTMLEvents');
        evt.initEvent('input', true, false); // bubbles = true, cancable = false
        input.dispatchEvent(evt); // fire event
      };

      input.addEventListener('focus', openColorTriangle, false);
      input.addEventListener('blur', closeColorTriangle, false);
      input.addEventListener('keyup', function () {
        var val = input.value;
        if (val.match(/^#((?:[0-9A-Fa-f]{3})|(?:[0-9A-Fa-f]{6}))$/)) {
          openColorTriangle();
          fireChangeEvent();
        } else {
          closeColorTriangle();
        }
      }, false);
    }
  }]);

  return ColorTriangle;
}(EventEmitter);

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// app.9aae724-en.js